(function () {
    'use strict';

    angular.module('app.common')
        .factory('wmsLayerService', ['$http', '$q', '$translate', wmsLayerService]);

    /**
     * WMS Layer Service
     * Manages WMS (Web Map Service) layers for regional planning data
     * Uses static layer definitions (CORS prevents GetCapabilities from browser)
     *
     * Currently supported regions:
     * - Aydın-Muğla-Denizli (AMD)
     * - Antalya-Burdur-Isparta (ABI)
     * - Balıkesir-Çanakkale (CB)
     * - Mersin-Adana (MA)
     *
     * Future regions can be added by extending the REGIONS configuration
     */
    function wmsLayerService($http, $q, $translate) {

        // ============================================
        // REGION CONFIGURATIONS
        // ============================================
        var REGIONS = {
            AMD: {
                id: 'amd',
                name: 'Aydın-Muğla-Denizli',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_amd_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [36.185353, 26.986913],
                    northEast: [38.504813, 30.166237]
                },
                // Province codes for this region
                provinces: [9, 48, 20] // Aydın: 9, Muğla: 48, Denizli: 20
            },
            ABI: {
                id: 'abi',
                name: 'Antalya-Burdur-Isparta',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_abi_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [36.032062, 29.081046],
                    northEast: [38.580968, 32.685459]
                },
                // Province codes for this region
                provinces: [7, 15, 32] // Antalya: 7, Burdur: 15, Isparta: 32
            },
            CB: {
                id: 'cb',
                name: 'Balıkesir-Çanakkale',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_cb_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [38.818504, 25.155116],
                    northEast: [42.064769, 29.863585]
                },
                // Province codes for this region
                provinces: [10, 17] // Balıkesir: 10, Çanakkale: 17
            },
            MA: {
                id: 'ma',
                name: 'Mersin-Adana',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_ma_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [35.835946, 32.132190],
                    northEast: [38.501061, 37.009053]
                },
                // Province codes for this region
                provinces: [33, 1] // Mersin: 33, Adana: 1
            },
            ASD: {
                id: 'asd',
                name: 'Adıyaman-Şanlıurfa-Diyarbakır',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_asd_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [35.788222, 34.636827],
                    northEast: [39.274028, 42.256839]
                },
                // Province codes for this region
                provinces: [2, 63, 21] // Adıyaman: 2, Şanlıurfa: 63, Diyarbakır: 21
            },
            AKIA: {
                id: 'akia',
                name: 'Ağrı-Kars-Iğdır-Ardahan',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_akia_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [38.396964, 38.828511],
                    northEast: [41.759783, 45.409189]
                },
                // Province codes for this region
                provinces: [4, 36, 76, 75] // Ağrı: 4, Kars: 36, Iğdır: 76, Ardahan: 75
            },
            KNNA: {
                id: 'knna',
                name: 'Aksaray-Kırşehir-Nevşehir-Niğde',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_knna_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [36.895700, 31.734065],
                    northEast: [40.236026, 38.873964]
                },
                // Province codes for this region
                provinces: [68, 40, 50, 51] // Aksaray: 68, Kırşehir: 40, Nevşehir: 50, Niğde: 51
            },
            AMASYA: {
                id: 'amasya',
                name: 'Amasya',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_amasya_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [40.148669, 34.663625],
                    northEast: [41.264778, 36.694881]
                },
                // Province codes for this region
                provinces: [5] // Amasya: 5
            },
            OTRGGA: {
                id: 'otrgga',
                name: 'Artvin-Giresun-Gümüşhane-Ordu-Rize-Trabzon',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_otrgga_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [38.611696, 36.671230],
                    northEast: [42.771077, 42.731645]
                },
                // Province codes for this region
                provinces: [8, 28, 29, 52, 53, 61] // Artvin: 8, Giresun: 28, Gümüşhane: 29, Ordu: 52, Rize: 53, Trabzon: 61
            },
            ZBK: {
                id: 'zbk',
                name: 'Karabük-Zonguldak',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_zbk_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [40.556478, 30.777348],
                    northEast: [42.183757, 34.385645]
                },
                // Province codes for this region
                provinces: [78, 67] // Karabük: 78, Zonguldak: 67
            },
            BARTIN25: {
                id: 'bartin25',
                name: 'Bartın 1/25000',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_bartin25_wms',
                // Bounds from WMS GetCapabilities (root EX_GeographicBoundingBox)
                bounds: {
                    southWest: [41.345136, 31.877029],
                    northEast: [41.974614, 32.922861]
                },
                provinces: [74] // Bartın: 74
            },
            MBSSH: {
                id: 'mbssh',
                name: 'Batman-Hakkari-Mardin-Siirt-Şırnak',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_mbssh_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [35.767938, 39.367390],
                    northEast: [39.046377, 45.377181]
                },
                // Province codes for this region
                provinces: [72, 30, 47, 56, 73] // Batman: 72, Hakkari: 30, Mardin: 47, Siirt: 56, Şırnak: 73
            },
            EEB: {
                id: 'eeb',
                name: 'Bayburt-Erzurum-Erzincan',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_eeb_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [38.299899, 38.228300],
                    northEast: [41.643260, 43.062094]
                },
                // Province codes for this region
                provinces: [69, 25, 24] // Bayburt: 69, Erzurum: 25, Erzincan: 24
            },
            BILECIK: {
                id: 'bilecik',
                name: 'Bilecik',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_bilecik_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [39.632060, 29.697089],
                    northEast: [40.521301, 30.678411]
                },
                // Province codes for this region
                provinces: [11] // Bilecik: 11
            },
            MBV: {
                id: 'mbv',
                name: 'Bitlis-Muş-Van',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_mbv_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [37.490718, 40.834169],
                    northEast: [39.703200, 44.708057]
                },
                // Province codes for this region
                provinces: [13, 49, 65] // Bitlis: 13, Muş: 49, Van: 65
            },
            BOLU: {
                id: 'bolu',
                name: 'Bolu',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_bolu_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [40.144285, 30.550151],
                    northEast: [41.055657, 32.568856]
                },
                // Province codes for this region
                provinces: [14] // Bolu: 14
            },
            SCT: {
                id: 'sct',
                name: 'Çorum-Samsun-Tokat',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_sct_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [39.603691, 33.528118],
                    northEast: [42.028897, 38.059482]
                },
                // Province codes for this region
                provinces: [19, 55, 60] // Çorum: 19, Samsun: 55, Tokat: 60
            },
            IM: {
                id: 'im',
                name: 'İzmir-Manisa',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_im_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [37.766125, 26.189740],
                    northEast: [39.451399, 29.222243]
                },
                // Province codes for this region
                provinces: [35, 45] // İzmir: 35, Manisa: 45
            },
            KK: {
                id: 'kk',
                name: 'Karaman-Konya',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_kk_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [36.405816, 29.648521],
                    northEast: [39.673224, 35.695094]
                },
                // Province codes for this region
                provinces: [70, 42] // Karaman: 70, Konya: 42
            },
            YSK: {
                id: 'ysk',
                name: 'Kayseri-Sivas-Yozgat',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_ysk_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [37.421120, 33.658877],
                    northEast: [40.722269, 39.826552]
                },
                // Province codes for this region
                provinces: [38, 58, 66] // Kayseri: 38, Sivas: 58, Yozgat: 66
            },
            KILIS: {
                id: 'kilis',
                name: 'Kilis',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_kilis_wms',
                // Bounds from WMS GetCapabilities
                bounds: {
                    southWest: [36.512164, 36.647205],
                    northEast: [37.151547, 37.624095]
                },
                // Province codes for this region
                provinces: [79] // Kilis: 79
            },
            KIRIKKALE: {
                id: 'kirikkale',
                name: 'Kırıkkale',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_kirikkale_wms',
                // Bounds from WMS GetCapabilities (root EX_GeographicBoundingBox)
                bounds: {
                    southWest: [39.354056, 32.854130],
                    northEast: [40.386116, 34.649764]
                },
                provinces: [71] // Kırıkkale: 71
            },
            OSMANIYE: {
                id: 'osmaniye',
                name: 'Osmaniye',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_osmaniye_wms',
                // Bounds from WMS GetCapabilities (root EX_GeographicBoundingBox)
                bounds: {
                    southWest: [37.069123, 35.473717],
                    northEast: [37.775687, 36.883069]
                },
                provinces: [80] // Osmaniye: 80
            },
            SINOP: {
                id: 'sinop',
                name: 'Sinop',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_sinop_wms',
                // Bounds from WMS GetCapabilities (root EX_GeographicBoundingBox)
                bounds: {
                    southWest: [41.602510, 34.743343],
                    northEast: [42.101067, 35.262061]
                },
                provinces: [57] // Sinop: 57
            },
            USAK: {
                id: 'usak',
                name: 'Uşak',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_usak_wms',
                // Bounds from WMS GetCapabilities (root EX_GeographicBoundingBox)
                bounds: {
                    southWest: [38.033540, 28.354500],
                    northEast: [39.111765, 30.318375]
                },
                provinces: [64] // Uşak: 64
            },
            YALOVA: {
                id: 'yalova',
                name: 'Yalova',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_yalova_wms',
                // Bounds from WMS GetCapabilities (layer-level EX_GeographicBoundingBox)
                bounds: {
                    southWest: [40.442486, 28.772716],
                    northEast: [40.762751, 29.564233]
                },
                provinces: [77] // Yalova: 77
            },
            SKC: {
                id: 'skc',
                name: 'Sinop-Kastamonu-Çankırı',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_skc_wms',
                // Bounds from WMS GetCapabilities (root EX_GeographicBoundingBox)
                bounds: {
                    southWest: [40.152106, 31.862951],
                    northEast: [42.328462, 35.888070]
                },
                provinces: [37, 18] // Kastamonu: 37, Çankırı: 18
            },
            ERGENE: {
                id: 'ergene',
                name: 'Ergene Havzası',
                wmsUrl: 'https://tucbs-public-api.csb.gov.tr/csb_cdp_ergene_wms',
                // Bounds from WMS GetCapabilities (root EX_GeographicBoundingBox)
                bounds: {
                    southWest: [39.845453, 25.412765],
                    northEast: [42.261958, 30.364822]
                },
                provinces: [22, 39, 59] // Edirne: 22, Kırklareli: 39, Tekirdağ: 59
            }
            // Future regions can be added here:
        };

        // ============================================
        // STATIC LAYER DEFINITIONS (from GetCapabilities)
        // ============================================
        // Layer definitions are static because CORS prevents browser from fetching GetCapabilities
        // These were extracted from: https://tucbs-public-api.csb.gov.tr/csb_cdp_amd_wms?service=WMS&request=GetCapabilities
        var LAYER_DEFINITIONS = {
            amd: [
                // PL_ALAN Group (Area layers)
                { layer: 1, name: 'TARIM_FON', group: 'PL_ALAN' },
                { layer: 2, name: 'AydinDenizliCayirMera', group: 'PL_ALAN' },
                { layer: 3, name: 'MakiFunda', group: 'PL_ALAN' },
                { layer: 4, name: 'mugla_orman_25000_butun', group: 'PL_ALAN' },
                { layer: 5, name: 'Orman', group: 'PL_ALAN' },
                { layer: 6, name: 'KayalikTaslik', group: 'PL_ALAN' },
                { layer: 7, name: 'SazlikBataklik', group: 'PL_ALAN' },
                { layer: 8, name: 'Kumul', group: 'PL_ALAN' },
                { layer: 9, name: 'MuglaMera', group: 'PL_ALAN' },
                { layer: 10, name: 'ARAZI KULLANIMI_EKOTURİZM', group: 'PL_ALAN' },
                { layer: 12, name: 'AĞAÇLANDIRILACAK ALAN', group: 'PL_ALAN' },
                { layer: 13, name: 'MESKUN(AGAÇ ALANI)', group: 'PL_ALAN' },
                { layer: 14, name: 'KENTSEL YERLEŞİK ALAN', group: 'PL_ALAN' },
                { layer: 15, name: 'SANAYI_DEPOLAMA_YENI', group: 'PL_ALAN' },
                { layer: 16, name: 'ARAZI KULLANIMI', group: 'PL_ALAN' },
                { layer: 17, name: 'GELİŞME ALANI', group: 'PL_ALAN' },
                { layer: 18, name: 'Kentsel_servis', group: 'PL_ALAN' },
                { layer: 19, name: 'KÖY_YERLEŞİM_ALANLARI', group: 'PL_ALAN' },
                { layer: 20, name: 'TGB_ALAN', group: 'PL_ALAN' },
                { layer: 21, name: 'SİT ALANLARI_FON', group: 'PL_ALAN' },
                { layer: 22, name: 'BARAJ', group: 'PL_ALAN' },
                { layer: 23, name: 'GÖL', group: 'PL_ALAN' },
                { layer: 24, name: 'GÖLET', group: 'PL_ALAN' },
                { layer: 25, name: 'SİT ALANLARI', group: 'PL_ALAN' },
                { layer: 26, name: 'ÖNEMLİ DOĞA ALANLARI', group: 'PL_ALAN' },
                { layer: 27, name: 'Sulama_Alanlari', group: 'PL_ALAN' },
                // PL_CİZGİ Group (Line layers)
                { layer: 29, name: 'AkarsuCizgi', group: 'PL_CİZGİ' },
                { layer: 30, name: 'KIYI', group: 'PL_CİZGİ' },
                { layer: 31, name: 'mavi_tur_guzergah', group: 'PL_CİZGİ' },
                { layer: 32, name: 'FERİBOT HATLARI', group: 'PL_CİZGİ' },
                { layer: 33, name: 'KoyYollari_BarajAlti', group: 'PL_CİZGİ' },
                { layer: 34, name: 'KoyYollari', group: 'PL_CİZGİ' },
                { layer: 35, name: 'KARAYOLLARI', group: 'PL_CİZGİ' },
                { layer: 36, name: 'TeleferikHatti', group: 'PL_CİZGİ' },
                { layer: 37, name: 'DEMİRYOLLARI_1', group: 'PL_CİZGİ' },
                { layer: 38, name: 'Sit_Sinirlari', group: 'PL_CİZGİ' },
                { layer: 39, name: 'KAPLUMBAĞA YUVALAMA KUMSALLARI', group: 'PL_CİZGİ' },
                { layer: 40, name: 'DOĞA KORUMA ALANLARI', group: 'PL_CİZGİ' },
                { layer: 41, name: 'Ozel_Statulu_Alanlar', group: 'PL_CİZGİ' },
                { layer: 42, name: 'BarajKorumaKusak_Erase', group: 'PL_CİZGİ' },
                { layer: 43, name: 'TigemSinir', group: 'PL_CİZGİ' },
                { layer: 44, name: 'AltBolge', group: 'PL_CİZGİ' },
                { layer: 45, name: 'OZEL PLANLAMA ALANI', group: 'PL_CİZGİ' },
                { layer: 46, name: 'BELEDİYE SINIRI', group: 'PL_CİZGİ' },
                { layer: 47, name: 'TURIZM MERKEZLERİ', group: 'PL_CİZGİ' },
                { layer: 48, name: 'TurizmBolgesi_Cizgi', group: 'PL_CİZGİ' },
                { layer: 49, name: 'DOĞALGAZ HATTI', group: 'PL_CİZGİ' },
                { layer: 50, name: 'ELEKTRİK HATTI', group: 'PL_CİZGİ' },
                { layer: 51, name: 'SINIRLAR', group: 'PL_CİZGİ' },
                { layer: 52, name: 'PLANLAMA BÖLGESİ SINIRI', group: 'PL_CİZGİ' },
                { layer: 53, name: 'ÖZEL ÇEVRE KORUMA BÖLGESİ', group: 'PL_CİZGİ' },
                // PL_NOKTA Group (Point layers)
                { layer: 55, name: 'IlMerkezi', group: 'PL_NOKTA' },
                { layer: 56, name: 'ILCE_ADI', group: 'PL_NOKTA' },
                { layer: 57, name: 'BELEDIYE_ADI', group: 'PL_NOKTA' },
                { layer: 58, name: 'KÖY_ADI', group: 'PL_NOKTA' },
                { layer: 59, name: 'YaylaYerleşimAlanları', group: 'PL_NOKTA' },
                { layer: 60, name: 'YENILENEBILIR', group: 'PL_NOKTA' },
                { layer: 61, name: 'KAVŞAK', group: 'PL_NOKTA' },
                { layer: 62, name: 'TGB', group: 'PL_NOKTA' },
                { layer: 63, name: 'Noktalar_AMD', group: 'PL_NOKTA' },
                { layer: 64, name: 'Noktalar_Bodrum', group: 'PL_NOKTA' }
            ],
            abi: [
                // ANTALYA Group - Area/Spatial layers
                { layer: 1, name: 'PLANYUZBIN_alan-MEKANSAL', group: 'ANTALYA' },
                { layer: 2, name: 'ENERJİ - SULAMA (ALAN)', group: 'ANTALYA' },
                { layer: 3, name: 'PLANYUZBIN_cizgi', group: 'ANTALYA' },
                // ANTALYA - ULAŞIM VE İLETİM HATLARI
                { layer: 5, name: 'KARAYOLLARI (ÇİZGİ)', group: 'ANTALYA_ULASIM' },
                { layer: 6, name: 'DEMİRYOLU HATLARI', group: 'ANTALYA_ULASIM' },
                { layer: 7, name: 'ENERJİ - SULAMA (ÇİZGİ)', group: 'ANTALYA_ULASIM' },
                // ANTALYA - KORUMA ALANLARI
                { layer: 9, name: 'AFET RİSKLİ ALANLAR', group: 'ANTALYA_KORUMA' },
                { layer: 11, name: 'SUKAYNAKLARIKORUMA_ÇİZGİ', group: 'ANTALYA_KORUMA' },
                { layer: 13, name: 'DİĞER KORUMA ALANLARI (ALAN)', group: 'ANTALYA_KORUMA' },
                { layer: 14, name: 'DIGERKORUMAALANLARI(NOKTA)', group: 'ANTALYA_KORUMA' },
                { layer: 16, name: 'SİT ALANLARI (ALAN)', group: 'ANTALYA_KORUMA' },
                { layer: 17, name: 'SİT ALANLARI (NOKTA)', group: 'ANTALYA_KORUMA' },
                // ANTALYA - PLANLAMA SINIRLARI
                { layer: 19, name: 'OPA_ALTBOLGESINIR_cizgi', group: 'ANTALYA_PLANLAMA' },
                { layer: 20, name: 'OZELKANUNLARATABIALANLAR', group: 'ANTALYA_PLANLAMA' },
                { layer: 21, name: 'ÖÇK BÖLGELERİ', group: 'ANTALYA_PLANLAMA' },
                { layer: 22, name: 'OZELKANUNLARATABIALANLAR_NOKTA', group: 'ANTALYA_PLANLAMA' },
                { layer: 23, name: 'OZELKANUNLARATABIALANLAR_NOKTA', group: 'ANTALYA_PLANLAMA' },
                // ANTALYA - İDARİ SINIRLAR
                { layer: 25, name: 'ILCESINIRI_alan', group: 'ANTALYA_IDARI' },
                { layer: 26, name: 'ILSINIRI_alan', group: 'ANTALYA_IDARI' },
                { layer: 27, name: 'İDARİ SINIRLAR (ÇİZGİ)', group: 'ANTALYA_IDARI' },
                { layer: 28, name: 'IDARİ MERKEZLER (NOKTA)', group: 'ANTALYA_IDARI' },
                { layer: 29, name: 'PLANYUZBIN_nokta', group: 'ANTALYA' },
                { layer: 30, name: 'PLANONAMASINIRI_cizgi', group: 'ANTALYA' },
                { layer: 31, name: 'plan_degisikligi_sinir', group: 'ANTALYA' },
                // BURDUR-ISPARTA Group - ALANSAL KARARLAR
                { layer: 34, name: 'TARIMSAL ARAZI KULLANIMLARI', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 35, name: 'ORMAN VE AĞACLANDIRILACAK ALANLAR', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 36, name: 'DOĞAL KARAKTERİ KORUNACAK ALANLAR', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 37, name: 'HAVAYOLLARI (ALAN)', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 38, name: 'ENERJİ - SULAMA (ALAN)', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 39, name: 'YERLEŞİM ALANLARI', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 40, name: 'MESKUNMPYY', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 41, name: 'kentsel_gelisme_mpyy', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 42, name: 'DİĞER ARAZİ KULLANIM ALANLARI (ALAN)', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 43, name: 'SU YUZEYLERİ', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 44, name: 'SUYUZEYLERIA', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 45, name: 'BÜYÜK VE AÇIK ALAN KULLANIŞLARI (ALAN)', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 46, name: 'kentselbolgeselyesilspormpyy', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 47, name: 'kentselbolgeseldonatı', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 48, name: 'OTAmpyy', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 49, name: 'TURİZM ALANLARI', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 50, name: 'DENIZYOLLARIVEKIYIYAPILARIA', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 51, name: 'ÇALIŞMA ALANLARI', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 52, name: 'sanayivedepolamampyy', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 53, name: 'KSAMPYY', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 54, name: 'ATIKVEARITMATESISLERIA', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 55, name: 'DİĞER ARAZİ KULLANIM ALANLARI (ALAN)', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 56, name: 'SU KAYNAKLARI KORUMA ALANLARI', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 57, name: 'SUKAYNAKLARIKORUMA_L', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 58, name: 'SİT ALANLARI (ALAN)', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 59, name: 'PLANLAMASINIRLARI_L', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 60, name: 'OZELKANUNLARATABIALANLAR', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 61, name: 'KULLANIM SINIRLAMASI GETİRİLEN ALANLAR', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 62, name: 'DİĞER KORUMA ALANLARI (ALAN)', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 63, name: 'DÜDEN KORUMA ALANLARI', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 64, name: 'EGIRDIRGOLU_OZELHUKUM_A', group: 'BURDUR_ISPARTA_ALANSAL' },
                { layer: 65, name: 'EGIRDIRGOLU_OZELHUKUM_L', group: 'BURDUR_ISPARTA_ALANSAL' },
                // BURDUR-ISPARTA - SINIRLAR (Boundaries)
                { layer: 67, name: 'KARAYOLLARI (ÇİZGİ)', group: 'BURDUR_ISPARTA_SINIRLAR' },
                { layer: 68, name: 'SINIRLAR', group: 'BURDUR_ISPARTA_SINIRLAR' },
                { layer: 69, name: 'SORUMLULUKSINIRI_L', group: 'BURDUR_ISPARTA_SINIRLAR' },
                { layer: 70, name: 'PLANLAMABOLGESI', group: 'BURDUR_ISPARTA_SINIRLAR' },
                { layer: 71, name: 'SINIR KAPILARI', group: 'BURDUR_ISPARTA_SINIRLAR' },
                { layer: 72, name: 'IDARİ MERKEZLER (NOKTA)', group: 'BURDUR_ISPARTA_SINIRLAR' },
                // BURDUR-ISPARTA - ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 74, name: 'HAVAYOLLARI (ÇİZGİ)', group: 'BURDUR_ISPARTA_CIZGISEL' },
                { layer: 75, name: 'ENERJİ - SULAMA (ÇİZGİ)', group: 'BURDUR_ISPARTA_CIZGISEL' },
                { layer: 76, name: 'DENIZYOLLARIVEKIYIYAPILARIC', group: 'BURDUR_ISPARTA_CIZGISEL' },
                { layer: 77, name: 'DEMİRYOLLARI', group: 'BURDUR_ISPARTA_CIZGISEL' },
                { layer: 78, name: 'SU YÜZEYLERİ (ÇİZGİ)', group: 'BURDUR_ISPARTA_CIZGISEL' },
                // BURDUR-ISPARTA - NOKTASAL KARARLAR (Point decisions)
                { layer: 80, name: 'TURİZM ALANLARI (NOKTA)', group: 'BURDUR_ISPARTA_NOKTASAL' },
                { layer: 81, name: 'SİT ALANLARI (NOKTA)', group: 'BURDUR_ISPARTA_NOKTASAL' },
                { layer: 82, name: 'HAVAYOLLARI (NOKTA)', group: 'BURDUR_ISPARTA_NOKTASAL' },
                { layer: 83, name: 'DIGERKORUMAALANLARIN', group: 'BURDUR_ISPARTA_NOKTASAL' },
                { layer: 84, name: 'DİĞER ARAZİ KULLANIM ALANLARI (NOKTA)', group: 'BURDUR_ISPARTA_NOKTASAL' },
                { layer: 85, name: 'DENIZYOLLARIVEKIYIYAPILARIN', group: 'BURDUR_ISPARTA_NOKTASAL' },
                { layer: 86, name: 'ÇALIŞMA ALANLARI (NOKTA)', group: 'BURDUR_ISPARTA_NOKTASAL' },
                { layer: 87, name: 'BÜYÜK VE AÇIK ALAN KULLANIŞLARI (NOKTA)', group: 'BURDUR_ISPARTA_NOKTASAL' },
                { layer: 88, name: 'donatınokta', group: 'BURDUR_ISPARTA_NOKTASAL' },
                { layer: 89, name: 'ATIK VE ARITMA TESISLERİ (NOKTA)', group: 'BURDUR_ISPARTA_NOKTASAL' },
                { layer: 90, name: 'plan_degisikligi_sinir', group: 'BURDUR_ISPARTA_NOKTASAL' }
            ],
            cb: [
                // ALANSAL KARARLAR (Area decisions)
                { layer: 2, name: 'TARIMSAL ARAZİ KULLANIMLARI', group: 'CB_ALANSAL' },
                { layer: 3, name: 'ORMAN VE AĞAÇLANDIRILACAK ALANLAR', group: 'CB_ALANSAL' },
                { layer: 4, name: 'DOĞAL KARAKTERİ KORUNACAK ALANLAR', group: 'CB_ALANSAL' },
                { layer: 5, name: 'HAVAYOLLARI (ALAN)', group: 'CB_ALANSAL' },
                { layer: 6, name: 'YERLEŞİM ALANLARI', group: 'CB_ALANSAL' },
                { layer: 7, name: 'SU YÜZEYLERİ', group: 'CB_ALANSAL' },
                { layer: 9, name: 'BÜYÜK VE AÇIK ALAN KULLANIŞLARI', group: 'CB_ALANSAL' },
                { layer: 10, name: 'KENTSEL VE BÖLGESEL SOSYAL ALTYAPI ALANI', group: 'CB_ALANSAL' },
                { layer: 11, name: 'TURİZM ALANLARI', group: 'CB_ALANSAL' },
                { layer: 12, name: 'DENİZYOLLARI VE KIYI YAPILARI (ALAN)', group: 'CB_ALANSAL' },
                { layer: 13, name: 'ÇALIŞMA ALANLARI', group: 'CB_ALANSAL' },
                { layer: 14, name: 'ATIK VE ARITMA TESİSLERİ (ALAN)', group: 'CB_ALANSAL' },
                { layer: 15, name: 'DİĞER ARAZİ KULLANIM ALANLARI (ALAN)', group: 'CB_ALANSAL' },
                { layer: 16, name: 'KORUNACAK ALANLAR', group: 'CB_ALANSAL' },
                { layer: 17, name: 'ÖZEL KANUNLARA TABİ ALANLAR', group: 'CB_ALANSAL' },
                { layer: 18, name: 'DİĞER KORUMA ALANLARI (ALAN)', group: 'CB_ALANSAL' },
                { layer: 19, name: 'ENERJİ - SULAMA (ALAN)', group: 'CB_ALANSAL' },
                { layer: 20, name: 'TGB', group: 'CB_ALANSAL' },
                // ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 22, name: 'SU YÜZEYLERİ (ÇİZGİ)', group: 'CB_CIZGISEL' },
                { layer: 23, name: 'ENERJİ - SULAMA (ÇİZGİ)', group: 'CB_CIZGISEL' },
                { layer: 24, name: 'DENİZYOLLARI VE KIYI YAPILARI (ÇİZGİ)', group: 'CB_CIZGISEL' },
                { layer: 25, name: 'DEMİRYOLLARI', group: 'CB_CIZGISEL' },
                { layer: 26, name: 'KARAYOLLARI (ÇİZGİ)', group: 'CB_CIZGISEL' },
                { layer: 27, name: 'SU KAYNAKLARI KORUMA (ÇİZGİ)', group: 'CB_CIZGISEL' },
                { layer: 28, name: 'ÖZEL GÜVENLİK BÖLGESİ SINIR', group: 'CB_CIZGISEL' },
                // SINIRLAR (Boundaries)
                { layer: 30, name: 'İDARİ MERKEZLER', group: 'CB_SINIRLAR' },
                { layer: 31, name: 'İDARİ MERKEZLER KÖY', group: 'CB_SINIRLAR' },
                { layer: 32, name: 'İDARİ SINIRLAR', group: 'CB_SINIRLAR' },
                { layer: 33, name: 'PLAN DEĞİŞİKLİĞİ SINIR', group: 'CB_SINIRLAR' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 35, name: 'TURİZM BÖLGESİ (NOKTA)', group: 'CB_NOKTASAL' },
                { layer: 36, name: 'STRATEJİK KARARLAR (NOKTA)', group: 'CB_NOKTASAL' },
                { layer: 37, name: 'SİT ALANLARI (NOKTA)', group: 'CB_NOKTASAL' },
                { layer: 38, name: 'HAVAYOLLARI (NOKTA)', group: 'CB_NOKTASAL' },
                { layer: 39, name: 'DENİZYOLLARI (NOKTA)', group: 'CB_NOKTASAL' },
                { layer: 40, name: 'ÇALIŞMA ALANLARI (NOKTA)', group: 'CB_NOKTASAL' },
                { layer: 41, name: 'BÜYÜK VE AÇIK ALAN KULLANIŞLARI (NOKTA)', group: 'CB_NOKTASAL' },
                { layer: 42, name: 'SU-ATIKSU VE ATIK SİSTEMLERİ (NOKTA)', group: 'CB_NOKTASAL' },
                { layer: 43, name: 'KIYI TESİSLERİ ALANI', group: 'CB_NOKTASAL' },
                { layer: 44, name: 'ÖZEL GÜVENLİK BÖLGESİ SEMBOL', group: 'CB_NOKTASAL' },
                { layer: 45, name: 'KBSA SEMBOL', group: 'CB_NOKTASAL' },
                { layer: 46, name: 'KENTSEL BÖLGESEL SOSYAL ALTYAPI NOKTA', group: 'CB_NOKTASAL' },
                { layer: 47, name: 'TGB SEMBOL', group: 'CB_NOKTASAL' }
            ],
            ma: [
                // PLAN_ADANA - ALANSAL KARARLAR (Area decisions)
                { layer: 3, name: 'ARAZIKULLANIMI RENK', group: 'MA_ADANA_ALANSAL' },
                { layer: 4, name: 'TARIM_MPYY', group: 'MA_ADANA_ALANSAL' },
                { layer: 5, name: 'ARAZIKULLANIMI TARAMA', group: 'MA_ADANA_ALANSAL' },
                { layer: 6, name: 'ceyhan_osb', group: 'MA_ADANA_ALANSAL' },
                { layer: 7, name: 'OSB__H_SABANCI_ILAVE', group: 'MA_ADANA_ALANSAL' },
                { layer: 8, name: 'OSB_NOKTA_DEG', group: 'MA_ADANA_ALANSAL' },
                { layer: 9, name: 'ENERJİ - SULAMA (ALAN)', group: 'MA_ADANA_ALANSAL' },
                { layer: 10, name: 'SİT ALANLARI', group: 'MA_ADANA_ALANSAL' },
                { layer: 11, name: 'ÖZEL KANUNLARA TABİ ALANLAR', group: 'MA_ADANA_ALANSAL' },
                { layer: 12, name: 'DİĞER KORUMA ALANLARI (ALAN)', group: 'MA_ADANA_ALANSAL' },
                { layer: 13, name: 'eb_bos_cizgi', group: 'MA_ADANA_ALANSAL' },
                { layer: 14, name: 'ENDUSTRI_BOLGESI', group: 'MA_ADANA_ALANSAL' },
                { layer: 15, name: 'SANAYIVEDEPOLAMA_ALANI', group: 'MA_ADANA_ALANSAL' },
                { layer: 16, name: 'KENTSEL_GEL_MPYY', group: 'MA_ADANA_ALANSAL' },
                // PLAN_ADANA - SINIRLAR (Boundaries)
                { layer: 18, name: 'pl_deg_sn', group: 'MA_ADANA_SINIRLAR' },
                { layer: 19, name: 'SORUMLULUK SINIRI (ÇİZGİ)', group: 'MA_ADANA_SINIRLAR' },
                { layer: 20, name: 'İDARİ MERKEZLER', group: 'MA_ADANA_SINIRLAR' },
                // PLAN_ADANA - ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 22, name: 'SU KAYNAKLARI KORUMA ALANLARI (ÇİZGİ)', group: 'MA_ADANA_CIZGISEL' },
                { layer: 23, name: 'DİĞER KORUMA ALANLARI (ÇİZGİ)', group: 'MA_ADANA_CIZGISEL' },
                { layer: 24, name: 'KARAYOLLARI (ÇİZGİ)', group: 'MA_ADANA_CIZGISEL' },
                { layer: 25, name: 'HAVAYOLLARI (ÇİZGİ)', group: 'MA_ADANA_CIZGISEL' },
                { layer: 26, name: 'ENERJİ - SULAMA (ÇİZGİ)', group: 'MA_ADANA_CIZGISEL' },
                { layer: 27, name: 'DENIZYOLLARIVEKIYIYAPILARIC', group: 'MA_ADANA_CIZGISEL' },
                { layer: 28, name: 'ÖZEL KANUNLARA TABİ ALANLAR (ÇİZGİ)', group: 'MA_ADANA_CIZGISEL' },
                { layer: 29, name: 'SU YÜZEYLERİ (ÇİZGİ)', group: 'MA_ADANA_CIZGISEL' },
                // PLAN_ADANA - NOKTASAL KARARLAR (Point decisions)
                { layer: 31, name: 'KARAYOLLARI - KAVŞAK (NOKTA)', group: 'MA_ADANA_NOKTASAL' },
                { layer: 32, name: 'TURİZM ALANLARI (NOKTA)', group: 'MA_ADANA_NOKTASAL' },
                { layer: 33, name: 'STRATEJİK KARARLAR (NOKTA)', group: 'MA_ADANA_NOKTASAL' },
                { layer: 34, name: 'SİT ALANLARI (NOKTA)', group: 'MA_ADANA_NOKTASAL' },
                { layer: 35, name: 'HAVAYOLLARI (NOKTA)', group: 'MA_ADANA_NOKTASAL' },
                { layer: 36, name: 'ENERJİ - SULAMA (NOKTA)', group: 'MA_ADANA_NOKTASAL' },
                { layer: 37, name: 'KENTSEL ÇALIŞMA ALANLARI (NOKTA)', group: 'MA_ADANA_NOKTASAL' },
                { layer: 38, name: 'SU-ATIKSU VE ATIK SİSTEMLERİ (NOKTA)', group: 'MA_ADANA_NOKTASAL' },
                // PLAN_MERSIN - ALANSAL KARARLAR (Area decisions)
                { layer: 39, name: 'PLAN SINIRI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 40, name: 'ARAZIKULLANIMI RENK', group: 'MA_MERSIN_ALANSAL' },
                { layer: 41, name: 'ARAZIKULLANIMI TARAMA', group: 'MA_MERSIN_ALANSAL' },
                { layer: 42, name: 'TARIMSAL ARAZI KULLANIMLARI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 44, name: 'ORMAN VE AĞAÇLANDIRILACAK ALANLAR', group: 'MA_MERSIN_ALANSAL' },
                { layer: 48, name: 'DOĞAL KARAKTERİ KORUNACAK ALANLAR', group: 'MA_MERSIN_ALANSAL' },
                { layer: 49, name: 'SERBEST BÖLGE', group: 'MA_MERSIN_ALANSAL' },
                { layer: 50, name: 'YERLEŞİM ALANLARI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 51, name: 'KENTSEL GELİŞME ALANI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 52, name: 'SU YÜZEYLERİ', group: 'MA_MERSIN_ALANSAL' },
                { layer: 53, name: 'BÜYÜK VE AÇIK ALAN KULLANIŞLARI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 54, name: 'TURİZM ALANLARI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 55, name: 'KENTSEL ÇALIŞMA ALANLARI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 56, name: 'SANAYİ VE DEPOLAMA', group: 'MA_MERSIN_ALANSAL' },
                { layer: 57, name: 'ENERJİ ÜRETİM-DAĞITIM VE DEPOLAMA', group: 'MA_MERSIN_ALANSAL' },
                { layer: 58, name: 'KENTSEL VE BÖLGESEL SOSYAL ALTYAPI ALANI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 59, name: 'SU-ATIKSU VE ATIK SİSTEMLERİ', group: 'MA_MERSIN_ALANSAL' },
                { layer: 60, name: 'DİĞER ARAZİ KULLANIM ALANLARI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 61, name: 'SU KAYNAKLARI KORUMA ALANLARI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 62, name: 'YAPI SINIRLAMASI GETİRİLEREK KORUNACAK ALANLAR', group: 'MA_MERSIN_ALANSAL' },
                { layer: 63, name: 'BUGÜNKÜ ARAZİ KULLANIMI DEVAMETTİRİLEREK KORUNACAK ALANLAR', group: 'MA_MERSIN_ALANSAL' },
                { layer: 64, name: 'TARİHİ VE KÜLTÜREL DEĞERLER', group: 'MA_MERSIN_ALANSAL' },
                { layer: 65, name: 'AFET VE JEOLOJIK SAKINCALI ALANLAR', group: 'MA_MERSIN_ALANSAL' },
                { layer: 66, name: 'DİĞER KORUMA ALANLARI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 67, name: 'ASKERİ YASAK VE GÜVENLİK BÖLGELERİ', group: 'MA_MERSIN_ALANSAL' },
                { layer: 68, name: 'ÖZEL KANUNLARLA BELİRLENEN ALANLAR', group: 'MA_MERSIN_ALANSAL' },
                { layer: 70, name: 'MİLLİ PARK', group: 'MA_MERSIN_ALANSAL' },
                { layer: 71, name: 'TABİAT PARKI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 72, name: 'TABİATI KORUMA ALANI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 73, name: 'SULAK ALAN', group: 'MA_MERSIN_ALANSAL' },
                { layer: 74, name: 'YABAN HAYATI KORUMA VE GELİŞTİRME ALANI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 75, name: 'ÖZEL ÇEVRE KORUMA BÖLGESİ', group: 'MA_MERSIN_ALANSAL' },
                { layer: 77, name: 'TABİAT PARKI ALANI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 78, name: 'ÖZEL ÇEVRE KORUMA BÖLGESİ', group: 'MA_MERSIN_ALANSAL' },
                { layer: 79, name: 'YABAN HAYATI KORUMA VE GELİŞTİRME ALANI', group: 'MA_MERSIN_ALANSAL' },
                { layer: 80, name: 'SİT ALANLARI', group: 'MA_MERSIN_ALANSAL' },
                // PLAN_MERSIN - ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 82, name: 'YAPI SINIRLAMASI GETİRİLEREK KORUNACAK ALANLAR (ÇİZGİ)', group: 'MA_MERSIN_CIZGISEL' },
                { layer: 84, name: 'TEİAŞ HATLAR', group: 'MA_MERSIN_CIZGISEL' },
                { layer: 85, name: 'BOTAŞ BORU HATTI', group: 'MA_MERSIN_CIZGISEL' },
                { layer: 86, name: 'NATO BORU HATTI', group: 'MA_MERSIN_CIZGISEL' },
                { layer: 87, name: 'SU YÜZEYLERİ (ÇİZGİ)', group: 'MA_MERSIN_CIZGISEL' },
                { layer: 88, name: 'DENİZYOLLARI (ÇİZGİ)', group: 'MA_MERSIN_CIZGISEL' },
                { layer: 89, name: 'KARAYOLLARI (ÇİZGİ)', group: 'MA_MERSIN_CIZGISEL' },
                { layer: 90, name: 'DEMİRYOLLARI (ÇİZGİ)', group: 'MA_MERSIN_CIZGISEL' },
                // PLAN_MERSIN - NOKTASAL KARARLAR (Point decisions)
                { layer: 92, name: 'DEMİRYOLLARI (NOKTA)', group: 'MA_MERSIN_NOKTASAL' },
                { layer: 93, name: 'KARAYOLLARI - KAVŞAK (NOKTA)', group: 'MA_MERSIN_NOKTASAL' },
                { layer: 94, name: 'TURİZM ALANLARI (NOKTA)', group: 'MA_MERSIN_NOKTASAL' },
                { layer: 95, name: 'TURİZM BÖLGESİ (NOKTA)', group: 'MA_MERSIN_NOKTASAL' },
                { layer: 96, name: 'ÖZEL KANUNLARLA BELİRLENEN ALANLAR (NOKTA)', group: 'MA_MERSIN_NOKTASAL' },
                { layer: 97, name: 'HAVAYOLLARI (NOKTA)', group: 'MA_MERSIN_NOKTASAL' },
                { layer: 98, name: 'ENERJİ ÜRETİM DAĞITIM VE DEPOLAMA (NOKTA)', group: 'MA_MERSIN_NOKTASAL' },
                { layer: 100, name: 'AKDENİZ FOKU DENİZ KAPLUMBAĞALARI KORUMA ALANI (NOKTA)', group: 'MA_MERSIN_NOKTASAL' },
                { layer: 101, name: 'SİT VE KORUNACAK ALANLAR (NOKTA)', group: 'MA_MERSIN_NOKTASAL' },
                { layer: 102, name: 'DENİZYOLLARI (NOKTA)', group: 'MA_MERSIN_NOKTASAL' },
                { layer: 103, name: 'KENTSEL ÇALIŞMA ALANLARI (NOKTA)', group: 'MA_MERSIN_NOKTASAL' },
                { layer: 104, name: 'SOSYAL ALTYAPI ALANLARI (NOKTA)', group: 'MA_MERSIN_NOKTASAL' },
                { layer: 105, name: 'SU-ATIKSU VE ATIK SİSTEMLERİ (NOKTA)', group: 'MA_MERSIN_NOKTASAL' },
                // PLAN_MERSIN - SINIRLAR (Boundaries)
                { layer: 107, name: 'PLAN DEĞİŞİKLİĞİ SINIRI', group: 'MA_MERSIN_SINIRLAR' },
                { layer: 108, name: 'SINIRLAR', group: 'MA_MERSIN_SINIRLAR' },
                { layer: 109, name: 'İLÇE SINIRI (MERSİN)', group: 'MA_MERSIN_SINIRLAR' },
                { layer: 110, name: 'İDARİ MERKEZLER', group: 'MA_MERSIN_SINIRLAR' },
                { layer: 111, name: 'ASKERİ YASAK VE GÜVENLİK BÖLGE SINIRI', group: 'MA_MERSIN_SINIRLAR' },
                { layer: 112, name: 'KTKGB', group: 'MA_MERSIN_SINIRLAR' },
                { layer: 113, name: 'K_MPYY', group: 'MA_MERSIN_SINIRLAR' }
            ],
            asd: [
                // ALANSAL KARARLAR (Area decisions) - Diyarbakır
                { layer: 3, name: 'TARIMSALARAZIKULLANIMLARIA', group: 'ASD_ALANSAL' },
                { layer: 4, name: 'ORMANVEAGACLANDIRILACAKA', group: 'ASD_ALANSAL' },
                { layer: 5, name: 'DOGALKARAKTERIKORUNACAKA_son', group: 'ASD_ALANSAL' },
                { layer: 6, name: 'TARIMA_DONUSTURULECEK_ALAN', group: 'ASD_ALANSAL' },
                { layer: 7, name: 'YERLESIMA', group: 'ASD_ALANSAL' },
                { layer: 8, name: 'YERLESIMA', group: 'ASD_ALANSAL' },
                { layer: 9, name: 'BUYUKVEACIKALANKULLANISLARIA', group: 'ASD_ALANSAL' },
                { layer: 10, name: 'CALISMAA', group: 'ASD_ALANSAL' },
                { layer: 11, name: 'DIGERARAZIKULLANIMA', group: 'ASD_ALANSAL' },
                { layer: 12, name: 'TURIZMA', group: 'ASD_ALANSAL' },
                { layer: 13, name: 'HAVAYOLLARIA', group: 'ASD_ALANSAL' },
                { layer: 14, name: 'ATIKVEARITMATESISLERIA', group: 'ASD_ALANSAL' },
                { layer: 15, name: 'ENERJISULAMAA', group: 'ASD_ALANSAL' },
                { layer: 16, name: 'ENERJISULAMAA', group: 'ASD_ALANSAL' },
                { layer: 17, name: 'SUYUZEYLERIA', group: 'ASD_ALANSAL' },
                { layer: 18, name: 'SUYUZEYLERIA_ATATURK_BRJ', group: 'ASD_ALANSAL' },
                { layer: 19, name: 'DIGERKORUMAALANLARIA', group: 'ASD_ALANSAL' },
                { layer: 20, name: 'SITA', group: 'ASD_ALANSAL' },
                { layer: 21, name: 'DIGERKORUMAALANLARIA', group: 'ASD_ALANSAL' },
                { layer: 22, name: 'SUKAYNAKLARIKORUMAA-ATATURK BARAJI', group: 'ASD_ALANSAL' },
                { layer: 23, name: 'SUKAYNAKLARIKORUMAA', group: 'ASD_ALANSAL' },
                { layer: 24, name: 'OZELKANUNLARATABIALANLAR', group: 'ASD_ALANSAL' },
                // ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 26, name: 'HAVAYOLLARIC', group: 'ASD_CIZGISEL' },
                { layer: 27, name: 'SUYUZEYLERIC', group: 'ASD_CIZGISEL' },
                { layer: 28, name: 'DENIZYOLLARIVEKIYIYAPILARIC', group: 'ASD_CIZGISEL' },
                { layer: 29, name: 'PLANLAMASINIRLARI_Alternatif_2', group: 'ASD_CIZGISEL' },
                { layer: 30, name: 'PLANLAMASINIRLARIL', group: 'ASD_CIZGISEL' },
                { layer: 31, name: 'SORUMLULUKSINIRIL', group: 'ASD_CIZGISEL' },
                { layer: 32, name: 'SINIRLAR', group: 'ASD_CIZGISEL' },
                { layer: 33, name: 'ENERJISULAMAC', group: 'ASD_CIZGISEL' },
                { layer: 34, name: 'DEMIRYOLLARI', group: 'ASD_CIZGISEL' },
                { layer: 35, name: 'KARAYOLLARI-ADIY_URFA', group: 'ASD_CIZGISEL' },
                { layer: 36, name: 'PLANDEGISIKLIGISINIRI', group: 'ASD_CIZGISEL' },
                { layer: 37, name: 'PLANDEGISIKLIGISINIRI', group: 'ASD_CIZGISEL' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 39, name: 'KARAYOLLARIN', group: 'ASD_NOKTASAL' },
                { layer: 40, name: 'SINIRKAPILARI', group: 'ASD_NOKTASAL' },
                { layer: 41, name: 'DIGERKORUMAALANLARIN', group: 'ASD_NOKTASAL' },
                { layer: 42, name: 'DIGERARAZIKULLANIMN', group: 'ASD_NOKTASAL' },
                { layer: 43, name: 'ATIKVEARITMATESISLERIN', group: 'ASD_NOKTASAL' },
                { layer: 44, name: 'CALISMAN', group: 'ASD_NOKTASAL' },
                { layer: 45, name: 'DENIZYOLLARIVEKIYIYAPILARIN', group: 'ASD_NOKTASAL' },
                { layer: 46, name: 'HAVAYOLLARIN', group: 'ASD_NOKTASAL' },
                { layer: 47, name: 'TURIZMN', group: 'ASD_NOKTASAL' },
                // İDARİ MERKEZLER (Administrative centers)
                { layer: 49, name: 'IDARIMERKEZLER_BELDE', group: 'ASD_IDARI' },
                { layer: 50, name: 'IDARIMERKEZLER_ILCE', group: 'ASD_IDARI' },
                { layer: 51, name: 'IDARIMERKEZLER_IL', group: 'ASD_IDARI' },
                { layer: 52, name: 'SITN', group: 'ASD_NOKTASAL' },
                { layer: 53, name: 'BUYUKVEACIKALANKULLANISLARIN', group: 'ASD_NOKTASAL' },
                { layer: 54, name: 'IDARIMERKEZLER_KÖY', group: 'ASD_IDARI' }
            ],
            akia: [
                // ALANSAL KARARLAR (Area decisions)
                { layer: 2, name: 'ARAZI_KULLANIMI', group: 'AKIA_ALANSAL' },
                { layer: 3, name: 'TARIMSAL ARAZİ KULLANIMLARI', group: 'AKIA_ALANSAL' },
                { layer: 4, name: 'DOĞAL KARAKTERİ KORUNACAK ALANLAR', group: 'AKIA_ALANSAL' },
                { layer: 5, name: 'ORMANVEAGACLANDIRILACAKA', group: 'AKIA_ALANSAL' },
                { layer: 6, name: 'BÜYÜK VE AÇIK ALAN KULLANIŞLARI', group: 'AKIA_ALANSAL' },
                { layer: 7, name: 'ÇALIŞMA ALANLARI', group: 'AKIA_ALANSAL' },
                { layer: 8, name: 'KENTSEL_SERVİS_ALANI_MPYY', group: 'AKIA_ALANSAL' },
                { layer: 9, name: 'TURİZM ALANLARI', group: 'AKIA_ALANSAL' },
                { layer: 10, name: 'YERLEŞİM ALANLARI', group: 'AKIA_ALANSAL' },
                { layer: 11, name: 'KENTSEL_YERLESME_MPYY', group: 'AKIA_ALANSAL' },
                { layer: 12, name: 'KENTSEL_GELISME_MPYY', group: 'AKIA_ALANSAL' },
                { layer: 13, name: 'DUSUK YOGUNLUKLU KENTSEL GELISME', group: 'AKIA_ALANSAL' },
                // SU YÜZEYLERİ (Water surfaces)
                { layer: 15, name: 'SU YÜZEYLERİ', group: 'AKIA_ALANSAL' },
                { layer: 17, name: 'AKARSU_ALAN', group: 'AKIA_ALANSAL' },
                { layer: 18, name: 'GOLLER', group: 'AKIA_ALANSAL' },
                { layer: 19, name: 'BARAJ_GOLET', group: 'AKIA_ALANSAL' },
                { layer: 20, name: 'KAYABEYİ_BARAJI', group: 'AKIA_ALANSAL' },
                // STRATEJİK KARARLAR (Strategic decisions)
                { layer: 21, name: 'STRATEJİK KARARLAR (ALAN)', group: 'AKIA_ALANSAL' },
                { layer: 22, name: 'universite_alan', group: 'AKIA_ALANSAL' },
                { layer: 23, name: 'lojistik_bolge_alan', group: 'AKIA_ALANSAL' },
                { layer: 24, name: 'kentsel_bolgesel_yesil_spor_alani', group: 'AKIA_ALANSAL' },
                { layer: 25, name: 'sanayi_depolama_alanı_mpyy', group: 'AKIA_ALANSAL' },
                { layer: 26, name: 'kentsel_bolgesel_sosyal_altyapı_alanı', group: 'AKIA_ALANSAL' },
                { layer: 27, name: 'PLANLAMA SINIRLARI (ALAN)', group: 'AKIA_ALANSAL' },
                { layer: 28, name: 'HAVAYOLLARI (ALAN)', group: 'AKIA_ALANSAL' },
                { layer: 29, name: 'DENİZYOLLARI VE KIYI YAPILARI (ALAN)', group: 'AKIA_ALANSAL' },
                { layer: 30, name: 'ATIK VE ARITMA TESİSLERİ (ALAN)', group: 'AKIA_ALANSAL' },
                { layer: 31, name: 'DİĞER ARAZİ KULLANIM ALANLARI (ALAN)', group: 'AKIA_ALANSAL' },
                { layer: 32, name: 'DİĞER KORUMA ALANLARI (ALAN)', group: 'AKIA_ALANSAL' },
                { layer: 33, name: 'ORGANİZE_TARIM_HAYVANCILIK_MPYY', group: 'AKIA_ALANSAL' },
                // KORUMA ALANLARI (Protection areas)
                { layer: 35, name: 'KORUMA_ALANLARI', group: 'AKIA_ALANSAL' },
                { layer: 36, name: 'SU KAYNAKLARI KORUMA ALANLARI', group: 'AKIA_ALANSAL' },
                { layer: 37, name: 'KULLANIM SINIRLAMASI GETİRİLEN ALANLAR', group: 'AKIA_ALANSAL' },
                { layer: 38, name: 'OZELKANUNLARATABIALANLAR', group: 'AKIA_ALANSAL' },
                { layer: 39, name: 'SİT ALANLARI (ALAN)', group: 'AKIA_ALANSAL' },
                // MANİA (Obstacle areas)
                { layer: 41, name: 'AGRI__MANIA', group: 'AKIA_ALANSAL' },
                { layer: 42, name: 'KARS_MANIA', group: 'AKIA_ALANSAL' },
                // ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 16, name: 'SU YÜZEYLERİ (ÇİZGİ)', group: 'AKIA_CIZGISEL' },
                { layer: 43, name: 'HAVAYOLLARI (ÇİZGİ)', group: 'AKIA_CIZGISEL' },
                { layer: 44, name: 'BARAJALTI_YOL', group: 'AKIA_CIZGISEL' },
                { layer: 45, name: 'otoyol_mpyy', group: 'AKIA_CIZGISEL' },
                { layer: 46, name: 'plan_deg_sinir_mpyy', group: 'AKIA_CIZGISEL' },
                { layer: 47, name: 'birinici_derece_yol_mpyy', group: 'AKIA_CIZGISEL' },
                { layer: 49, name: 'SINIR', group: 'AKIA_CIZGISEL' },
                { layer: 50, name: 'STRATEJİK KARARLAR (ÇİZGİ)', group: 'AKIA_CIZGISEL' },
                { layer: 51, name: 'SORUMLULUK SINIRI (ALAN)', group: 'AKIA_CIZGISEL' },
                { layer: 52, name: 'PLANLAMA BÖLGESİ', group: 'AKIA_CIZGISEL' },
                { layer: 53, name: 'ILSINIR_CIZGI', group: 'AKIA_CIZGISEL' },
                { layer: 54, name: 'ILCESINIRI_CIZGI', group: 'AKIA_CIZGISEL' },
                { layer: 55, name: 'ULKE_SINRI_CIZGI', group: 'AKIA_CIZGISEL' },
                { layer: 56, name: 'KARAYOLLARI (ÇİZGİ)', group: 'AKIA_CIZGISEL' },
                { layer: 57, name: 'DENİZYOLLARI VE KIYI YAPILARI (ÇİZGİ)', group: 'AKIA_CIZGISEL' },
                { layer: 58, name: 'ENERJİ - SULAMA (ÇİZGİ)', group: 'AKIA_CIZGISEL' },
                { layer: 78, name: 'DEMİRYOLLARI', group: 'AKIA_CIZGISEL' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 60, name: 'HAVAYOLLARI (NOKTA)', group: 'AKIA_NOKTASAL' },
                { layer: 61, name: 'universite_nokta', group: 'AKIA_NOKTASAL' },
                { layer: 62, name: 'lojistik_bolge_nokta', group: 'AKIA_NOKTASAL' },
                { layer: 63, name: 'mia', group: 'AKIA_NOKTASAL' },
                { layer: 64, name: 'kentsel_bolgesel_sosyal_altyapı_nokta', group: 'AKIA_NOKTASAL' },
                { layer: 65, name: 'STRATEJİK KARARLAR', group: 'AKIA_NOKTASAL' },
                { layer: 66, name: 'ENERJİ - SULAMA (NOKTA)', group: 'AKIA_NOKTASAL' },
                { layer: 67, name: 'ATIK VE ARITMA TESİSLERİ (NOKTA)', group: 'AKIA_NOKTASAL' },
                { layer: 68, name: 'TURİZM ALANLARI (NOKTA)', group: 'AKIA_NOKTASAL' },
                { layer: 69, name: 'BÜYÜK VE AÇIK ALAN KULLANIŞLARI (NOKTA)', group: 'AKIA_NOKTASAL' },
                { layer: 70, name: 'DİĞER ARAZİ KULLANIM ALANLARI (NOKTA)', group: 'AKIA_NOKTASAL' },
                { layer: 71, name: 'ÇALIŞMA ALANLARI (NOKTA)', group: 'AKIA_NOKTASAL' },
                { layer: 72, name: 'SINIR KAPILARI', group: 'AKIA_NOKTASAL' },
                { layer: 77, name: 'İDARİ MERKEZLER (NOKTA)', group: 'AKIA_NOKTASAL' },
                { layer: 79, name: 'DENİZYOLLARI VE KIYI YAPILARI (NOKTA)', group: 'AKIA_NOKTASAL' },
                { layer: 80, name: 'SİT ALANLARI (NOKTA)', group: 'AKIA_NOKTASAL' },
                { layer: 81, name: 'MANIAAGRI', group: 'AKIA_NOKTASAL' },
                { layer: 82, name: 'MANIAKARS', group: 'AKIA_NOKTASAL' },
                // İDARİ MERKEZLER (Administrative centers)
                { layer: 73, name: 'IL_MERKEZI', group: 'AKIA_IDARI' },
                { layer: 74, name: 'BARAJALTI KIRSAL YERLEŞIM', group: 'AKIA_IDARI' },
                { layer: 75, name: 'MERKEZI_YERLESIM_YERLERI', group: 'AKIA_IDARI' },
                { layer: 76, name: 'KOY_MAHALLE_MRKZI', group: 'AKIA_IDARI' }
            ],
            knna: [
                // ALANSAL KARARLAR (Area decisions) - ARAZİ_KULLANIM
                { layer: 1, name: 'Mera_Alanları', group: 'KNNA_ALANSAL' },
                { layer: 2, name: 'Tarım_Alanları', group: 'KNNA_ALANSAL' },
                { layer: 3, name: 'Orman_Alanları', group: 'KNNA_ALANSAL' },
                { layer: 4, name: 'Kırsal_Meskun_alanlar', group: 'KNNA_ALANSAL' },
                { layer: 5, name: 'OSB', group: 'KNNA_ALANSAL' },
                { layer: 6, name: 'Sanayi_Bolgesi', group: 'KNNA_ALANSAL' },
                { layer: 7, name: 'Endüstri Bölgesi', group: 'KNNA_ALANSAL' },
                { layer: 8, name: 'Universite', group: 'KNNA_ALANSAL' },
                { layer: 9, name: 'Agaclandırılacak_Alanlar', group: 'KNNA_ALANSAL' },
                { layer: 10, name: 'Goller', group: 'KNNA_ALANSAL' },
                { layer: 11, name: 'Baraj', group: 'KNNA_ALANSAL' },
                { layer: 12, name: 'Golet', group: 'KNNA_ALANSAL' },
                { layer: 13, name: 'Golet_Proje', group: 'KNNA_ALANSAL' },
                { layer: 14, name: 'Günübirlik Tesis ve Alanı', group: 'KNNA_ALANSAL' },
                { layer: 15, name: 'Turizm_Merkezi', group: 'KNNA_ALANSAL' },
                { layer: 16, name: 'Kentsel_Gelisme_Yeni', group: 'KNNA_ALANSAL' },
                { layer: 17, name: 'Kentsel_Meskun_Alanlar', group: 'KNNA_ALANSAL' },
                { layer: 18, name: 'Akarsular', group: 'KNNA_ALANSAL' },
                { layer: 19, name: 'Askeri_Alanlar', group: 'KNNA_ALANSAL' },
                { layer: 20, name: 'Depolama', group: 'KNNA_ALANSAL' },
                { layer: 21, name: 'BAKGA', group: 'KNNA_ALANSAL' },
                { layer: 22, name: 'Kent Parkı', group: 'KNNA_ALANSAL' },
                { layer: 23, name: 'KDCA', group: 'KNNA_ALANSAL' },
                { layer: 24, name: 'Kentsel Servis Alanları', group: 'KNNA_ALANSAL' },
                { layer: 25, name: 'KucukSanayiSitesi', group: 'KNNA_ALANSAL' },
                { layer: 26, name: 'SANAYI_DEPOLAMA', group: 'KNNA_ALANSAL' },
                { layer: 27, name: 'Havaalanı', group: 'KNNA_ALANSAL' },
                { layer: 28, name: 'KampusİciOrman', group: 'KNNA_ALANSAL' },
                { layer: 29, name: 'OrganizeHayvancılık', group: 'KNNA_ALANSAL' },
                { layer: 30, name: 'Taslık', group: 'KNNA_ALANSAL' },
                { layer: 31, name: 'Bataklik_region', group: 'KNNA_ALANSAL' },
                { layer: 32, name: 'JEOSAKIN_region', group: 'KNNA_ALANSAL' },
                { layer: 33, name: 'Havaalani_ellipse', group: 'KNNA_ALANSAL' },
                { layer: 34, name: 'TaskinAlani_region', group: 'KNNA_ALANSAL' },
                { layer: 35, name: 'Havakoridoru_region', group: 'KNNA_ALANSAL' },
                { layer: 36, name: 'Yeni_region', group: 'KNNA_ALANSAL' },
                // KORUMA ALANLARI (Protection areas)
                { layer: 38, name: 'KENTSEL_SIT_region', group: 'KNNA_KORUMA' },
                { layer: 39, name: 'Yeni_region_koruma', group: 'KNNA_KORUMA' },
                { layer: 40, name: 'MILLI_PARKTAB_region', group: 'KNNA_KORUMA' },
                { layer: 41, name: 'arkeolojik_sit_text', group: 'KNNA_KORUMA' },
                { layer: 42, name: 'OCK_SINIR_region', group: 'KNNA_KORUMA' },
                { layer: 43, name: 'EKOSISTEM', group: 'KNNA_KORUMA' },
                { layer: 44, name: 'KENTSEL_SIT_SEMBOL', group: 'KNNA_KORUMA' },
                { layer: 45, name: 'TabiatiKorumaAlanlari_region', group: 'KNNA_KORUMA' },
                { layer: 46, name: 'TKA_TARA_region', group: 'KNNA_KORUMA' },
                { layer: 48, name: 'Ekolojik Etkilenme Bölgesi', group: 'KNNA_KORUMA' },
                { layer: 49, name: 'Sulak Alan Tampon Bölgesi', group: 'KNNA_KORUMA' },
                { layer: 50, name: 'Mutlak Koruma Alanı', group: 'KNNA_KORUMA' },
                { layer: 51, name: 'Sulak Alan', group: 'KNNA_KORUMA' },
                { layer: 52, name: 'SU KAYNAKLARI KORUMA ALANLARI', group: 'KNNA_KORUMA' },
                // ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 54, name: 'Demiryolu_oneri', group: 'KNNA_CIZGISEL' },
                { layer: 55, name: 'DemirYolu2_polyline', group: 'KNNA_CIZGISEL' },
                { layer: 56, name: 'OTOYOLLAR_polyline', group: 'KNNA_CIZGISEL' },
                { layer: 57, name: 'IKINCI_DERECE_YOLLAR_polyline', group: 'KNNA_CIZGISEL' },
                { layer: 58, name: 'BIRINCI_DERECE_YOLLAR_polyline', group: 'KNNA_CIZGISEL' },
                { layer: 59, name: 'Teknoloji_Gelistirme_Bolgesi', group: 'KNNA_CIZGISEL' },
                { layer: 61, name: 'plan_sinirlari', group: 'KNNA_CIZGISEL' },
                { layer: 62, name: 'altbolge_siniri_polyline', group: 'KNNA_CIZGISEL' },
                { layer: 63, name: 'PLAN_SINIRI_polyline', group: 'KNNA_CIZGISEL' },
                { layer: 64, name: 'ILCE_SINIRLARI_polyline', group: 'KNNA_CIZGISEL' },
                { layer: 65, name: 'IL_SINIRLARI_YENİ_polyline', group: 'KNNA_CIZGISEL' },
                { layer: 67, name: 'DogalGazHatti_polyline', group: 'KNNA_CIZGISEL' },
                { layer: 68, name: 'ENH', group: 'KNNA_CIZGISEL' },
                { layer: 69, name: 'dsi_proje_region', group: 'KNNA_CIZGISEL' },
                { layer: 70, name: 'AkarsuCizgi_polyline', group: 'KNNA_CIZGISEL' },
                { layer: 71, name: 'Fay_polyline', group: 'KNNA_CIZGISEL' },
                { layer: 72, name: 'hava_sembol', group: 'KNNA_CIZGISEL' },
                { layer: 73, name: 'Dere_yeni_polyline', group: 'KNNA_CIZGISEL' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 75, name: 'SuKaynagi_font_point', group: 'KNNA_NOKTASAL' },
                { layer: 76, name: 'ARITMATESISI_font_point', group: 'KNNA_NOKTASAL' },
                { layer: 77, name: 'Yayla', group: 'KNNA_NOKTASAL' },
                { layer: 79, name: 'KAPLICA_font_point', group: 'KNNA_NOKTASAL' },
                { layer: 80, name: 'DOGALGAZ_DEPO', group: 'KNNA_NOKTASAL' },
                { layer: 81, name: 'Maden_font_point', group: 'KNNA_NOKTASAL' },
                { layer: 82, name: 'madenocagı', group: 'KNNA_NOKTASAL' },
                // İDARİ MERKEZLER (Administrative centers)
                { layer: 83, name: 'KoyMerkezi_point', group: 'KNNA_IDARI' },
                { layer: 84, name: 'belediye', group: 'KNNA_IDARI' },
                { layer: 85, name: 'IlceMerkezi_font_point', group: 'KNNA_IDARI' },
                { layer: 86, name: 'IlMerkezi_font_point', group: 'KNNA_IDARI' },
                { layer: 87, name: 'Endüstri Bölgesi Nokta', group: 'KNNA_NOKTASAL' }
            ],
            amasya: [
                // ALANSAL KARARLAR (Area decisions) - Arazi Kullanım
                { layer: 2, name: 'A_25K_PL_Kompleks', group: 'AMASYA_ALANSAL' },
                { layer: 3, name: 'A_25K_PL_MutlakTarims', group: 'AMASYA_ALANSAL' },
                { layer: 4, name: 'A_25K_PL_MarjinalTarim', group: 'AMASYA_ALANSAL' },
                { layer: 5, name: 'A_25K_PL_BagBahce', group: 'AMASYA_ALANSAL' },
                { layer: 6, name: 'A_25K_PL_DikiliAlanlar', group: 'AMASYA_ALANSAL' },
                { layer: 7, name: 'A_25K_PL_Diger', group: 'AMASYA_ALANSAL' },
                { layer: 8, name: 'A_25K_PL_Cayır', group: 'AMASYA_ALANSAL' },
                { layer: 9, name: 'A_25K_PL_Mera', group: 'AMASYA_ALANSAL' },
                { layer: 10, name: 'A_25K_PL_AgaclıkAlan', group: 'AMASYA_ALANSAL' },
                { layer: 11, name: 'A_25K_OrmanAlanlariA', group: 'AMASYA_ALANSAL' },
                { layer: 12, name: 'A_25K_PL_AgaclandirilacakAlan', group: 'AMASYA_ALANSAL' },
                { layer: 13, name: 'A_25K_GelismeAlanlari', group: 'AMASYA_ALANSAL' },
                { layer: 14, name: 'YERLESIM_ALANLARI', group: 'AMASYA_ALANSAL' },
                { layer: 31, name: 'SulamaAlanlari', group: 'AMASYA_ALANSAL' },
                { layer: 32, name: 'ManiaAlani', group: 'AMASYA_ALANSAL' },
                { layer: 38, name: 'MesireAlanlari', group: 'AMASYA_ALANSAL' },
                { layer: 40, name: 'YERLESIM_ALANLARI_N', group: 'AMASYA_ALANSAL' },
                { layer: 41, name: 'SOSYAL_ALTYAPI_ALANLARI', group: 'AMASYA_ALANSAL' },
                // KORUMA ALANLARI (Protection Areas)
                { layer: 15, name: 'OZEL_KANUNLARLA_BELIRLENEN_ALAN', group: 'AMASYA_KORUMA' },
                { layer: 23, name: 'OZEL_KANUNLARLA_BELIRLENEN_ALAN_2', group: 'AMASYA_KORUMA' },
                { layer: 24, name: 'OZEL_KANUNLARLA_BELIRLENEN_ALAN_3', group: 'AMASYA_KORUMA' },
                { layer: 25, name: 'SU_ATIKSU_VE_ATIK_SISTEMLERI', group: 'AMASYA_KORUMA' },
                { layer: 34, name: 'PlanDegOnamaSiniriALANforPIN', group: 'AMASYA_KORUMA' },
                { layer: 35, name: 'TGB_sinir', group: 'AMASYA_KORUMA' },
                { layer: 39, name: 'TGB', group: 'AMASYA_KORUMA' },
                // ÇİZGİSEL KARARLAR (Linear decisions)
                { layer: 16, name: 'Amasya25KAkarsular', group: 'AMASYA_CIZGISEL' },
                { layer: 17, name: 'Amasya25KAnaAkarsular', group: 'AMASYA_CIZGISEL' },
                { layer: 19, name: 'Amasya25KDogalgazBoruHattiL', group: 'AMASYA_CIZGISEL' },
                { layer: 20, name: 'DEMİRYOLLARI', group: 'AMASYA_CIZGISEL' },
                { layer: 21, name: 'DEMİRYOLLARI_2', group: 'AMASYA_CIZGISEL' },
                { layer: 22, name: 'KARAYOLLARI', group: 'AMASYA_CIZGISEL' },
                { layer: 27, name: 'Amasya_25K_PlanSinirlariL', group: 'AMASYA_CIZGISEL' },
                { layer: 28, name: 'IdariSinirlar', group: 'AMASYA_CIZGISEL' },
                { layer: 29, name: 'PlanOnamaSiniri', group: 'AMASYA_CIZGISEL' },
                { layer: 33, name: 'EnerjiNakiHatti', group: 'AMASYA_CIZGISEL' },
                { layer: 36, name: 'PlanDegOnamaSinir', group: 'AMASYA_CIZGISEL' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 30, name: 'Terminal', group: 'AMASYA_NOKTASAL' },
                { layer: 42, name: 'A_25K_SitAlanlariN', group: 'AMASYA_NOKTASAL' },
                { layer: 43, name: 'A_25K_HavaalaniN', group: 'AMASYA_NOKTASAL' },
                { layer: 44, name: 'TurizmN', group: 'AMASYA_NOKTASAL' },
                { layer: 45, name: 'SU_ATIKSU_VE_ATIK_SISTEMLERI_N', group: 'AMASYA_NOKTASAL' },
                { layer: 46, name: 'OZEL_KANUNLARLA_BELIRLENEN_ALAN_N', group: 'AMASYA_NOKTASAL' }
            ],
            otrgga: [
                // ALANSAL KARARLAR (Area decisions)
                { layer: 2, name: 'TARIMSAL_ARAZI_KULLANIMLARI', group: 'OTRGGA_ALANSAL' },
                { layer: 3, name: 'ORMAN_VE_AGACLANDIRILACAK_ALANLAR', group: 'OTRGGA_ALANSAL' },
                { layer: 4, name: 'DOGAL_KARAKTERI_KORUNACAK_ALANLAR', group: 'OTRGGA_ALANSAL' },
                { layer: 5, name: 'HAVAYOLLARI_ALAN', group: 'OTRGGA_ALANSAL' },
                { layer: 6, name: 'OTRGGA_YERLESIMA', group: 'OTRGGA_ALANSAL' },
                { layer: 7, name: 'SU_YUZEYLERI', group: 'OTRGGA_ALANSAL' },
                { layer: 8, name: 'BUYUK_VE_ACIK_ALAN_KULLANISLARI', group: 'OTRGGA_ALANSAL' },
                { layer: 9, name: 'DENIZYOLLARI_VE_KIYI_YAPILARI_ALAN', group: 'OTRGGA_ALANSAL' },
                { layer: 10, name: 'CALISMA_ALANLARI', group: 'OTRGGA_ALANSAL' },
                { layer: 11, name: 'ENERJI_SULAMA_ALAN', group: 'OTRGGA_ALANSAL' },
                { layer: 12, name: 'ATIK_VE_ARITMA_TESISLERI_ALAN', group: 'OTRGGA_ALANSAL' },
                { layer: 13, name: 'DIGER_ARAZI_KULLANIM_ALANLARI_ALAN', group: 'OTRGGA_ALANSAL' },
                { layer: 14, name: 'SU_KAYNAKLARI_KORUMA_ALANLARI', group: 'OTRGGA_ALANSAL' },
                { layer: 15, name: 'SIT_ALANLARI_ALAN', group: 'OTRGGA_ALANSAL' },
                { layer: 16, name: 'KULLANIM_SINIRLAMASI_GETIRILEN_ALANLAR', group: 'OTRGGA_ALANSAL' },
                { layer: 17, name: 'EGB', group: 'OTRGGA_ALANSAL' },
                // ÇİZGİSEL KARARLAR (Linear decisions)
                { layer: 19, name: 'Trabzon_Birincidereceyol', group: 'OTRGGA_CIZGISEL' },
                { layer: 20, name: 'KARAYOLLARI', group: 'OTRGGA_CIZGISEL' },
                { layer: 21, name: 'HAVAYOLLARI', group: 'OTRGGA_CIZGISEL' },
                { layer: 22, name: 'ENERJI_SULAMA', group: 'OTRGGA_CIZGISEL' },
                { layer: 23, name: 'DENIZYOLLARI_VE_KIYI_YAPILARI_CIZGI', group: 'OTRGGA_CIZGISEL' },
                { layer: 24, name: 'DEMIRYOLLARI', group: 'OTRGGA_CIZGISEL' },
                { layer: 25, name: 'OZEL_KANUNLARA_TABI_ALANLAR', group: 'OTRGGA_CIZGISEL' },
                { layer: 26, name: 'DIGER_KORUMA_ALANLARI_ALAN', group: 'OTRGGA_CIZGISEL' },
                { layer: 27, name: 'PLANLAMA_SINIRLARI_ALAN', group: 'OTRGGA_CIZGISEL' },
                { layer: 28, name: 'SUYUZEYLERIC_1', group: 'OTRGGA_CIZGISEL' },
                { layer: 29, name: 'SINIRLAR', group: 'OTRGGA_CIZGISEL' },
                { layer: 30, name: 'SORUMLULUK_SINIRI_ALAN', group: 'OTRGGA_CIZGISEL' },
                { layer: 31, name: 'PLANLAMA_BOLGESI', group: 'OTRGGA_CIZGISEL' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 33, name: 'TURIZM_ALANLARI_NOKTA', group: 'OTRGGA_NOKTASAL' },
                { layer: 34, name: 'TARIMSAL_ARAZI_KULLANIMLARI_NOKTA', group: 'OTRGGA_NOKTASAL' },
                { layer: 35, name: 'STRATEJIK_KARARLAR', group: 'OTRGGA_NOKTASAL' },
                { layer: 36, name: 'SIT_ALANLARI_NOKTA', group: 'OTRGGA_NOKTASAL' },
                { layer: 37, name: 'HAVAYOLLARI_NOKTA', group: 'OTRGGA_NOKTASAL' },
                { layer: 38, name: 'DIGER_KORUMA_ALANLARI_NOKTA', group: 'OTRGGA_NOKTASAL' },
                { layer: 39, name: 'DIGER_ARAZI_KULLANIM_ALANLARI_NOKTA', group: 'OTRGGA_NOKTASAL' },
                { layer: 40, name: 'CALISMA_ALANLARI_NOKTA', group: 'OTRGGA_NOKTASAL' },
                { layer: 41, name: 'BUYUK_VE_ACIK_ALAN_KULLANISLARI_NOKTA', group: 'OTRGGA_NOKTASAL' },
                { layer: 42, name: 'ATIK_VE_ARITMA_TESISLERI_NOKTA', group: 'OTRGGA_NOKTASAL' },
                { layer: 43, name: 'IDARI_MERKEZLER_NOKTA', group: 'OTRGGA_NOKTASAL' },
                { layer: 44, name: 'DENIZYOLLARI_VE_KIYI_YAPILARI_NOKTA', group: 'OTRGGA_NOKTASAL' }
            ],
            zbk: [
                // PL_ALAN (Area layers)
                { layer: 1, name: 'osb_yeni', group: 'ZBK_ALANSAL' },
                { layer: 2, name: 'milletbahcesi', group: 'ZBK_ALANSAL' },
                { layer: 3, name: 'KiyiYonetimiAltProje', group: 'ZBK_ALANSAL' },
                { layer: 4, name: 'Hidroelektrik_Santraller', group: 'ZBK_ALANSAL' },
                { layer: 5, name: 'Akarsu', group: 'ZBK_ALANSAL' },
                { layer: 6, name: 'Barajlar', group: 'ZBK_ALANSAL' },
                { layer: 7, name: 'Askeri_Alan', group: 'ZBK_ALANSAL' },
                { layer: 8, name: 'SulamaAlani', group: 'ZBK_ALANSAL' },
                { layer: 9, name: 'Plan_Kararlari', group: 'ZBK_ALANSAL' },
                { layer: 10, name: 'Mera_birlesik', group: 'ZBK_ALANSAL' },
                { layer: 11, name: 'Orman_birlesik', group: 'ZBK_ALANSAL' },
                { layer: 12, name: 'Tarim_birlesik', group: 'ZBK_ALANSAL' },
                // PL_CIZGI (Line layers)
                { layer: 14, name: 'ElektrikHatti', group: 'ZBK_CIZGISEL' },
                { layer: 15, name: 'Belediye_Sinirlari', group: 'ZBK_CIZGISEL' },
                { layer: 16, name: 'DenizYolu_Yazi', group: 'ZBK_CIZGISEL' },
                { layer: 17, name: 'DenizYolu_Tum_Plan', group: 'ZBK_CIZGISEL' },
                { layer: 18, name: 'Havza_Siniri', group: 'ZBK_CIZGISEL' },
                { layer: 19, name: 'Komur_Havzalari', group: 'ZBK_CIZGISEL' },
                { layer: 20, name: 'Demiryolu', group: 'ZBK_CIZGISEL' },
                { layer: 21, name: 'DemiryoluOneri', group: 'ZBK_CIZGISEL' },
                { layer: 22, name: 'Dogalgaz_Boru_Hatti', group: 'ZBK_CIZGISEL' },
                { layer: 23, name: 'Ulasim', group: 'ZBK_CIZGISEL' },
                { layer: 24, name: 'Il_Siniri', group: 'ZBK_CIZGISEL' },
                { layer: 25, name: 'PlanlamaBolgesiSiniri', group: 'ZBK_CIZGISEL' },
                { layer: 26, name: 'Ilce_Siniri', group: 'ZBK_CIZGISEL' },
                { layer: 27, name: 'AkarsuCizgi', group: 'ZBK_CIZGISEL' },
                { layer: 28, name: 'BarajKorumaalanlari_2009', group: 'ZBK_CIZGISEL' },
                { layer: 29, name: 'Mania_Siniri', group: 'ZBK_CIZGISEL' },
                { layer: 30, name: 'KORUMA_ALAN_VE_SINIRLARI', group: 'ZBK_CIZGISEL' },
                { layer: 31, name: 'MilliParkPlanlama_B', group: 'ZBK_CIZGISEL' },
                { layer: 32, name: 'TabiatiKorumaAlanlari_K', group: 'ZBK_CIZGISEL' },
                { layer: 33, name: 'YabanHayatiKorumaAlanlari_K', group: 'ZBK_CIZGISEL' },
                { layer: 34, name: 'YENICE_ORMANLARI', group: 'ZBK_CIZGISEL' },
                { layer: 35, name: 'TURIZM_KONAKLAMA_KORIDORLARI', group: 'ZBK_CIZGISEL' },
                { layer: 36, name: 'Ekolojik_Oneme_Sahip_Alanlar', group: 'ZBK_CIZGISEL' },
                { layer: 37, name: 'Dere_Yatagi', group: 'ZBK_CIZGISEL' },
                // PL_NOKTA (Point layers)
                { layer: 39, name: 'Enerji_Uretim_Alani', group: 'ZBK_NOKTASAL' },
                { layer: 40, name: 'TeknikAltyapi', group: 'ZBK_NOKTASAL' },
                { layer: 41, name: 'Koyler', group: 'ZBK_NOKTASAL' },
                { layer: 42, name: 'osbn_yeni', group: 'ZBK_NOKTASAL' },
                { layer: 43, name: 'Il_Merkezi', group: 'ZBK_NOKTASAL' },
                { layer: 44, name: 'Belde_Merkezi', group: 'ZBK_NOKTASAL' },
                { layer: 45, name: 'Ilce_Merkezi', group: 'ZBK_NOKTASAL' },
                { layer: 46, name: 'KullanimAlanlari_Point', group: 'ZBK_NOKTASAL' },
                { layer: 47, name: 'Kulturel_Tarihsel_CevreKoruma_Alanlari', group: 'ZBK_NOKTASAL' },
                { layer: 48, name: 'Gunubirlik_Tesis_Alanlari', group: 'ZBK_NOKTASAL' },
                { layer: 49, name: 'Tersane', group: 'ZBK_NOKTASAL' },
                { layer: 50, name: 'Ulasim_Projeleri', group: 'ZBK_NOKTASAL' },
                { layer: 51, name: 'Balikci_Barinaklari', group: 'ZBK_NOKTASAL' },
                { layer: 52, name: 'Termik_Santraller', group: 'ZBK_NOKTASAL' },
                { layer: 53, name: 'Hidroelektrik_Santraller_Nokta', group: 'ZBK_NOKTASAL' }
            ],
            bartin25: [
                // PLAN layers (from GetCapabilities)
                { layer: 2, name: 'ASKERİ_ALANLAR', group: 'PLAN' },
                { layer: 3, name: 'DSİ SULAMA ALANI', group: 'PLAN' },
                { layer: 4, name: 'SİT ALANLARI', group: 'PLAN' },
                { layer: 5, name: 'HAVAALANI KORUMA BANDI VE UÇUŞ KORİDORU', group: 'PLAN' },
                { layer: 6, name: 'KARAYOLU', group: 'PLAN' },
                { layer: 7, name: 'FAY_MUHTEMEL', group: 'PLAN' },
                { layer: 8, name: 'DERE_TASKIN', group: 'PLAN' },
                { layer: 9, name: 'HATLAR', group: 'PLAN' },
                { layer: 10, name: 'KAVSAKLAR', group: 'PLAN' },
                { layer: 11, name: 'KORUMA_KUSAKLARI', group: 'PLAN' },
                { layer: 13, name: 'DİKİLİ TARIM ALANI', group: 'PLAN' },
                { layer: 14, name: 'ÖZEL ÜRÜN TARIM ALANI', group: 'PLAN' },
                { layer: 15, name: 'ORMAN', group: 'PLAN' },
                { layer: 16, name: 'ÇAYIR - MERA', group: 'PLAN' },
                { layer: 17, name: 'MUTLAK TARIM ALANI', group: 'PLAN' },
                { layer: 18, name: 'MARJİNAL TARIM ALANI', group: 'PLAN' },
                { layer: 19, name: 'AĞAÇLANDIRILACAK ALANLAR', group: 'PLAN' },
                { layer: 20, name: 'BUYUK KENTSEL YESIL', group: 'PLAN' },
                { layer: 21, name: 'TURİZM TESİS ALANLARI', group: 'PLAN' },
                { layer: 22, name: 'TERMİNAL', group: 'PLAN' },
                { layer: 23, name: 'SANAYİ BÖLGESİ', group: 'PLAN' },
                { layer: 24, name: 'ORGANİZE SANAYİ BÖLGESİ', group: 'PLAN' },
                { layer: 25, name: 'AKARSU', group: 'PLAN' },
                { layer: 26, name: 'BARTIN_OSB_DERE_ISLAHI', group: 'PLAN' },
                { layer: 27, name: 'ORGANİZE HAYVANCILIK ALANI', group: 'PLAN' },
                { layer: 28, name: 'ÜNİVERSİTE KAMPUS ALANLARI', group: 'PLAN' },
                { layer: 29, name: 'HIZMET_MERKEZI', group: 'PLAN' },
                { layer: 30, name: 'KENTSEL_HIZMET_MERKEZI', group: 'PLAN' },
                { layer: 31, name: 'LİMAN_TEKNEİMAL_SAHİL', group: 'PLAN' },
                { layer: 32, name: 'KÜÇÜK SANAYİ', group: 'PLAN' },
                { layer: 33, name: 'KIRSAL YERLEŞİK ALAN', group: 'PLAN' },
                { layer: 34, name: 'GELİŞME KONUT ALANI', group: 'PLAN' },
                { layer: 35, name: 'KENTSEL YERLEŞİK ALAN', group: 'PLAN' },
                { layer: 36, name: 'KONUTDIŞI KENTSEL ÇALIŞMA ALANI', group: 'PLAN' },
                { layer: 37, name: 'KATI ATIK DEPOLAMA ALANLARI', group: 'PLAN' },
                { layer: 38, name: 'GUNUBIRLIK_TESIS', group: 'PLAN' },
                { layer: 39, name: 'DONATILAR', group: 'PLAN' },
                { layer: 40, name: 'DEPOLAMA', group: 'PLAN' },
                { layer: 41, name: 'ARITMA TESİSİ', group: 'PLAN' },
                { layer: 42, name: 'DSİ TAŞKIN KORUMA TESİSİ', group: 'PLAN' },
                { layer: 43, name: 'ASKERİ_ALANLAR', group: 'PLAN' },
                { layer: 44, name: 'YAT LİMANI- BALIKÇI BARINAKLARI', group: 'PLAN' },
                { layer: 45, name: 'GÖL-GÖLET', group: 'PLAN' },
                { layer: 46, name: 'BARAJLAR', group: 'PLAN' },
                { layer: 47, name: 'SINIRLAR', group: 'PLAN' },
                { layer: 49, name: 'İSTİKAMET_KARAYOLU', group: 'PLAN' },
                { layer: 50, name: 'ÜNİVERSİTE', group: 'PLAN' },
                { layer: 51, name: 'TERMİNAL', group: 'PLAN' },
                { layer: 52, name: 'SİT', group: 'PLAN' },
                { layer: 53, name: 'SOSYAL DONATI -SPOR', group: 'PLAN' },
                { layer: 54, name: 'OSB', group: 'PLAN' },
                { layer: 55, name: 'OHA', group: 'PLAN' },
                { layer: 56, name: 'KATI ATIK DEPOLAMA', group: 'PLAN' },
                { layer: 57, name: 'REVIZYON_SEMBOL', group: 'PLAN' },
                { layer: 58, name: 'GÜNÜBİRLİK_SEMBOL', group: 'PLAN' },
                { layer: 59, name: 'ARITMA_TESİSİ', group: 'PLAN' },
                { layer: 60, name: 'HES', group: 'PLAN' },
                { layer: 61, name: 'LİMAN_YAT_LİMAN', group: 'PLAN' },
                { layer: 62, name: 'HİZMET MERKEZLERİ', group: 'PLAN' },
                { layer: 63, name: 'ENERJI_URETIM_ALANI', group: 'ENERJI_URETIM_ALANI' },
                { layer: 64, name: 'milletbahcesi', group: 'milletbahcesi' },
                { layer: 65, name: 'ENERJİ ÜRETİM ALANI', group: 'ENERJİ ÜRETİM ALANI' },
                { layer: 66, name: 'milletbahcesin', group: 'milletbahcesin' }
            ],
            mbssh: [
                // ALANSAL KARARLAR (Area decisions) - PLAN
                { layer: 1, name: 'ORMANVEAGACLANDIRILACAKA', group: 'MBSSH_ALANSAL' },
                { layer: 2, name: 'DOĞAL KARAKTERİ KORUNACAK ALANLAR', group: 'MBSSH_ALANSAL' },
                { layer: 3, name: 'TARIMSAL ARAZİ KULLANIMLARI', group: 'MBSSH_ALANSAL' },
                { layer: 4, name: 'DOĞAL KARAKTERİ KORUNACAK ALANLAR', group: 'MBSSH_ALANSAL' },
                { layer: 5, name: 'TARIMSAL ARAZİ KULLANIMLARI', group: 'MBSSH_ALANSAL' },
                { layer: 6, name: 'TARIMSAL ARAZİ KULLANIMLARI', group: 'MBSSH_ALANSAL' },
                { layer: 7, name: 'ENERJİ - SULAMA (ALAN)', group: 'MBSSH_ALANSAL' },
                { layer: 8, name: 'HAVAYOLLARI (ALAN)', group: 'MBSSH_ALANSAL' },
                { layer: 9, name: 'DİĞER KORUMA ALANLARI (ALAN)', group: 'MBSSH_ALANSAL' },
                { layer: 10, name: 'SU YÜZEYLERİ', group: 'MBSSH_ALANSAL' },
                { layer: 11, name: 'KULLANIM SINIRLAMASI GETİRİLEN ALANLAR', group: 'MBSSH_ALANSAL' },
                { layer: 12, name: 'SU YÜZEYLERİ (ÇİZGİ)', group: 'MBSSH_ALANSAL' },
                { layer: 13, name: 'SUYUZEYLERIA', group: 'MBSSH_ALANSAL' },
                { layer: 14, name: 'DİĞER KORUMA ALANLARI (ALAN)', group: 'MBSSH_ALANSAL' },
                { layer: 15, name: 'YERLEŞİM ALANLARI', group: 'MBSSH_ALANSAL' },
                { layer: 16, name: 'ÇALIŞMA ALANLARI', group: 'MBSSH_ALANSAL' },
                { layer: 17, name: 'TURİZM ALANLARI', group: 'MBSSH_ALANSAL' },
                { layer: 18, name: 'DİĞER ARAZİ KULLANIM ALANLARI (ALAN)', group: 'MBSSH_ALANSAL' },
                { layer: 19, name: 'BÜYÜK VE AÇIK ALAN KULLANIŞLARI', group: 'MBSSH_ALANSAL' },
                { layer: 20, name: 'SİT ALANLARI (ALAN)', group: 'MBSSH_ALANSAL' },
                // ÇİZGİSEL KARARLAR (Linear decisions)
                { layer: 21, name: 'ENERJİ - SULAMA (ÇİZGİ)', group: 'MBSSH_CIZGISEL' },
                { layer: 22, name: 'SU KAYNAKLARI KORUMA ALANLARI', group: 'MBSSH_CIZGISEL' },
                { layer: 23, name: 'HAVAYOLLARI (ÇİZGİ)', group: 'MBSSH_CIZGISEL' },
                { layer: 24, name: 'DEMİRYOLLARI', group: 'MBSSH_CIZGISEL' },
                { layer: 25, name: 'KARAYOLLARI (ÇİZGİ)', group: 'MBSSH_CIZGISEL' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 26, name: 'TURİZM ALANLARI (NOKTA)', group: 'MBSSH_NOKTASAL' },
                { layer: 27, name: 'TURİZM ALANLARI (NOKTA)', group: 'MBSSH_NOKTASAL' },
                { layer: 28, name: 'ATIK VE ARITMA TESİSLERİ (NOKTA)', group: 'MBSSH_NOKTASAL' },
                { layer: 29, name: 'SİT ALANLARI (NOKTA)', group: 'MBSSH_NOKTASAL' },
                { layer: 30, name: 'HAVAYOLLARI (NOKTA)', group: 'MBSSH_NOKTASAL' },
                { layer: 31, name: 'ENERJİ - SULAMA (NOKTA)', group: 'MBSSH_NOKTASAL' },
                { layer: 32, name: 'BÜYÜK VE AÇIK ALAN KULLANIŞLARI (NOKTA)', group: 'MBSSH_NOKTASAL' },
                { layer: 33, name: 'DENİZYOLLARI VE KIYI YAPILARI (NOKTA)', group: 'MBSSH_NOKTASAL' },
                { layer: 34, name: 'DİĞER ARAZİ KULLANIM ALANLARI (NOKTA)', group: 'MBSSH_NOKTASAL' },
                { layer: 35, name: 'İDARİ MERKEZLER (NOKTA)', group: 'MBSSH_NOKTASAL' },
                { layer: 36, name: 'SINIR KAPILARI', group: 'MBSSH_NOKTASAL' },
                { layer: 37, name: 'ÇALIŞMA ALANLARI', group: 'MBSSH_NOKTASAL' },
                { layer: 38, name: 'ÇALIŞMA ALANLARI (NOKTA)', group: 'MBSSH_NOKTASAL' },
                { layer: 39, name: 'PLANLAMA BÖLGESİ', group: 'MBSSH_CIZGISEL' },
                // MPYY layers (Plan changes)
                { layer: 40, name: 'kentsel_servis_mpyy', group: 'MBSSH_MPYY' },
                { layer: 41, name: 'osb_mpyy', group: 'MBSSH_MPYY' },
                { layer: 42, name: 'OEB_mpyy', group: 'MBSSH_MPYY' },
                { layer: 43, name: 'osb_mpyy_nokta', group: 'MBSSH_MPYY' },
                { layer: 44, name: 'OEB_mpyy_nokta', group: 'MBSSH_MPYY' },
                { layer: 45, name: 'Siirt_Degisiklik_09092020', group: 'MBSSH_DEGISIKLIK' },
                { layer: 47, name: 'dogal_karakteri_korunacak_aln_mpyy', group: 'MBSSH_MPYY' },
                { layer: 48, name: 'kentsel_meskun_mpyy', group: 'MBSSH_MPYY' },
                { layer: 49, name: 'kentsel_gelisme_mpyy', group: 'MBSSH_MPYY' },
                { layer: 50, name: 'kentsel_ve_bölgesel_yeşil_ve_spor_mpyy', group: 'MBSSH_MPYY' },
                // Mardin Plan change layers
                { layer: 52, name: 'ORMAN ALANI (ALAN)', group: 'MBSSH_DEGISIKLIK' },
                { layer: 53, name: 'YERLEŞİM ALANLARI (ALAN)', group: 'MBSSH_DEGISIKLIK' },
                { layer: 54, name: 'KENTSEL_ÇALIŞMA_ALANI (ALAN)', group: 'MBSSH_DEGISIKLIK' },
                { layer: 55, name: 'BÜYÜK VE AÇIK ALAN KULLANIŞLARI (ALAN)', group: 'MBSSH_DEGISIKLIK' },
                { layer: 56, name: 'SİT_ALANLARI (ALAN)', group: 'MBSSH_DEGISIKLIK' },
                { layer: 57, name: 'HAVAYOLLARI (ÇİZGİ)', group: 'MBSSH_DEGISIKLIK' },
                { layer: 58, name: 'İDARİ MERKEZLER (NOKTA)(bütüncül)', group: 'MBSSH_DEGISIKLIK' },
                { layer: 59, name: 'KARAYOLLARI (ÇİZGİ) (bütüncül)', group: 'MBSSH_DEGISIKLIK' },
                { layer: 60, name: 'ÇEVREYOLU (ÇİZGİ)', group: 'MBSSH_DEGISIKLIK' },
                { layer: 61, name: 'BUYUKVEACIKALANKULLANISLARI (NOKTA)', group: 'MBSSH_DEGISIKLIK' },
                { layer: 62, name: 'SİT_ALANLARI (NOKTA)', group: 'MBSSH_DEGISIKLIK' },
                { layer: 63, name: 'KARAYOLLARI (ÇİZGİ)', group: 'MBSSH_DEGISIKLIK' },
                { layer: 64, name: 'ASKERI_ALAN_MPYY', group: 'MBSSH_MPYY' },
                { layer: 65, name: 'UCUNCU_DERECE_YOL_MPYY', group: 'MBSSH_MPYY' },
                { layer: 66, name: 'IKINCI_DERECE_YOL_MPYY', group: 'MBSSH_MPYY' },
                { layer: 67, name: 'birinci_dereceyol_mpyy', group: 'MBSSH_MPYY' },
                { layer: 68, name: 'tarim_alani', group: 'MBSSH_MPYY' },
                { layer: 69, name: 'OTOYOL_MPYY', group: 'MBSSH_MPYY' },
                { layer: 70, name: 'SINIRLAR', group: 'MBSSH_CIZGISEL' }
            ],
            eeb: [
                // ALANSAL KARARLAR (Area decisions)
                { layer: 1, name: 'tarım_orman_shp', group: 'EEB_ALANSAL' },
                { layer: 2, name: 'sulama', group: 'EEB_ALANSAL' },
                { layer: 3, name: 'KENTSEL_GELISME_ALANI', group: 'EEB_ALANSAL' },
                { layer: 4, name: 'PLAN_TEKRENK', group: 'EEB_ALANSAL' },
                { layer: 5, name: 'PLAN_CDP_ONERI_SEMATIK_', group: 'EEB_ALANSAL' },
                { layer: 7, name: 'SU YÜZEYLERİ', group: 'EEB_ALANSAL' },
                { layer: 11, name: 'SITA', group: 'EEB_ALANSAL' },
                { layer: 13, name: 'DIGERKORUMAALANLARIA', group: 'EEB_ALANSAL' },
                { layer: 14, name: 'OZELKANUNLARATABIALANLAR', group: 'EEB_ALANSAL' },
                // ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 6, name: 'akarsu', group: 'EEB_CIZGISEL' },
                { layer: 8, name: 'KARAYOLLARIC_kentiçi', group: 'EEB_CIZGISEL' },
                { layer: 9, name: 'KARAYOLLARIC', group: 'EEB_CIZGISEL' },
                { layer: 10, name: 'DEMIRYOLLARI', group: 'EEB_CIZGISEL' },
                { layer: 12, name: 'ENERJISULAMAC', group: 'EEB_CIZGISEL' },
                { layer: 16, name: 'SINIRLAR', group: 'EEB_CIZGISEL' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 17, name: 'PLAN_CDP_ONERI_point_2', group: 'EEB_NOKTASAL' },
                { layer: 18, name: 'SITN', group: 'EEB_NOKTASAL' },
                // İDARİ MERKEZLER (Administrative centers)
                { layer: 20, name: 'IDARIMERKEZLER_KÖY', group: 'EEB_IDARI' },
                { layer: 21, name: 'IDARIMERKEZLER_BELDE', group: 'EEB_IDARI' },
                { layer: 22, name: 'IDARIMERKEZLER_ILCE', group: 'EEB_IDARI' },
                { layer: 23, name: 'IDARIMERKEZLER_IL', group: 'EEB_IDARI' }
            ],
            bilecik: [
                // ALANSAL KARARLAR (Area decisions)
                { layer: 1, name: 'Toprak_Clip', group: 'BILECIK_ALANSAL' },
                { layer: 2, name: 'AGACLANDIRMA_SAHALARI', group: 'BILECIK_ALANSAL' },
                { layer: 4, name: 'HEYELAN_ALANLARI', group: 'BILECIK_ALANSAL' },
                { layer: 5, name: 'SIVILASMA_RISKLI', group: 'BILECIK_ALANSAL' },
                { layer: 6, name: 'SAKARYA_VADISI_TARIM_ALANI', group: 'BILECIK_ALANSAL' },
                { layer: 8, name: 'GOL', group: 'BILECIK_ALANSAL' },
                { layer: 9, name: 'Askeri_Alan', group: 'BILECIK_ALANSAL' },
                { layer: 10, name: 'YERLEŞİMLER MAHALLE-KÖY', group: 'BILECIK_ALANSAL' },
                { layer: 11, name: 'YERLESIMLER', group: 'BILECIK_ALANSAL' },
                { layer: 12, name: 'OSB', group: 'BILECIK_ALANSAL' },
                { layer: 13, name: 'MADEN_SAHALARI', group: 'BILECIK_ALANSAL' },
                { layer: 14, name: 'GOLET_BARAJ', group: 'BILECIK_ALANSAL' },
                { layer: 15, name: 'SULAMA', group: 'BILECIK_ALANSAL' },
                { layer: 16, name: 'Pasif_Alanlar', group: 'BILECIK_ALANSAL' },
                { layer: 17, name: 'OSB_MPYY', group: 'BILECIK_ALANSAL' },
                // ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 7, name: 'Akarsu_isim', group: 'BILECIK_CIZGISEL' },
                { layer: 20, name: 'Yollar', group: 'BILECIK_CIZGISEL' },
                { layer: 21, name: 'DEMIRYOLLARI', group: 'BILECIK_CIZGISEL' },
                { layer: 22, name: 'AKARSU', group: 'BILECIK_CIZGISEL' },
                { layer: 23, name: 'DOGAL_GAZ_HATTI', group: 'BILECIK_CIZGISEL' },
                { layer: 24, name: 'Karasu_Mansap_Koruma_Alanı', group: 'BILECIK_CIZGISEL' },
                { layer: 25, name: 'Karasu_Memba_Koruma_Aln', group: 'BILECIK_CIZGISEL' },
                { layer: 26, name: 'Karasu_Icme_Suyu_Hatti', group: 'BILECIK_CIZGISEL' },
                { layer: 27, name: 'ELEK_PET_DOG', group: 'BILECIK_CIZGISEL' },
                { layer: 28, name: 'BELEDIYE_SINIRI', group: 'BILECIK_CIZGISEL' },
                { layer: 29, name: 'İlçe Sınırı', group: 'BILECIK_CIZGISEL' },
                { layer: 30, name: 'İl Sınırı', group: 'BILECIK_CIZGISEL' },
                { layer: 31, name: 'bilecik_3_osb', group: 'BILECIK_CIZGISEL' },
                { layer: 43, name: 'KARAYOLLARI', group: 'BILECIK_CIZGISEL' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 33, name: 'Mevcut_Sanayi_Alanlari_Featu', group: 'BILECIK_NOKTASAL' },
                { layer: 34, name: 'MADEN_ISLETME', group: 'BILECIK_NOKTASAL' },
                { layer: 35, name: 'Kanalizasyon_Desarj_Noktaları', group: 'BILECIK_NOKTASAL' },
                { layer: 36, name: 'HES', group: 'BILECIK_NOKTASAL' },
                { layer: 37, name: 'SIT_ALANLARI', group: 'BILECIK_NOKTASAL' },
                { layer: 39, name: 'Gelisme_Aks_Kırsal', group: 'BILECIK_NOKTASAL' },
                { layer: 40, name: 'Gelisme_Aks_Kentsel', group: 'BILECIK_NOKTASAL' },
                { layer: 41, name: 'GELISME_ALANLARI_IMP', group: 'BILECIK_NOKTASAL' },
                { layer: 42, name: 'Gelisme_Alanlari', group: 'BILECIK_NOKTASAL' },
                { layer: 44, name: 'SOSYO_KULTUREL_DONATI', group: 'BILECIK_NOKTASAL' },
                { layer: 45, name: 'SANAYI_ALANLARI', group: 'BILECIK_NOKTASAL' },
                { layer: 46, name: 'EKONOMIK_YAPI', group: 'BILECIK_NOKTASAL' },
                { layer: 47, name: 'ALT_YAPI', group: 'BILECIK_NOKTASAL' },
                { layer: 48, name: 'Kavsaklar', group: 'BILECIK_NOKTASAL' },
                { layer: 49, name: 'İstasyonlar', group: 'BILECIK_NOKTASAL' },
                { layer: 50, name: 'Alternatif_Enerji', group: 'BILECIK_NOKTASAL' },
                { layer: 51, name: 'osb_mpyy_sembol', group: 'BILECIK_NOKTASAL' }
            ],
            mbv: [
                // ALANSAL KARARLAR (Area decisions)
                { layer: 0, name: 'SEMA_RN', group: 'MBV_ALANSAL' },
                { layer: 1, name: 'SEMA_Baraj', group: 'MBV_ALANSAL' },
                { layer: 2, name: 'SEMA_t', group: 'MBV_ALANSAL' },
                { layer: 3, name: 'SEMA_OL', group: 'MBV_ALANSAL' },
                { layer: 4, name: 'Doğa Koruma Alanları', group: 'MBV_ALANSAL' },
                { layer: 5, name: 'Sit Alanları', group: 'MBV_ALANSAL' },
                { layer: 6, name: 'Turizm Merkezi ve Bölgeleri (Alan)', group: 'MBV_ALANSAL' },
                { layer: 7, name: 'Sulama Alanları', group: 'MBV_ALANSAL' },
                { layer: 8, name: 'OnemliDogaAlanlari_Sinir', group: 'MBV_ALANSAL' },
                { layer: 9, name: 'Sulak Alanlar-Sazlıklar-Deltalar', group: 'MBV_ALANSAL' },
                { layer: 10, name: 'AfetKotu_1650', group: 'MBV_ALANSAL' },
                { layer: 22, name: 'JEOLOJİK_SAKINCALI_ALAN', group: 'MBV_ALANSAL' },
                // ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 11, name: 'AkarsuCizgi', group: 'MBV_CIZGISEL' },
                { layer: 12, name: 'DogalHattiTechizat', group: 'MBV_CIZGISEL' },
                { layer: 13, name: 'Demiryolu', group: 'MBV_CIZGISEL' },
                { layer: 14, name: 'Plan_Karayollari', group: 'MBV_CIZGISEL' },
                { layer: 15, name: 'Mania', group: 'MBV_CIZGISEL' },
                { layer: 16, name: 'Enerji İletim Hatları', group: 'MBV_CIZGISEL' },
                { layer: 17, name: 'BelediyeSiniri_Cizgi', group: 'MBV_CIZGISEL' },
                { layer: 18, name: 'Turizm Merkezi ve Bölgeleri (Çizgi)', group: 'MBV_CIZGISEL' },
                { layer: 19, name: 'Ilce_Cızgı', group: 'MBV_CIZGISEL' },
                { layer: 20, name: 'Plan Onama Sınırı', group: 'MBV_CIZGISEL' },
                { layer: 21, name: 'Tatvan-Van Feribot Seferleri', group: 'MBV_CIZGISEL' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 23, name: 'Karayolu Yön Oku', group: 'MBV_NOKTASAL' },
                { layer: 25, name: 'TumYerlesimMerkezleri', group: 'MBV_NOKTASAL' },
                { layer: 27, name: 'TeknikAltyapi_Nokta', group: 'MBV_NOKTASAL' },
                { layer: 28, name: 'SitAlanlari_Nokta', group: 'MBV_NOKTASAL' },
                { layer: 29, name: 'Havaalani', group: 'MBV_NOKTASAL' },
                { layer: 30, name: 'Feribot İskelesi', group: 'MBV_NOKTASAL' },
                { layer: 31, name: 'SEMA_Point', group: 'MBV_NOKTASAL' },
                { layer: 32, name: 'SEMA_1_Nokta', group: 'MBV_NOKTASAL' }
            ],
            bolu: [
                // Raster layer - CDP Plan
                { layer: 0, name: 'BOLU_CDP_K', group: 'BOLU_RASTER' }
            ],
            sct: [
                // ALANSAL KARARLAR (Area decisions)
                { layer: 1, name: 'SAK_83', group: 'SCT_ALANSAL' },
                { layer: 2, name: 'TERSANE_83', group: 'SCT_ALANSAL' },
                { layer: 3, name: 'KENTSEL_SERVIS', group: 'SCT_ALANSAL' },
                { layer: 4, name: 'RADIKAL_PLAN', group: 'SCT_ALANSAL' },
                { layer: 5, name: '83_BELDELER', group: 'SCT_ALANSAL' },
                { layer: 6, name: 'YABAN', group: 'SCT_ALANSAL' },
                { layer: 7, name: 'TKA', group: 'SCT_ALANSAL' },
                { layer: 8, name: 'KENTSEL', group: 'SCT_ALANSAL' },
                { layer: 9, name: 'DOGAL', group: 'SCT_ALANSAL' },
                { layer: 10, name: 'ARKEO', group: 'SCT_ALANSAL' },
                { layer: 11, name: 'RAMSAR', group: 'SCT_ALANSAL' },
                { layer: 12, name: 'HAVAALANI', group: 'SCT_ALANSAL' },
                { layer: 14, name: 'GOL', group: 'SCT_ALANSAL' },
                { layer: 15, name: 'gol', group: 'SCT_ALANSAL' },
                { layer: 16, name: 'KORUMA', group: 'SCT_ALANSAL' },
                { layer: 19, name: 'BARAJ_TR83', group: 'SCT_ALANSAL' },
                { layer: 24, name: 'BUYUKSEHIR', group: 'SCT_ALANSAL' },
                { layer: 25, name: 'TR83_TOURISM', group: 'SCT_ALANSAL' },
                { layer: 29, name: 'altbolgeozelprojalanı', group: 'SCT_ALANSAL' },
                { layer: 30, name: 'altbolge', group: 'SCT_ALANSAL' },
                { layer: 42, name: 'SCT_MilliParkA', group: 'SCT_ALANSAL' },
                { layer: 44, name: 'Tabiat_parki', group: 'SCT_ALANSAL' },
                { layer: 45, name: 'SCT_PL_askeri_alan', group: 'SCT_ALANSAL' },
                { layer: 46, name: 'SulakAlan', group: 'SCT_ALANSAL' },
                // ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 17, name: 'DERELER', group: 'SCT_CIZGISEL' },
                { layer: 18, name: 'DENIZCILIK_83', group: 'SCT_CIZGISEL' },
                { layer: 20, name: 'MaviAkim', group: 'SCT_CIZGISEL' },
                { layer: 22, name: 'IDARI_L', group: 'SCT_CIZGISEL' },
                { layer: 23, name: 'SCT_PL_BsehirBeldeBldSinirL', group: 'SCT_CIZGISEL' },
                { layer: 26, name: '83_YOL_ONERISI', group: 'SCT_CIZGISEL' },
                { layer: 31, name: 'SCT_BotasTasimaL', group: 'SCT_CIZGISEL' },
                { layer: 39, name: 'SCT_PL_SinirlarL', group: 'SCT_CIZGISEL' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 28, name: 'LIMAN', group: 'SCT_NOKTASAL' },
                { layer: 33, name: 'tr83_yazi', group: 'SCT_NOKTASAL' },
                { layer: 34, name: 'TR83_YAZI_IL', group: 'SCT_NOKTASAL' },
                { layer: 35, name: 'TR83_YAZI_ILCE', group: 'SCT_NOKTASAL' },
                { layer: 36, name: 'TR83_KOY_NOKTA', group: 'SCT_NOKTASAL' },
                { layer: 37, name: 'PLAN_NOKTA', group: 'SCT_NOKTASAL' },
                { layer: 38, name: 'MANIA_83', group: 'SCT_NOKTASAL' },
                { layer: 40, name: 'SCT_SitAlanN', group: 'SCT_NOKTASAL' },
                { layer: 41, name: 'TERSANE_N', group: 'SCT_NOKTASAL' },
                { layer: 43, name: 'Tabiat_parki_sembol', group: 'SCT_NOKTASAL' }
            ],
            im: [
                // ALANSAL KARARLAR (Area decisions)
                { layer: 2, name: 'ARAZIKULLANIMI RENK', group: 'IM_ALANSAL' },
                { layer: 3, name: 'ARAZIKULLANIMI TARAMA', group: 'IM_ALANSAL' },
                { layer: 4, name: 'DİĞER ARAZİ KULLANIM ALANLARI (ALAN)', group: 'IM_ALANSAL' },
                { layer: 5, name: 'ENERJİ - SULAMA (ALAN)', group: 'IM_ALANSAL' },
                { layer: 6, name: 'ÖZEL KANUNLARA TABİ ALANLAR', group: 'IM_ALANSAL' },
                { layer: 7, name: 'DİĞER KORUMA ALANLARI (ALAN)', group: 'IM_ALANSAL' },
                { layer: 8, name: 'ENDUSTRI_BOLGESI', group: 'IM_ALANSAL' },
                { layer: 9, name: 'SİT ALANLARI (ALAN)', group: 'IM_ALANSAL' },
                // ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 11, name: 'SU KAYNAKLARI KORUMA ALANLARI (ÇİZGİ)', group: 'IM_CIZGISEL' },
                { layer: 12, name: 'DİĞER KORUMA ALANLARI (ÇİZGİ)', group: 'IM_CIZGISEL' },
                { layer: 13, name: 'KARAYOLLARI (ÇİZGİ)', group: 'IM_CIZGISEL' },
                { layer: 14, name: 'HAVAYOLLARI (ÇİZGİ)', group: 'IM_CIZGISEL' },
                { layer: 15, name: 'HIZLI_TREN', group: 'IM_CIZGISEL' },
                { layer: 16, name: 'DEMİRYOLLARI', group: 'IM_CIZGISEL' },
                { layer: 17, name: 'ÖZEL KANUNLARA TABİ ALANLAR (ÇİZGİ)', group: 'IM_CIZGISEL' },
                { layer: 18, name: 'ENERJİ - SULAMA (ÇİZGİ)', group: 'IM_CIZGISEL' },
                { layer: 19, name: 'SU YÜZEYLERİ (ÇİZGİ)', group: 'IM_CIZGISEL' },
                // SINIRLAR (Borders)
                { layer: 21, name: 'SINIRLAR', group: 'IM_SINIRLAR' },
                { layer: 22, name: 'OPA_SINIR', group: 'IM_SINIRLAR' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 24, name: 'TURİZM ALANLARI (NOKTA)', group: 'IM_NOKTASAL' },
                { layer: 25, name: 'STRATEJİK KARARLAR (NOKTA)', group: 'IM_NOKTASAL' },
                { layer: 26, name: 'SİT ALANLARI (NOKTA)', group: 'IM_NOKTASAL' },
                { layer: 27, name: 'İDARİ MERKEZLER (NOKTA)', group: 'IM_NOKTASAL' },
                { layer: 28, name: 'HAVAYOLLARI (NOKTA)', group: 'IM_NOKTASAL' },
                { layer: 29, name: 'ENERJİ - SULAMA (NOKTA)', group: 'IM_NOKTASAL' },
                { layer: 30, name: 'DİĞER KORUMA ALANLARI (NOKTA)', group: 'IM_NOKTASAL' },
                { layer: 31, name: 'DİĞER ARAZİ KULLANIM ALANLARI (NOKTA)', group: 'IM_NOKTASAL' },
                { layer: 32, name: 'DENİZYOLLARI VE KIYI YAPILARI (NOKTA)', group: 'IM_NOKTASAL' },
                { layer: 33, name: 'ÇALIŞMA ALANLARI (NOKTA)', group: 'IM_NOKTASAL' },
                { layer: 34, name: 'BÜYÜK VE AÇIK ALAN KULLANIŞLARI (NOKTA)', group: 'IM_NOKTASAL' },
                { layer: 35, name: 'ATIK VE ARITMA TESİSLERİ (NOKTA)', group: 'IM_NOKTASAL' },
                { layer: 36, name: 'ENDUSTRI_BOLGESI_SEMBOL', group: 'IM_NOKTASAL' },
                { layer: 37, name: 'YENILENEBILIR_ENERJI_SEMBOL', group: 'IM_NOKTASAL' },
                { layer: 38, name: 'PLAN_DEG_ONAMA_SINIRI', group: 'IM_NOKTASAL' }
            ],
            kk: [
                // ALANSAL KARARLAR (Area decisions)
                { layer: 2, name: 'PLAN 100000 ARAZİ KULLANIM-RENK', group: 'KK_ALANSAL' },
                { layer: 3, name: 'PLAN 100000 ARAZİ KULLANIM-TARAMA', group: 'KK_ALANSAL' },
                { layer: 4, name: 'DİĞER KORUMA ALANLARI', group: 'KK_ALANSAL' },
                { layer: 5, name: 'ENERJİ-SULAMA (ALAN)', group: 'KK_ALANSAL' },
                { layer: 6, name: 'SİT ALANLARI', group: 'KK_ALANSAL' },
                // ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 8, name: 'ENERJİ-SULAMA (ÇİZGİ)', group: 'KK_CIZGISEL' },
                { layer: 9, name: 'AKARSULAR', group: 'KK_CIZGISEL' },
                { layer: 11, name: 'KARAYOLLARI-ÜÇÜNCÜ DERECE YOL', group: 'KK_CIZGISEL' },
                { layer: 12, name: 'KARAYOLLARI-İKİNCİ DERECE YOL', group: 'KK_CIZGISEL' },
                { layer: 13, name: 'KARAYOLLARI-BİRİNCİ DERECE YOL', group: 'KK_CIZGISEL' },
                { layer: 14, name: 'KARAYOLLARI-OTOYOL - EKSPRES YOL', group: 'KK_CIZGISEL' },
                { layer: 15, name: 'DEMİRYOLLARI', group: 'KK_CIZGISEL' },
                // SINIRLAR (Borders)
                { layer: 17, name: 'DİĞER KORUMA ALANI SINIRLARI', group: 'KK_SINIRLAR' },
                { layer: 18, name: 'SU KAYNAKLARI KORUMA ALAN SINIRLARI', group: 'KK_SINIRLAR' },
                { layer: 19, name: 'SULAK ALAN SINIRLARI', group: 'KK_SINIRLAR' },
                { layer: 20, name: 'ÖZEL KANUNLARA TABİ ALANLAR', group: 'KK_SINIRLAR' },
                { layer: 21, name: 'PLANLAMA SINIRLARI', group: 'KK_SINIRLAR' },
                { layer: 22, name: 'İDARİ SINIRLAR', group: 'KK_SINIRLAR' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 25, name: 'SİT ALANLARI (NOKTA)', group: 'KK_NOKTASAL' },
                { layer: 26, name: 'SİT ALANLARI (NOKTA) 2', group: 'KK_NOKTASAL' },
                { layer: 27, name: 'SİT ALANLARI (NOKTA) 3', group: 'KK_NOKTASAL' },
                { layer: 28, name: 'İDARİ MERKEZLER', group: 'KK_NOKTASAL' },
                { layer: 29, name: 'PLAN NOKTA', group: 'KK_NOKTASAL' },
                { layer: 30, name: 'Plan Değişikliği Sınırı', group: 'KK_NOKTASAL' }
            ],
            ysk: [
                // ALANSAL KARARLAR (Area decisions)
                { layer: 2, name: 'ORMAN VE AĞAÇLANDIRILACAK ALANLAR', group: 'YSK_ALANSAL' },
                { layer: 3, name: 'TARIMSAL ARAZİ KULLANIMLARI', group: 'YSK_ALANSAL' },
                { layer: 4, name: 'DOĞAL KARAKTERİ KORUNACAK ALANLAR', group: 'YSK_ALANSAL' },
                { layer: 5, name: 'DİĞER KORUMA ALANLARI', group: 'YSK_ALANSAL' },
                { layer: 6, name: 'ENERJİ-SULAMA (ALAN)', group: 'YSK_ALANSAL' },
                { layer: 8, name: 'DİĞER KORUMA ALANLARI 2', group: 'YSK_ALANSAL' },
                { layer: 9, name: 'YERLEŞİM', group: 'YSK_ALANSAL' },
                { layer: 10, name: 'TURİZM', group: 'YSK_ALANSAL' },
                { layer: 11, name: 'DİĞER ARAZİ KULLANIM', group: 'YSK_ALANSAL' },
                { layer: 12, name: 'BÜYÜK VE AÇIK ALAN KULLANIŞLARI', group: 'YSK_ALANSAL' },
                { layer: 13, name: 'ÇALIŞMA', group: 'YSK_ALANSAL' },
                { layer: 14, name: 'ATIK VE ARITMA TESİSLERİ', group: 'YSK_ALANSAL' },
                { layer: 15, name: 'HAVAYOLLARI', group: 'YSK_ALANSAL' },
                { layer: 16, name: 'ENERJİ-SULAMA (ALAN) 2', group: 'YSK_ALANSAL' },
                { layer: 18, name: 'SU YÜZEYLERİ', group: 'YSK_ALANSAL' },
                // ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 17, name: 'SU YÜZEYLERİ (ÇİZGİ)', group: 'YSK_CIZGISEL' },
                { layer: 19, name: 'SİT ALANLARI', group: 'YSK_CIZGISEL' },
                { layer: 20, name: 'YENİ YOL', group: 'YSK_CIZGISEL' },
                { layer: 21, name: 'KARAYOLLARI', group: 'YSK_CIZGISEL' },
                { layer: 22, name: 'DEMİRYOLLARI', group: 'YSK_CIZGISEL' },
                { layer: 23, name: 'ENERJİ-SULAMA (ÇİZGİ)', group: 'YSK_CIZGISEL' },
                // SINIRLAR (Borders)
                { layer: 24, name: 'DİĞER KORUMA ALANLARI SINIRLARI', group: 'YSK_SINIRLAR' },
                { layer: 25, name: 'SU KAYNAKLARI KORUMA SINIRLARI', group: 'YSK_SINIRLAR' },
                { layer: 26, name: 'ÖZEL KANUNLARA TABİ ALANLAR', group: 'YSK_SINIRLAR' },
                { layer: 27, name: 'ÖZEL KANUNLARA TABİ ALANLAR SINIRLARI', group: 'YSK_SINIRLAR' },
                { layer: 28, name: 'PLANLAMA SINIRLARI', group: 'YSK_SINIRLAR' },
                { layer: 29, name: 'SORUMLULUK SINIRI', group: 'YSK_SINIRLAR' },
                { layer: 30, name: 'SINIRLAR', group: 'YSK_SINIRLAR' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 32, name: 'KARAYOLLARI (NOKTA)', group: 'YSK_NOKTASAL' },
                { layer: 33, name: 'DEMİRYOLLARI (NOKTA)', group: 'YSK_NOKTASAL' },
                { layer: 34, name: 'DİĞER ARAZİ KULLANIM (NOKTA)', group: 'YSK_NOKTASAL' },
                { layer: 35, name: 'ATIK VE ARITMA TESİSLERİ (NOKTA)', group: 'YSK_NOKTASAL' },
                { layer: 36, name: 'ÇALIŞMA (NOKTA)', group: 'YSK_NOKTASAL' },
                { layer: 37, name: 'YENİLENEBİLİR ENERJİ', group: 'YSK_NOKTASAL' },
                { layer: 38, name: 'BÜYÜK VE AÇIK ALAN KULLANIŞLARI (NOKTA)', group: 'YSK_NOKTASAL' },
                { layer: 39, name: 'TURİZM (NOKTA)', group: 'YSK_NOKTASAL' },
                { layer: 40, name: 'SİT ALANLARI (NOKTA)', group: 'YSK_NOKTASAL' },
                { layer: 41, name: 'HAVAYOLLARI (NOKTA)', group: 'YSK_NOKTASAL' },
                { layer: 43, layers: '43,44,45,46', name: 'İDARİ MERKEZLER', group: 'YSK_NOKTASAL' }
            ],
            kilis: [
                // ALANSAL KARARLAR (Area decisions)
                { layer: 4, name: 'BUGÜNKÜ ARAZİ KULLANIMI DEVAM ETTİRİLEREK KORUNACAK ALANLAR', group: 'KILIS_ALANSAL' },
                { layer: 5, name: 'PLAN KARARLARI', group: 'KILIS_ALANSAL' },
                { layer: 6, name: 'KENTSEL ÇALIŞMA ALANLARI', group: 'KILIS_ALANSAL' },
                { layer: 7, name: 'ÖZEL KANUNLARLA BELİRLENEN ALAN VE SINIRLAR', group: 'KILIS_ALANSAL' },
                { layer: 8, name: 'SULAMA ALANLARI', group: 'KILIS_ALANSAL' },
                { layer: 9, name: 'SİT ALANLARI (ALAN)', group: 'KILIS_ALANSAL' },
                { layer: 10, name: 'KORUNACAK ALANLAR', group: 'KILIS_ALANSAL' },
                { layer: 11, name: 'BARAJ GÖL', group: 'KILIS_ALANSAL' },
                { layer: 15, name: 'ENERJİ ÜRETİM, DAĞITIM VE DEPOLAMA', group: 'KILIS_ALANSAL' },
                // ÇİZGİSEL KARARLAR (Line decisions)
                { layer: 13, name: 'AKARSULAR', group: 'KILIS_CIZGISEL' },
                { layer: 14, name: 'DEMİRYOLLARI', group: 'KILIS_CIZGISEL' },
                { layer: 16, name: 'KARAYOLLARI', group: 'KILIS_CIZGISEL' },
                // SINIRLAR (Borders)
                { layer: 2, name: 'İDARİ SINIRLAR', group: 'KILIS_SINIRLAR' },
                { layer: 3, name: 'SORUMLULUK SINIRI', group: 'KILIS_SINIRLAR' },
                { layer: 17, name: 'SU KAYNAKLARI KORUMA ALANLARI', group: 'KILIS_SINIRLAR' },
                // NOKTASAL KARARLAR (Point decisions)
                { layer: 19, name: 'TURİZM ALANLARI (NOKTA)', group: 'KILIS_NOKTASAL' },
                { layer: 20, name: 'SİT ALANLARI (NOKTA)', group: 'KILIS_NOKTASAL' },
                { layer: 21, name: 'ÖZEL KANUNLARA TABİ ALANLAR (NOKTA)', group: 'KILIS_NOKTASAL' },
                { layer: 22, name: 'DEMİRYOLU (NOKTA)', group: 'KILIS_NOKTASAL' },
                { layer: 23, name: 'ÇALIŞMA ALANLARI (NOKTA)', group: 'KILIS_NOKTASAL' },
                { layer: 24, name: 'BÜYÜK VE AÇIK ALAN KULLANIŞLARI (NOKTA)', group: 'KILIS_NOKTASAL' },
                { layer: 25, name: 'SU, ATIKSU VE ATIK SİSTEMLERİ', group: 'KILIS_NOKTASAL' },
                { layer: 26, name: 'SINIR KAPILARI', group: 'KILIS_NOKTASAL' },
                { layer: 27, name: 'İDARİ MERKEZLER', group: 'KILIS_NOKTASAL' }
            ],
            kirikkale: [
                // ALANSAL (from GetCapabilities)
                { layer: 2, name: 'Tarım Arazileri', group: 'KIRIKKALE_ALANSAL' },
                { layer: 3, name: 'Sazlık Bataklık Alanlar', group: 'KIRIKKALE_ALANSAL' },
                { layer: 4, name: 'Kumluk Alanlar', group: 'KIRIKKALE_ALANSAL' },
                { layer: 5, name: 'Kayalık Taşlık Alanlar ve Kumullar', group: 'KIRIKKALE_ALANSAL' },
                { layer: 6, name: 'Seyrek Bitkilik Alanlar', group: 'KIRIKKALE_ALANSAL' },
                { layer: 7, name: 'Koruma Alanları', group: 'KIRIKKALE_ALANSAL' },
                { layer: 9, name: 'Ağaçlandırılacak Alan', group: 'KIRIKKALE_ALANSAL' },
                { layer: 11, name: 'Orman ve Ağaçlandırılacak Alanlar', group: 'KIRIKKALE_ALANSAL' },
                { layer: 13, name: 'Doğal Çayırlıklar', group: 'KIRIKKALE_ALANSAL' },
                { layer: 14, name: 'Çayır - Meralar', group: 'KIRIKKALE_ALANSAL' },
                { layer: 15, name: 'Meyve Bahçeleri', group: 'KIRIKKALE_ALANSAL' },
                { layer: 16, name: 'Diğer Arazi Kullanım Kararları', group: 'KIRIKKALE_ALANSAL' },
                { layer: 17, name: 'Diğer Arazi Kullanım Kararları', group: 'KIRIKKALE_ALANSAL' },
                { layer: 18, name: 'Büyük ve Açık Alan Kullanışları', group: 'KIRIKKALE_ALANSAL' },
                { layer: 19, name: 'Büyük ve Açık Alan Kullanımları', group: 'KIRIKKALE_ALANSAL' },
                { layer: 20, name: 'Çalışma Alanları', group: 'KIRIKKALE_ALANSAL' },
                { layer: 21, name: 'Endüstri', group: 'KIRIKKALE_ALANSAL' },
                { layer: 22, name: 'Kentsel Gelişme Alanı', group: 'KIRIKKALE_ALANSAL' },
                { layer: 23, name: 'Arazi Kullanımı', group: 'KIRIKKALE_ALANSAL' },
                { layer: 24, name: 'Su, Kanalizasyon, Çöp', group: 'KIRIKKALE_ALANSAL' },
                { layer: 25, name: 'Organize Hayvancılık Alanları', group: 'KIRIKKALE_ALANSAL' },
                { layer: 26, name: 'Üniversite Kampüs Alanları', group: 'KIRIKKALE_ALANSAL' },
                { layer: 27, name: 'AritmaTesisi (Proje)', group: 'KIRIKKALE_ALANSAL' },
                { layer: 28, name: 'Hastahane', group: 'KIRIKKALE_ALANSAL' },
                { layer: 29, name: 'Katı Atık Toplama ve Tasfiye Alanı', group: 'KIRIKKALE_ALANSAL' },
                { layer: 30, name: 'Göller', group: 'KIRIKKALE_ALANSAL' },
                { layer: 31, name: 'Enerji ve Sulama', group: 'KIRIKKALE_ALANSAL' },
                // ÇİZGİSEL
                { layer: 33, name: 'Su Yüzeyleri', group: 'KIRIKKALE_CIZGISEL' },
                { layer: 36, name: 'Altyapı', group: 'KIRIKKALE_CIZGISEL' },
                { layer: 37, name: 'Devlet Karayolları (Proje)', group: 'KIRIKKALE_CIZGISEL' },
                { layer: 38, name: 'Demiryolları', group: 'KIRIKKALE_CIZGISEL' },
                { layer: 39, name: 'Doğalgaz Nakil Hattı', group: 'KIRIKKALE_CIZGISEL' },
                { layer: 40, name: 'Hızlı Tren Güzergahı', group: 'KIRIKKALE_CIZGISEL' },
                { layer: 41, name: 'Enerji Taşınımı', group: 'KIRIKKALE_CIZGISEL' },
                // SINIRLAR
                { layer: 34, name: 'Su Kaynakları Koruma Alanı Sınırları', group: 'KIRIKKALE_SINIRLAR' },
                { layer: 35, name: 'Yapı Yasağı Getirilen Alanlar', group: 'KIRIKKALE_SINIRLAR' },
                { layer: 42, name: 'ÇDP Onama Sınırı', group: 'KIRIKKALE_SINIRLAR' },
                { layer: 43, name: 'Planlama Sınırları', group: 'KIRIKKALE_SINIRLAR' },
                { layer: 44, name: 'Planlama Sınırları', group: 'KIRIKKALE_SINIRLAR' },
                { layer: 45, name: 'Belediye Sınırı', group: 'KIRIKKALE_SINIRLAR' },
                { layer: 46, name: 'İlçe Sınırı', group: 'KIRIKKALE_SINIRLAR' },
                { layer: 47, name: 'Sınırlar', group: 'KIRIKKALE_SINIRLAR' },
                { layer: 48, name: 'Özel Planlama Alanı', group: 'KIRIKKALE_SINIRLAR' },
                // NOKTASAL
                { layer: 50, name: 'Hızlı Tren İstasyonları', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 51, name: 'Afet Alanları', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 52, name: 'Küçük Sanayi Siteleri', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 53, name: 'Organize Sanayi Bölgeleri', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 54, name: 'Endüstri', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 55, name: 'Koruma Alanları', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 56, name: 'Rafineri', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 57, name: 'Organize Sanayi Bölgeleri', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 58, name: 'Küçük Sanayi Siteleri', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 59, name: 'Katı Atık Depolama Tesisi', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 60, name: 'Hastahane', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 61, name: 'Revizyonu Yapılacak Planlı Alanlar', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 62, name: 'Arıtma Tesisi', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 63, name: 'Köy Merkezleri', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 64, name: 'Belediye Merkezleri', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 65, name: 'İlçe Merkezleri', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 66, name: 'Yerleşim Merkezleri', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 67, name: 'Koyler', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 68, name: 'Belediyeler1', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 69, name: 'IlceMerkezi', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 70, name: 'IlMerkezi', group: 'KIRIKKALE_NOKTASAL' },
                { layer: 71, name: 'ASKERI_YASAK_BOLGE_N', group: 'KIRIKKALE_NOKTASAL' }
            ],
            osmaniye: [
                // ALANSAL (from GetCapabilities)
                { layer: 3, name: 'MERA ALANLARI', group: 'OSMANIYE_ALANSAL' },
                { layer: 4, name: 'MARJİNAL TARIM ALANLARI', group: 'OSMANIYE_ALANSAL' },
                { layer: 5, name: 'ÖZEL ÜRÜN ALANLARI', group: 'OSMANIYE_ALANSAL' },
                { layer: 6, name: 'MUTLAK TARIM ALANLARI', group: 'OSMANIYE_ALANSAL' },
                { layer: 7, name: 'MAKİLİK FUNDALIK ALANLAR', group: 'OSMANIYE_ALANSAL' },
                { layer: 8, name: 'DOĞAL KARAKTERİ KORUNACAK ALANLAR', group: 'OSMANIYE_ALANSAL' },
                { layer: 9, name: 'ORMAN ALANLARI', group: 'OSMANIYE_ALANSAL' },
                { layer: 10, name: 'TARAMA TARIM&ORMAN', group: 'OSMANIYE_ALANSAL' },
                { layer: 11, name: 'OSMANİYE MERKEZ DEG TARIM&ORMAN', group: 'OSMANIYE_ALANSAL' },
                { layer: 13, name: 'AĞAÇLANDIRILACAK ALANLAR', group: 'OSMANIYE_ALANSAL' },
                { layer: 14, name: 'ARAZİ KULLANMA KARARLARI', group: 'OSMANIYE_ALANSAL' },
                { layer: 15, name: 'SANAYİ ALANLARI', group: 'OSMANIYE_ALANSAL' },
                { layer: 16, name: 'BÜYÜK AÇIK ALAN KULLANIŞLARI', group: 'OSMANIYE_ALANSAL' },
                { layer: 17, name: 'TURİZM ALANLARI', group: 'OSMANIYE_ALANSAL' },
                { layer: 18, name: 'KENTSEL ÇALIŞMA ALANLARI', group: 'OSMANIYE_ALANSAL' },
                { layer: 19, name: 'KENTSEL GELİŞME ALANI', group: 'OSMANIYE_ALANSAL' },
                { layer: 20, name: 'YERLEŞİK ALANLAR', group: 'OSMANIYE_ALANSAL' },
                { layer: 21, name: 'GELİŞMESİ DONDURULACAK SANAYİ VE K.D.K.Ç. ALANLARI', group: 'OSMANIYE_ALANSAL' },
                { layer: 22, name: 'OSMANİYE MERKEZ DEGISIKLIK', group: 'OSMANIYE_ALANSAL' },
                { layer: 23, name: 'osb_mpyy', group: 'OSMANIYE_ALANSAL' },
                { layer: 24, name: 'YAPI YASAĞI GETİRİLEN ALANLAR', group: 'OSMANIYE_ALANSAL' },
                { layer: 25, name: 'OSMANİYE_MERKEZ_KORUNACAK ALAN', group: 'OSMANIYE_ALANSAL' },
                { layer: 26, name: 'İÇME VE KULLANMA SUYU', group: 'OSMANIYE_ALANSAL' },
                { layer: 29, name: 'BARAJLAR-GÖLETLER KORUMA BANTI 2 KM', group: 'OSMANIYE_ALANSAL' },
                { layer: 30, name: 'BARAJLAR-GÖLETLER KORUMA BANTI 5 KM', group: 'OSMANIYE_ALANSAL' },
                { layer: 32, name: 'GOLLER NEHIRLER', group: 'OSMANIYE_ALANSAL' },
                { layer: 33, name: 'BARAJLAR-GÖLETLER', group: 'OSMANIYE_ALANSAL' },
                { layer: 43, name: 'OSMANİYE MERKEZ AFET RISKLI ALAN', group: 'OSMANIYE_ALANSAL' },
                { layer: 55, name: 'havaalani', group: 'OSMANIYE_ALANSAL' },
                // CIZGISEL (from GetCapabilities)
                { layer: 31, name: 'SULAMA KANALI', group: 'OSMANIYE_CIZGISEL' },
                { layer: 38, name: 'SULAMA KANALLARI', group: 'OSMANIYE_CIZGISEL' },
                { layer: 39, name: 'ENERJİ TAŞIMA', group: 'OSMANIYE_CIZGISEL' },
                { layer: 41, name: 'DEMİRYOLLARI', group: 'OSMANIYE_CIZGISEL' },
                { layer: 42, name: 'KARAYOLLARI', group: 'OSMANIYE_CIZGISEL' },
                { layer: 45, name: 'OSMANİYE MERKEZ CIZGI', group: 'OSMANIYE_CIZGISEL' },
                // SINIRLAR (from GetCapabilities)
                { layer: 35, name: 'SİT SINIRLARI', group: 'OSMANIYE_SINIRLAR' },
                { layer: 36, name: 'PLANLAMA SINIRLARI', group: 'OSMANIYE_SINIRLAR' },
                { layer: 44, name: 'PLANLAMA SINIRLARI', group: 'OSMANIYE_SINIRLAR' },
                { layer: 46, name: 'İDARİ SINIRLAR', group: 'OSMANIYE_SINIRLAR' },
                // NOKTASAL (from GetCapabilities)
                { layer: 47, name: 'DİĞER SEMBOLLER', group: 'OSMANIYE_NOKTASAL' },
                { layer: 48, name: 'ÇÖP TOPLAMA', group: 'OSMANIYE_NOKTASAL' },
                { layer: 49, name: 'TARİHİ KALELER', group: 'OSMANIYE_NOKTASAL' },
                { layer: 50, name: 'TURİZM', group: 'OSMANIYE_NOKTASAL' },
                { layer: 51, name: 'SANAYİ ALANLARI', group: 'OSMANIYE_NOKTASAL' },
                { layer: 52, name: 'BÜYÜK AÇIK ALAN KULLANIŞLARI', group: 'OSMANIYE_NOKTASAL' },
                { layer: 53, name: 'YERLEŞİM MERKEZLERİ', group: 'OSMANIYE_NOKTASAL' },
                { layer: 54, name: 'OSMANIYE MERKEZ YERLESIM_N', group: 'OSMANIYE_NOKTASAL' },
                { layer: 56, name: 'havaalani', group: 'OSMANIYE_NOKTASAL' },
                { layer: 57, name: 'TGB_mpyy', group: 'OSMANIYE_NOKTASAL' },
                { layer: 58, name: 'Plan Kullanımı Nokta', group: 'OSMANIYE_NOKTASAL' },
                { layer: 59, name: 'pindex', group: 'OSMANIYE_NOKTASAL' },
                { layer: 60, name: 'osb_nokta_mpyy', group: 'OSMANIYE_NOKTASAL' }
            ],
            sinop: [
                // ALANSAL (from GetCapabilities - A suffix layers)
                { layer: 1, name: 'TARIMSALARAZIKULLANIMLARIA', group: 'SINOP_ALANSAL' },
                { layer: 2, name: 'DOGALKARAKTERIKORUNACAKA', group: 'SINOP_ALANSAL' },
                { layer: 3, name: 'ORMANVEAGACLANDIRILACAKA', group: 'SINOP_ALANSAL' },
                { layer: 4, name: 'ORMANVEAGACLANDIRILACAKA', group: 'SINOP_ALANSAL' },
                { layer: 5, name: 'TARIMSALARAZIKULLANIMLARIA', group: 'SINOP_ALANSAL' },
                { layer: 6, name: 'DIGERKORUMAALANLARIA', group: 'SINOP_ALANSAL' },
                { layer: 7, name: 'KULLANIMSINIRLAMASIGETIRILENA', group: 'SINOP_ALANSAL' },
                { layer: 8, name: 'ENERJISULAMAA', group: 'SINOP_ALANSAL' },
                { layer: 9, name: 'YERLESIMA', group: 'SINOP_ALANSAL' },
                { layer: 10, name: 'KULLANIMSINIRLAMASIGETIRILENA', group: 'SINOP_ALANSAL' },
                { layer: 11, name: 'TURIZMA', group: 'SINOP_ALANSAL' },
                { layer: 12, name: 'ENERJISULAMAA', group: 'SINOP_ALANSAL' },
                { layer: 13, name: 'CALISMAA', group: 'SINOP_ALANSAL' },
                { layer: 14, name: 'ATIKVEARITMATESISLERIA', group: 'SINOP_ALANSAL' },
                { layer: 15, name: 'KULLANIMSINIRLAMASIGETIRILENA', group: 'SINOP_ALANSAL' },
                { layer: 16, name: 'SITA_FON', group: 'SINOP_ALANSAL' },
                { layer: 17, name: 'DIGERARAZIKULLANIMA', group: 'SINOP_ALANSAL' },
                { layer: 18, name: 'DIGERKORUMAALANLARIA', group: 'SINOP_ALANSAL' },
                { layer: 19, name: 'OZELKANUNLARATABIALANLAR', group: 'SINOP_ALANSAL' },
                { layer: 21, name: 'SUYUZEYLERIA', group: 'SINOP_ALANSAL' },
                { layer: 22, name: 'BUYUKVEACIKALANKULLANISLARIA', group: 'SINOP_ALANSAL' },
                { layer: 23, name: 'BUYUKVEACIKALANKULLANISLARIA', group: 'SINOP_ALANSAL' },
                { layer: 24, name: 'SITA_FON', group: 'SINOP_ALANSAL' },
                { layer: 25, name: 'SITA', group: 'SINOP_ALANSAL' },
                { layer: 26, name: 'DENIZYOLLARIVEKIYIYAPILARIA', group: 'SINOP_ALANSAL' },
                { layer: 42, name: 'YERLESIMA', group: 'SINOP_ALANSAL' },
                { layer: 49, name: 'KENTSELVEBOLGESELALTYAPIALANI', group: 'SINOP_ALANSAL' },
                { layer: 52, name: 'HAVAYOLLARIA_1', group: 'SINOP_ALANSAL' },
                { layer: 53, name: 'EUA', group: 'SINOP_ALANSAL' },
                // CIZGISEL (from GetCapabilities - C suffix layers)
                { layer: 20, name: 'SUYUZEYLERIC', group: 'SINOP_CIZGISEL' },
                { layer: 27, name: 'SUYUZEYLERIC', group: 'SINOP_CIZGISEL' },
                { layer: 28, name: 'ENERJISULAMAC', group: 'SINOP_CIZGISEL' },
                { layer: 43, name: 'KARAYOLLARIC', group: 'SINOP_CIZGISEL' },
                // SINIRLAR (from GetCapabilities - L suffix and boundary layers)
                { layer: 29, name: 'DIGERKORUMAALANLARI_L', group: 'SINOP_SINIRLAR' },
                { layer: 30, name: 'OZELKANUNLARATABIALANLAR_L', group: 'SINOP_SINIRLAR' },
                { layer: 31, name: 'SORUMLULUKSINIRI_L', group: 'SINOP_SINIRLAR' },
                { layer: 48, name: 'PLANLAMASINIRLARI_L', group: 'SINOP_SINIRLAR' },
                { layer: 50, name: 'PLANLAMASINIRLARI_L', group: 'SINOP_SINIRLAR' },
                { layer: 55, name: 'SINIRLAR', group: 'SINOP_SINIRLAR' },
                // NOKTASAL (from GetCapabilities - N suffix layers)
                { layer: 32, name: 'ENERJISULAMAN', group: 'SINOP_NOKTASAL' },
                { layer: 33, name: 'ATIKVEARITMATESISLERIN', group: 'SINOP_NOKTASAL' },
                { layer: 34, name: 'TURIZMN', group: 'SINOP_NOKTASAL' },
                { layer: 35, name: 'DIGERARAZIKULLANIMN', group: 'SINOP_NOKTASAL' },
                { layer: 36, name: 'CALISMAN', group: 'SINOP_NOKTASAL' },
                { layer: 37, name: 'BUYUKVEACIKALANKULLANISLARIN', group: 'SINOP_NOKTASAL' },
                { layer: 38, name: 'BUYUKVEACIKALANKULLANISLARIN', group: 'SINOP_NOKTASAL' },
                { layer: 39, name: 'DIGERKORUMAALANLARIN', group: 'SINOP_NOKTASAL' },
                { layer: 40, name: 'KARAYOLLARIN', group: 'SINOP_NOKTASAL' },
                { layer: 41, name: 'DENIZYOLLARIVEKIYIYAPILARIN', group: 'SINOP_NOKTASAL' },
                { layer: 44, name: 'IDARIMERKEZLER', group: 'SINOP_NOKTASAL' },
                { layer: 45, name: 'IDARIMERKEZLER', group: 'SINOP_NOKTASAL' },
                { layer: 46, name: 'SITN', group: 'SINOP_NOKTASAL' },
                { layer: 47, name: 'SITN', group: 'SINOP_NOKTASAL' },
                { layer: 51, name: 'KENTSELVEBOLGESELSOSYALALTYAPIALANI_N', group: 'SINOP_NOKTASAL' },
                { layer: 54, name: 'EUA_nokta', group: 'SINOP_NOKTASAL' },
                { layer: 56, name: 'HAVAYOLLARIN', group: 'SINOP_NOKTASAL' }
            ],
            usak: [
                // ALANSAL (from GetCapabilities)
                { layer: 1, name: 'Mera_Plan', group: 'USAK_ALANSAL' },
                { layer: 2, name: 'Orman_Plan', group: 'USAK_ALANSAL' },
                { layer: 3, name: 'Tarim_plan', group: 'USAK_ALANSAL' },
                { layer: 4, name: 'YÜRÜRLÜKTEKİ ONANLI İMAR PLANLARI', group: 'USAK_ALANSAL' },
                { layer: 5, name: 'AlanKullanimi', group: 'USAK_ALANSAL' },
                { layer: 6, name: 'MevziImarPlani', group: 'USAK_ALANSAL' },
                { layer: 7, name: 'Gol_DSI', group: 'USAK_ALANSAL' },
                { layer: 8, name: 'Baraj', group: 'USAK_ALANSAL' },
                { layer: 9, name: 'Dere_Yatagi', group: 'USAK_ALANSAL' },
                { layer: 11, name: 'Akarsu_BASEMAP', group: 'USAK_ALANSAL' },
                { layer: 12, name: 'KÜÇÜKLER BARAJI KORUMA ALANI', group: 'USAK_ALANSAL' },
                { layer: 13, name: 'Gol_BASEMAP', group: 'USAK_ALANSAL' },
                { layer: 14, name: 'GÖLETLERİN SULAMA ALANLARI', group: 'USAK_ALANSAL' },
                { layer: 16, name: 'BiyolojikOnemliAlan', group: 'USAK_ALANSAL' },
                { layer: 17, name: 'TurizmSiniri', group: 'USAK_ALANSAL' },
                { layer: 18, name: 'RekreasyonAlani', group: 'USAK_ALANSAL' },
                { layer: 19, name: 'SitAlanlari', group: 'USAK_ALANSAL' },
                { layer: 20, name: 'MilliParklar', group: 'USAK_ALANSAL' },
                { layer: 24, name: 'Usak_Havaalani', group: 'USAK_ALANSAL' },
                { layer: 43, name: 'plandegisikligisiniri', group: 'USAK_ALANSAL' },
                // CIZGISEL (from GetCapabilities)
                { layer: 10, name: 'AkarsuCizgi_BASEMAP', group: 'USAK_CIZGISEL' },
                { layer: 25, name: 'DemirYolu', group: 'USAK_CIZGISEL' },
                { layer: 26, name: 'DemirYoluProjeHatti', group: 'USAK_CIZGISEL' },
                { layer: 27, name: 'KarayoluCizgi', group: 'USAK_CIZGISEL' },
                { layer: 38, name: 'CDP_Siniri_Line', group: 'USAK_CIZGISEL' },
                { layer: 39, name: 'MucavirAlan_Line', group: 'USAK_CIZGISEL' },
                { layer: 40, name: 'Belediye_Line', group: 'USAK_CIZGISEL' },
                // SINIRLAR (from GetCapabilities)
                { layer: 29, name: 'İl_Basemap', group: 'USAK_SINIRLAR' },
                { layer: 30, name: 'İLÇE SINIRI', group: 'USAK_SINIRLAR' },
                { layer: 31, name: 'KomsuIllerSiniri', group: 'USAK_SINIRLAR' },
                { layer: 32, name: 'İL SINIRI', group: 'USAK_SINIRLAR' },
                { layer: 33, name: 'Bolgeler', group: 'USAK_SINIRLAR' },
                { layer: 34, name: 'OnanliImarPlaniSiniri', group: 'USAK_SINIRLAR' },
                // NOKTASAL (from GetCapabilities)
                { layer: 21, name: 'SitAlanlari_Kentselsentez_point', group: 'USAK_NOKTASAL' },
                { layer: 22, name: 'NoktasalKorumaAlanlari', group: 'USAK_NOKTASAL' },
                { layer: 35, name: 'RekreasyonAlani_Point', group: 'USAK_NOKTASAL' },
                { layer: 36, name: 'NoktasalGunubirlikAlanlar', group: 'USAK_NOKTASAL' },
                { layer: 37, name: 'KanalCopNokta', group: 'USAK_NOKTASAL' },
                { layer: 41, name: 'KÖYLER', group: 'USAK_NOKTASAL' },
                { layer: 42, name: 'OSB_Point', group: 'USAK_NOKTASAL' }
            ],
            yalova: [
                // ALANSAL (from GetCapabilities)
                { layer: 1, name: 'DENIZ', group: 'YALOVA_ALANSAL' },
                { layer: 2, name: 'SU_YUZEYI', group: 'YALOVA_ALANSAL' },
                { layer: 3, name: 'TARIM_ALANI', group: 'YALOVA_ALANSAL' },
                { layer: 4, name: 'ORMAN_ALANI', group: 'YALOVA_ALANSAL' },
                { layer: 5, name: 'SULAK_ALAN_BOLGESI', group: 'YALOVA_ALANSAL' },
                { layer: 6, name: 'TERSANE_ALANI', group: 'YALOVA_ALANSAL' },
                { layer: 7, name: 'MERA_ALANI', group: 'YALOVA_ALANSAL' },
                { layer: 8, name: 'KENTSEL_SOSYAL_ALTYAPI', group: 'YALOVA_ALANSAL' },
                { layer: 9, name: 'KIYI_TESIS_ALAN', group: 'YALOVA_ALANSAL' },
                { layer: 10, name: 'ASKERI_YASAK_GUVENLIK_ALAN', group: 'YALOVA_ALANSAL' },
                { layer: 11, name: 'SANAYI_DEPOLAMA_ALANI', group: 'YALOVA_ALANSAL' },
                { layer: 12, name: 'OSB_ALAN', group: 'YALOVA_ALANSAL' },
                { layer: 13, name: 'SU_ATIKSU_ATIK_SISTEMLERI', group: 'YALOVA_ALANSAL' },
                { layer: 14, name: 'UNIVERSITE_ALANI', group: 'YALOVA_ALANSAL' },
                { layer: 15, name: 'KENTSEL_BOLGESEL_YESIL_SPOR', group: 'YALOVA_ALANSAL' },
                { layer: 16, name: 'ORGANİZE_TARIM_ALANI', group: 'YALOVA_ALANSAL' },
                { layer: 17, name: 'TURİZM_BOLGESI', group: 'YALOVA_ALANSAL' },
                { layer: 18, name: 'KENTSEL_SERVIS_ALANI', group: 'YALOVA_ALANSAL' },
                { layer: 19, name: 'TERCIHLI_KULLANIM_ALANI', group: 'YALOVA_ALANSAL' },
                { layer: 20, name: 'KENTSEL_GELISME_ALANI', group: 'YALOVA_ALANSAL' },
                { layer: 21, name: 'KENTSEL_YERLESIK', group: 'YALOVA_ALANSAL' },
                { layer: 23, name: 'SIT_ALAN', group: 'YALOVA_ALANSAL' },
                { layer: 24, name: 'SULAMA_ALANI', group: 'YALOVA_ALANSAL' },
                { layer: 35, name: 'SULAK_ALAN_BOLGE', group: 'YALOVA_ALANSAL' },
                { layer: 36, name: 'KORUMA_KUSAKLARI', group: 'YALOVA_ALANSAL' },
                // CIZGISEL (from GetCapabilities)
                { layer: 26, name: 'DERELER', group: 'YALOVA_CIZGISEL' },
                { layer: 27, name: 'ASKERI_YASAK_GUVENLIK_SINIR', group: 'YALOVA_CIZGISEL' },
                { layer: 28, name: 'ENERJI_URETIM_DAGITIM_DEPOLAMA', group: 'YALOVA_CIZGISEL' },
                { layer: 30, name: 'UCUNCUDERECEYOL', group: 'YALOVA_CIZGISEL' },
                { layer: 31, name: 'IKINCIDERECEYOL', group: 'YALOVA_CIZGISEL' },
                { layer: 32, name: 'BIRINCIDERECEYOL', group: 'YALOVA_CIZGISEL' },
                { layer: 33, name: 'OTOYOL', group: 'YALOVA_CIZGISEL' },
                // SINIRLAR (from GetCapabilities)
                { layer: 38, name: 'TURIZM_MERKEZ_SINIR', group: 'YALOVA_SINIRLAR' },
                { layer: 39, name: 'ILCE_SINIRI', group: 'YALOVA_SINIRLAR' },
                { layer: 40, name: 'PLAN_ONAMA_SINIRI', group: 'YALOVA_SINIRLAR' },
                // NOKTASAL (from GetCapabilities)
                { layer: 42, name: 'TERSANE_SEMBOL', group: 'YALOVA_NOKTASAL' },
                { layer: 43, name: 'TABIAT_PARKI_SEMBOL', group: 'YALOVA_NOKTASAL' },
                { layer: 44, name: 'SIT_ALAN_SEMBOL', group: 'YALOVA_NOKTASAL' },
                { layer: 45, name: 'OSB_SEMBOL', group: 'YALOVA_NOKTASAL' },
                { layer: 46, name: 'ASKERI_YASAK_GUVENLIK_SEMBOL', group: 'YALOVA_NOKTASAL' },
                { layer: 47, name: 'SU_ATIKSU_ATIK_SEMBOL', group: 'YALOVA_NOKTASAL' },
                { layer: 48, name: 'KIYI_TESIS_ALANI_SEMBOL', group: 'YALOVA_NOKTASAL' },
                { layer: 49, name: 'KENTSEL_SOSYAL_ALTYAPI _SEMBOL', group: 'YALOVA_NOKTASAL' },
                { layer: 50, name: 'TURIZM_BOLGE_SEMBOL', group: 'YALOVA_NOKTASAL' },
                { layer: 51, name: 'TALI_MERKEZ_SEMBOL', group: 'YALOVA_NOKTASAL' },
                { layer: 52, name: 'MİA_SEMBOL', group: 'YALOVA_NOKTASAL' },
                { layer: 53, name: 'YON', group: 'YALOVA_NOKTASAL' },
                { layer: 55, name: 'KIRSAL_ALAN_SEMBOL', group: 'YALOVA_NOKTASAL' },
                { layer: 56, name: 'IDARI_MERKEZLER', group: 'YALOVA_NOKTASAL' }
            ],
            skc: [
                // SKC_ALANSAL Group (Area layers)
                { layer: 1, name: 'Il', group: 'SKC_ALANSAL' },
                { layer: 2, name: 'TOPRAK ARAZİ KULLANIMI', group: 'SKC_ALANSAL' },
                { layer: 3, name: 'TarimEk', group: 'SKC_ALANSAL' },
                { layer: 5, name: 'OrmanEk', group: 'SKC_ALANSAL' },
                { layer: 6, name: 'ORMAN ALANLARI', group: 'SKC_ALANSAL' },
                { layer: 7, name: 'ORMAN ALANLARI', group: 'SKC_ALANSAL' },
                { layer: 8, name: 'ORMAN_2022', group: 'SKC_ALANSAL' },
                { layer: 9, name: 'Kumsallar+Plajlar', group: 'SKC_ALANSAL' },
                { layer: 10, name: 'KANYON', group: 'SKC_ALANSAL' },
                { layer: 12, name: 'SULAMA ALANI', group: 'SKC_ALANSAL' },
                { layer: 13, name: 'SULAMA PROJE ALANI', group: 'SKC_ALANSAL' },
                { layer: 14, name: 'Sazlik_Pln', group: 'SKC_ALANSAL' },
                { layer: 15, name: 'ÖNEMLİ BİTKİ ALANI', group: 'SKC_ALANSAL' },
                { layer: 16, name: 'HAVAALANI', group: 'SKC_ALANSAL' },
                { layer: 18, name: 'KÖY VE KÖY ALTI YERLEŞİMLER', group: 'SKC_ALANSAL' },
                { layer: 19, name: 'KÖY VE KÖY ALTI YERLEŞİMLER', group: 'SKC_ALANSAL' },
                { layer: 20, name: 'KÖY YERLEŞİK ALANLARI', group: 'SKC_ALANSAL' },
                { layer: 21, name: 'KENTSEL MESKUN ALANLAR', group: 'SKC_ALANSAL' },
                { layer: 22, name: 'TOPLU KONUT', group: 'SKC_ALANSAL' },
                { layer: 24, name: 'BÜYÜK KENTSEL YEŞİL', group: 'SKC_ALANSAL' },
                { layer: 25, name: 'TURİZM TESİS ALANLARI', group: 'SKC_ALANSAL' },
                { layer: 26, name: 'ÜNİVERSİTE ALANI', group: 'SKC_ALANSAL' },
                { layer: 27, name: 'TERMİK SANTRAL', group: 'SKC_ALANSAL' },
                { layer: 28, name: 'BALIKÇI BARINAĞI GERİ SAHASI', group: 'SKC_ALANSAL' },
                { layer: 29, name: 'LİMAN GERİ SAHASI', group: 'SKC_ALANSAL' },
                { layer: 30, name: 'ORGANİZE TARIM BÖLGESİ', group: 'SKC_ALANSAL' },
                { layer: 31, name: 'Katı Atık', group: 'SKC_ALANSAL' },
                { layer: 32, name: 'SANAYİ ALANLARI', group: 'SKC_ALANSAL' },
                { layer: 33, name: 'Export_Output_SANAYI', group: 'SKC_ALANSAL' },
                { layer: 34, name: 'ORGANİZE SANAYİ BÖLGESİ', group: 'SKC_ALANSAL' },
                { layer: 35, name: 'KSS_ALAN', group: 'SKC_ALANSAL' },
                { layer: 36, name: 'BAGKK', group: 'SKC_ALANSAL' },
                { layer: 37, name: 'AĞAÇLANDIRILACAK ALAN', group: 'SKC_ALANSAL' },
                { layer: 38, name: 'MESİRE ALANI', group: 'SKC_ALANSAL' },
                { layer: 39, name: 'ASKERİ ALANLAR', group: 'SKC_ALANSAL' },
                { layer: 41, name: 'Y.H.K.S', group: 'SKC_ALANSAL' },
                { layer: 42, name: 'Y.H.G.V.Y.S', group: 'SKC_ALANSAL' },
                { layer: 44, name: 'AkarsuCizgi', group: 'SKC_ALANSAL' },
                { layer: 45, name: 'BARAJ', group: 'SKC_ALANSAL' },
                { layer: 46, name: 'BARAJ', group: 'SKC_ALANSAL' },
                { layer: 47, name: 'BARAJ', group: 'SKC_ALANSAL' },
                { layer: 48, name: 'GÖL', group: 'SKC_ALANSAL' },
                { layer: 49, name: 'Gölet', group: 'SKC_ALANSAL' },
                { layer: 50, name: 'TABİATI KORUMA ALANI', group: 'SKC_ALANSAL' },
                { layer: 51, name: 'SULAK ALAN', group: 'SKC_ALANSAL' },
                { layer: 52, name: 'ÖNEMLİ KUŞ ALANI', group: 'SKC_ALANSAL' },
                { layer: 53, name: 'ÖNEMLİ KUŞ ALANI', group: 'SKC_ALANSAL' },
                { layer: 54, name: 'dogal_karakteri_korunacak_alan', group: 'SKC_ALANSAL' },
                { layer: 55, name: 'jeolojik_sakıncalı', group: 'SKC_ALANSAL' },
                { layer: 83, name: 'Gelişme_alanı', group: 'SKC_ALANSAL' },
                { layer: 84, name: 'CDP_GELISME', group: 'SKC_ALANSAL' },
                { layer: 85, name: 'SİT ALANLARI', group: 'SKC_ALANSAL' },
                { layer: 86, name: 'turizm_merkezi', group: 'SKC_ALANSAL' },
                { layer: 87, name: 'TurizmMerkezi_Sinir_1', group: 'SKC_ALANSAL' },
                { layer: 88, name: 'Teknoloji_Gelistirme_Bolgesi_Alan', group: 'SKC_ALANSAL' },
                { layer: 91, name: 'Kentsel_servis_alani', group: 'SKC_ALANSAL' },
                { layer: 92, name: 'sanayi', group: 'SKC_ALANSAL' },
                { layer: 93, name: 'EUA', group: 'SKC_ALANSAL' },
                // SKC_CIZGISEL Group (Line layers)
                { layer: 56, name: 'DogalGazHatti', group: 'SKC_CIZGISEL' },
                { layer: 58, name: 'ALT BÖLGE SINIRI', group: 'SKC_CIZGISEL' },
                { layer: 59, name: 'ÖZEL PLANLAMASI YAPILACAK ALAN', group: 'SKC_CIZGISEL' },
                { layer: 60, name: 'onemliorman_cizgi', group: 'SKC_CIZGISEL' },
                { layer: 61, name: 'MİLLİ PARK SINIRI', group: 'SKC_CIZGISEL' },
                { layer: 62, name: 'BARAJ_KORUMA_KUSAK', group: 'SKC_CIZGISEL' },
                { layer: 63, name: 'MÜCAVİR ALAN SINIRI', group: 'SKC_CIZGISEL' },
                { layer: 64, name: 'BELEDİYE SINIRI', group: 'SKC_CIZGISEL' },
                { layer: 65, name: 'ÇEVRE DÜZENİ PLANI SINIRLARI', group: 'SKC_CIZGISEL' },
                { layer: 66, name: 'PLANLAMA BÖLGESİ', group: 'SKC_CIZGISEL' },
                { layer: 67, name: 'Kiyi', group: 'SKC_CIZGISEL' },
                { layer: 68, name: 'BAGKK-istasyon', group: 'SKC_CIZGISEL' },
                { layer: 69, name: 'TeleferikHatti', group: 'SKC_CIZGISEL' },
                { layer: 70, name: 'KoyYollari', group: 'SKC_CIZGISEL' },
                { layer: 71, name: 'İDARİ SINIRLAR', group: 'SKC_CIZGISEL' },
                { layer: 72, name: 'Demiryolu', group: 'SKC_CIZGISEL' },
                { layer: 74, name: 'ULASIM', group: 'SKC_CIZGISEL' },
                { layer: 75, name: 'ULASIM', group: 'SKC_CIZGISEL' },
                { layer: 76, name: 'ONERIYOL', group: 'SKC_CIZGISEL' },
                { layer: 77, name: 'ULASIM', group: 'SKC_CIZGISEL' },
                { layer: 78, name: 'ULASIM', group: 'SKC_CIZGISEL' },
                { layer: 79, name: 'ONERIYOL', group: 'SKC_CIZGISEL' },
                { layer: 80, name: 'ULASIM', group: 'SKC_CIZGISEL' },
                { layer: 81, name: 'ONERIYOL', group: 'SKC_CIZGISEL' },
                { layer: 89, name: 'Deniz_Ulasimi', group: 'SKC_CIZGISEL' },
                { layer: 90, name: 'ENERJİ NAKİL HATTI', group: 'SKC_CIZGISEL' },
                // SKC_NOKTASAL Group (Point layers)
                { layer: 95, name: 'TEKNOLOJİ GELİŞTİRME BÖLGESİ', group: 'SKC_NOKTASAL' },
                { layer: 97, name: 'KÖY ADI', group: 'SKC_NOKTASAL' },
                { layer: 98, name: 'BELDE ADI', group: 'SKC_NOKTASAL' },
                { layer: 99, name: 'ILCE ADI', group: 'SKC_NOKTASAL' },
                { layer: 100, name: 'IL ADI', group: 'SKC_NOKTASAL' },
                { layer: 101, name: 'KAVSAK', group: 'SKC_NOKTASAL' },
                { layer: 103, name: 'Hoyuk', group: 'SKC_NOKTASAL' },
                { layer: 104, name: 'HAVAALANI', group: 'SKC_NOKTASAL' },
                { layer: 105, name: 'TURİSTİK DEĞERLER', group: 'SKC_NOKTASAL' },
                { layer: 106, name: 'Yayla_sonn', group: 'SKC_NOKTASAL' },
                { layer: 107, name: 'Maden', group: 'SKC_NOKTASAL' },
                { layer: 108, name: 'sarapcılık_tesisi', group: 'SKC_NOKTASAL' },
                { layer: 109, name: 'LİMAN_BALIKCI BARINAĞI', group: 'SKC_NOKTASAL' },
                { layer: 110, name: 'ONERI_LIMAN_TERSANE', group: 'SKC_NOKTASAL' },
                { layer: 111, name: 'hidroelektrik santral', group: 'SKC_NOKTASAL' },
                { layer: 112, name: 'OSB', group: 'SKC_NOKTASAL' },
                { layer: 113, name: 'OSB-KSS', group: 'SKC_NOKTASAL' },
                { layer: 114, name: 'SitAlanlari_nokta', group: 'SKC_NOKTASAL' },
                { layer: 115, name: 'Altyapi', group: 'SKC_NOKTASAL' },
                { layer: 116, name: 'TURİSTİK GÜZERGAH', group: 'SKC_NOKTASAL' },
                { layer: 117, name: 'üni_nokta', group: 'SKC_NOKTASAL' }
            ],
            ergene: [
                // ERGENE Group - All layers (flat list, grid-based structure d18..g19)
                { layer: 1, name: 'Alan Veri', group: 'ERGENE' },
                { layer: 2, name: 'Çizgi Veri', group: 'ERGENE' },
                { layer: 4, name: 'D18 Alan Veri', group: 'ERGENE' },
                { layer: 5, name: 'D18 Çizgi Veri', group: 'ERGENE' },
                { layer: 6, name: 'D18 Havza Sınırı', group: 'ERGENE' },
                { layer: 7, name: 'D18 Semboller', group: 'ERGENE' },
                { layer: 8, name: 'D18 Semboller', group: 'ERGENE' },
                { layer: 9, name: 'D18 Semboller Saydamlı', group: 'ERGENE' },
                { layer: 10, name: 'D18 Baraj İsim', group: 'ERGENE' },
                { layer: 12, name: 'E16 Alan Veri', group: 'ERGENE' },
                { layer: 13, name: 'E16 Taramalar', group: 'ERGENE' },
                { layer: 14, name: 'E16 Baraj İsim', group: 'ERGENE' },
                { layer: 15, name: 'E16 Çizgi Veri', group: 'ERGENE' },
                { layer: 17, name: 'E16 Havza Kısa', group: 'ERGENE' },
                { layer: 18, name: 'E16 Havza Orta', group: 'ERGENE' },
                { layer: 19, name: 'E16 Havza Uzun', group: 'ERGENE' },
                { layer: 20, name: 'E16 Semboller', group: 'ERGENE' },
                { layer: 21, name: 'E16 Semboller Saydamlı', group: 'ERGENE' },
                { layer: 22, name: 'E16 Köyler', group: 'ERGENE' },
                { layer: 24, name: 'E17 Alan Veri', group: 'ERGENE' },
                { layer: 25, name: 'E17 Taramalar', group: 'ERGENE' },
                { layer: 26, name: 'E17 Baraj İsim', group: 'ERGENE' },
                { layer: 27, name: 'E17 Alan Veri Pln Değ.', group: 'ERGENE' },
                { layer: 28, name: 'E17 Çizgi Veri', group: 'ERGENE' },
                { layer: 30, name: 'E17 Havza Mutlak', group: 'ERGENE' },
                { layer: 31, name: 'E17 Havza Kısa', group: 'ERGENE' },
                { layer: 32, name: 'E17 Havza Orta', group: 'ERGENE' },
                { layer: 33, name: 'E17 Havza Uzun', group: 'ERGENE' },
                { layer: 34, name: 'E17 Çizgi Veri 2', group: 'ERGENE' },
                { layer: 35, name: 'E17 Semboller', group: 'ERGENE' },
                { layer: 36, name: 'E17 Semboller Saydamlı', group: 'ERGENE' },
                { layer: 37, name: 'E17 Merkez İsimleri', group: 'ERGENE' },
                { layer: 38, name: 'E17 Köyler', group: 'ERGENE' },
                { layer: 40, name: 'E18 Alan Veri', group: 'ERGENE' },
                { layer: 41, name: 'E18 Taramalar', group: 'ERGENE' },
                { layer: 42, name: 'E18 Baraj İsim', group: 'ERGENE' },
                { layer: 43, name: 'E18 Çizgi Veri', group: 'ERGENE' },
                { layer: 45, name: 'E18 Havza Mutlak', group: 'ERGENE' },
                { layer: 46, name: 'E18 Havza Kısa', group: 'ERGENE' },
                { layer: 47, name: 'E18 Havza Orta', group: 'ERGENE' },
                { layer: 48, name: 'E18 Havza Uzun', group: 'ERGENE' },
                { layer: 49, name: 'E18 Semboller', group: 'ERGENE' },
                { layer: 50, name: 'E18 Merkez İsimler', group: 'ERGENE' },
                { layer: 51, name: 'E18 Semboller Saydamlı', group: 'ERGENE' },
                { layer: 52, name: 'E18 Köyler', group: 'ERGENE' },
                { layer: 54, name: 'E19 Alan Veri', group: 'ERGENE' },
                { layer: 55, name: 'E19 Taramalar', group: 'ERGENE' },
                { layer: 56, name: 'E19 Baraj İsim', group: 'ERGENE' },
                { layer: 57, name: 'E19 Çizgi Veri', group: 'ERGENE' },
                { layer: 59, name: 'E19 Havza Mutlak', group: 'ERGENE' },
                { layer: 60, name: 'E19 Havza Kısa', group: 'ERGENE' },
                { layer: 61, name: 'E19 Havza Orta', group: 'ERGENE' },
                { layer: 62, name: 'E19 Havza Uzun', group: 'ERGENE' },
                { layer: 63, name: 'E19 Çizgi Veri 2', group: 'ERGENE' },
                { layer: 64, name: 'E19 Semboller', group: 'ERGENE' },
                { layer: 65, name: 'E19 Merkez İsimler', group: 'ERGENE' },
                { layer: 66, name: 'E19 Semboller Saydamlı', group: 'ERGENE' },
                { layer: 67, name: 'E19 Köyler', group: 'ERGENE' },
                { layer: 69, name: 'E20 Alan Veri', group: 'ERGENE' },
                { layer: 70, name: 'E20 Tabiat Parkı', group: 'ERGENE' },
                { layer: 71, name: 'E20 Taramalar', group: 'ERGENE' },
                { layer: 72, name: 'E20 Baraj İsim', group: 'ERGENE' },
                { layer: 73, name: 'E20 Çizgi Veri', group: 'ERGENE' },
                { layer: 75, name: 'E20 Havza Uzun', group: 'ERGENE' },
                { layer: 76, name: 'E20 Havza Orta', group: 'ERGENE' },
                { layer: 77, name: 'E20 Havza Kısa', group: 'ERGENE' },
                { layer: 78, name: 'E20 Havza Mutlak', group: 'ERGENE' },
                { layer: 79, name: 'E20 Semboller', group: 'ERGENE' },
                { layer: 80, name: 'E20 Semboller Saydamlı', group: 'ERGENE' },
                { layer: 81, name: 'E20 Köyler', group: 'ERGENE' },
                { layer: 83, name: 'F16 Alan Veri', group: 'ERGENE' },
                { layer: 84, name: 'F16 Taramalar', group: 'ERGENE' },
                { layer: 85, name: 'F16 Baraj İsim', group: 'ERGENE' },
                { layer: 86, name: 'F16 Çizgi Veri', group: 'ERGENE' },
                { layer: 87, name: 'F16 Semboller', group: 'ERGENE' },
                { layer: 88, name: 'F16 Merkez İsimler', group: 'ERGENE' },
                { layer: 89, name: 'F16 Semboller Saydamlı', group: 'ERGENE' },
                { layer: 90, name: 'F16 Köyler', group: 'ERGENE' },
                { layer: 92, name: 'F17 Alan Veri', group: 'ERGENE' },
                { layer: 93, name: 'F17 Taramalar', group: 'ERGENE' },
                { layer: 94, name: 'F17 Baraj İsim', group: 'ERGENE' },
                { layer: 95, name: 'F17 Çizgi Veri', group: 'ERGENE' },
                { layer: 96, name: 'F17 Semboller', group: 'ERGENE' },
                { layer: 97, name: 'F17 Merkez İsimler', group: 'ERGENE' },
                { layer: 98, name: 'F17 Semboller Saydamlı', group: 'ERGENE' },
                { layer: 99, name: 'F17 Köyler', group: 'ERGENE' },
                { layer: 101, name: 'F18 Alan Veri', group: 'ERGENE' },
                { layer: 102, name: 'F18 Taramalar', group: 'ERGENE' },
                { layer: 103, name: 'F18 Baraj İsim', group: 'ERGENE' },
                { layer: 104, name: 'F18 Çizgi Veri', group: 'ERGENE' },
                { layer: 105, name: 'F18 Semboller', group: 'ERGENE' },
                { layer: 106, name: 'F18 Merkez İsimleri', group: 'ERGENE' },
                { layer: 107, name: 'F18 Semboller Saydamlı', group: 'ERGENE' },
                { layer: 108, name: 'F18 Köyler', group: 'ERGENE' },
                { layer: 110, name: 'F19 Alan Veri', group: 'ERGENE' },
                { layer: 111, name: 'F19 Üniversite MPYY', group: 'ERGENE' },
                { layer: 112, name: 'F19 OSB MPYY', group: 'ERGENE' },
                { layer: 113, name: 'F19 Taramalar', group: 'ERGENE' },
                { layer: 114, name: 'F19 Baraj İsim', group: 'ERGENE' },
                { layer: 116, name: 'F19 Havza Uzun', group: 'ERGENE' },
                { layer: 117, name: 'F19 Havza Mutlak', group: 'ERGENE' },
                { layer: 118, name: 'F19 Havza Kısa', group: 'ERGENE' },
                { layer: 119, name: 'F19 Havza Orta', group: 'ERGENE' },
                { layer: 120, name: 'F19 Çizgi Veri', group: 'ERGENE' },
                { layer: 121, name: 'F19 Çizgi Veri 2', group: 'ERGENE' },
                { layer: 122, name: 'F19 Semboller', group: 'ERGENE' },
                { layer: 123, name: 'F19 Semboller Saydamlı', group: 'ERGENE' },
                { layer: 124, name: 'F19 OSB Nokta MPYY', group: 'ERGENE' },
                { layer: 125, name: 'F19 Merkez İsimler', group: 'ERGENE' },
                { layer: 126, name: 'F19 Köyler', group: 'ERGENE' },
                { layer: 128, name: 'F20 Alan Veri', group: 'ERGENE' },
                { layer: 129, name: 'F20 Taramalar', group: 'ERGENE' },
                { layer: 130, name: 'F20 Baraj İsim', group: 'ERGENE' },
                { layer: 131, name: 'F20 Çizgi Veri', group: 'ERGENE' },
                { layer: 133, name: 'F20 Havza Orta', group: 'ERGENE' },
                { layer: 134, name: 'F20 Havza Mutlak', group: 'ERGENE' },
                { layer: 135, name: 'F20 Havza Kısa', group: 'ERGENE' },
                { layer: 136, name: 'F20 Havza Uzun', group: 'ERGENE' },
                { layer: 137, name: 'F20 Çizgi Veri 2', group: 'ERGENE' },
                { layer: 138, name: 'F20 Semboller', group: 'ERGENE' },
                { layer: 139, name: 'F20 Merkez İsimler', group: 'ERGENE' },
                { layer: 140, name: 'F20 Semboller Saydamlı', group: 'ERGENE' },
                { layer: 141, name: 'F20 Köyler', group: 'ERGENE' },
                { layer: 143, name: 'G16 Alan Veri', group: 'ERGENE' },
                { layer: 144, name: 'G16 Milli Parklar', group: 'ERGENE' },
                { layer: 145, name: 'G16 Taramalar', group: 'ERGENE' },
                { layer: 146, name: 'G16 Baraj İsim', group: 'ERGENE' },
                { layer: 147, name: 'G16 Çizgi Veri', group: 'ERGENE' },
                { layer: 148, name: 'G16 Semboller', group: 'ERGENE' },
                { layer: 149, name: 'G16 Merkez İsimler', group: 'ERGENE' },
                { layer: 150, name: 'G16 Semboller Saydamlı', group: 'ERGENE' },
                { layer: 151, name: 'G16 Köyler', group: 'ERGENE' },
                { layer: 153, name: 'G17 Alan Veri', group: 'ERGENE' },
                { layer: 154, name: 'G17 Taramalar', group: 'ERGENE' },
                { layer: 155, name: 'G17 Baraj İsim', group: 'ERGENE' },
                { layer: 156, name: 'G17 Çizgi Veri', group: 'ERGENE' },
                { layer: 158, name: 'G17 Havza Mutlak', group: 'ERGENE' },
                { layer: 159, name: 'G17 Havza Kısa', group: 'ERGENE' },
                { layer: 160, name: 'G17 Havza Orta', group: 'ERGENE' },
                { layer: 161, name: 'G17 Havza Uzun', group: 'ERGENE' },
                { layer: 162, name: 'G17 Semboller', group: 'ERGENE' },
                { layer: 163, name: 'G17 Merkez İsimler', group: 'ERGENE' },
                { layer: 164, name: 'G17 Semboller Saydamlı', group: 'ERGENE' },
                { layer: 165, name: 'G17 Köyler', group: 'ERGENE' },
                { layer: 167, name: 'G18 Alan Veri', group: 'ERGENE' },
                { layer: 168, name: 'G18 Taramalar', group: 'ERGENE' },
                { layer: 169, name: 'G18 Baraj İsim', group: 'ERGENE' },
                { layer: 170, name: 'G18 Çizgi Veri', group: 'ERGENE' },
                { layer: 172, name: 'G18 Havza Uzun', group: 'ERGENE' },
                { layer: 173, name: 'G18 Havza Mutlak', group: 'ERGENE' },
                { layer: 174, name: 'G18 Havza Kısa', group: 'ERGENE' },
                { layer: 175, name: 'G18 Havza Orta', group: 'ERGENE' },
                { layer: 176, name: 'G18 Çizgi Veri 2', group: 'ERGENE' },
                { layer: 177, name: 'G18 Semboller', group: 'ERGENE' },
                { layer: 178, name: 'G18 Merkez İsimler', group: 'ERGENE' },
                { layer: 179, name: 'G18 Semboller Saydamlı', group: 'ERGENE' },
                { layer: 180, name: 'G18 Köyler', group: 'ERGENE' },
                { layer: 182, name: 'G19 Alan Veri', group: 'ERGENE' },
                { layer: 183, name: 'G19 Taramalar', group: 'ERGENE' },
                { layer: 184, name: 'G19 Çizgi Veri', group: 'ERGENE' },
                { layer: 185, name: 'G19 Çizgi Veri 2', group: 'ERGENE' },
                { layer: 186, name: 'G19 Semboller', group: 'ERGENE' },
                { layer: 187, name: 'G19 Merkez İsimler', group: 'ERGENE' },
                { layer: 188, name: 'G19 Semboller 2', group: 'ERGENE' },
                { layer: 189, name: 'Plan Değişikliği Sınırı', group: 'ERGENE' },
                { layer: 190, name: 'Plan İndeksi', group: 'ERGENE' },
                { layer: 192, name: 'OSB MPYY', group: 'ERGENE' },
                { layer: 193, name: 'Plan Değişikliği Sınırı 2', group: 'ERGENE' },
                { layer: 194, name: 'OSB Nokta MPYY', group: 'ERGENE' }
            ]
        };

        // Cache for loaded region layers
        var regionLayersCache = {};
        var loadingPromises = {};

        // ============================================
        // SERVICE API
        // ============================================
        var service = {
            // Region management
            getRegions: getRegions,
            getRegionById: getRegionById,
            isLocationInRegion: isLocationInRegion,
            getRegionByProvinceCode: getRegionByProvinceCode,
            getRegionForLocation: getRegionForLocation,

            // Overlay generation for angular-leaflet-directive
            generateWmsOverlays: generateWmsOverlays,

            // Cache management (Service Worker based)
            clearWmsCache: clearWmsCache,
            getWmsCacheStats: getWmsCacheStats,

            // Translation utilities (for development)
            logMissingTranslations: logMissingTranslations
        };

        return service;

        // ============================================
        // REGION FUNCTIONS
        // ============================================

        /**
         * Get all available regions
         * @returns {Object} All region configurations
         */
        function getRegions() {
            return angular.copy(REGIONS);
        }

        /**
         * Get a specific region by ID
         * @param {string} regionId - Region identifier (e.g., 'amd')
         * @returns {Object|null} Region configuration or null if not found
         */
        function getRegionById(regionId) {
            var key = regionId.toUpperCase();
            return REGIONS[key] ? angular.copy(REGIONS[key]) : null;
        }

        /**
         * Check if a location is within a region's bounds
         * @param {number} lat - Latitude
         * @param {number} lng - Longitude
         * @param {string} regionId - Region identifier
         * @returns {boolean} True if location is within region bounds
         */
        function isLocationInRegion(lat, lng, regionId) {
            var region = getRegionById(regionId);
            if (!region) return false;

            var bounds = region.bounds;
            return lat >= bounds.southWest[0] && lat <= bounds.northEast[0] &&
                lng >= bounds.southWest[1] && lng <= bounds.northEast[1];
        }

        /**
         * Get region by province code
         * @param {number} provinceCode - Province code (e.g., 9 for Aydın)
         * @returns {Object|null} Region configuration or null if not found
         */
        function getRegionByProvinceCode(provinceCode) {
            for (var key in REGIONS) {
                var region = REGIONS[key];
                if (region.provinces && region.provinces.indexOf(provinceCode) !== -1) {
                    return angular.copy(region);
                }
            }
            return null;
        }

        /**
         * Get region for a specific location (lat/lng)
         * @param {number} lat - Latitude
         * @param {number} lng - Longitude
         * @returns {Object|null} Region configuration or null if location is not in any region
         */
        function getRegionForLocation(lat, lng) {
            for (var key in REGIONS) {
                if (isLocationInRegion(lat, lng, key.toLowerCase())) {
                    return getRegionById(key.toLowerCase());
                }
            }
            return null;
        }




        // ============================================
        // LAYER LOADING
        // ============================================

        /**
         * Load layers for a region from GetCapabilities
         * Falls back to static definitions if GetCapabilities fails
         * @param {string} regionId - Region identifier
         * @returns {Promise<Array>} Array of layer definitions
         */
        function loadRegionLayers(regionId) {
            var region = getRegionById(regionId);
            if (!region) {
                return $q.reject('Region not found: ' + regionId);
            }

            // Return cached layers if available
            if (regionLayersCache[regionId]) {
                return $q.resolve(regionLayersCache[regionId]);
            }

            // Return existing promise if already loading
            if (loadingPromises[regionId]) {
                return loadingPromises[regionId];
            }
            // Try GetCapabilities first
            // Note: skipAuthorization prevents interceptor from adding Authorization header (causes CORS issues)
            var capabilitiesUrl = region.wmsUrl + '?service=WMS&request=GetCapabilities';

            loadingPromises[regionId] = $http.get(capabilitiesUrl, {
                headers: { 'Accept': 'application/xml, text/xml' },
                withCredentials: false,
                skipAuthorization: true, // Custom flag to skip auth interceptor
                transformResponse: function (data) { return data; }
            }).then(function (response) {
                var layers = normalizeRegionLayers(parseCapabilities(response.data, region), regionId);
                regionLayersCache[regionId] = layers;
                delete loadingPromises[regionId];
                console.log('WMS Layer Service: Loaded', layers.length, 'layers from GetCapabilities');
                return layers;
            }).catch(function (error) {
                console.warn('WMS Layer Service: GetCapabilities failed, using static definitions', error);
                delete loadingPromises[regionId];
                // Fallback to static definitions
                return loadStaticLayers(regionId);
            });

            return loadingPromises[regionId];
        }

        /**
         * Load layers from static definitions (fallback)
         * @param {string} regionId - Region identifier
         * @returns {Promise<Array>} Array of layer definitions
         */
        function loadStaticLayers(regionId) {
            var layers = LAYER_DEFINITIONS[regionId];
            if (!layers) {
                return $q.reject('No layer definitions for region: ' + regionId);
            }

            var enrichedLayers = layers.map(function (layer) {
                return {
                    layer: layer.layer,
                    layers: layer.layers,
                    name: getTranslatedLayerName(layer.name),
                    group: layer.group,
                    regionId: regionId,
                    defaultVisible: false
                };
            });

            enrichedLayers = normalizeRegionLayers(enrichedLayers, regionId);
            regionLayersCache[regionId] = enrichedLayers;
            return $q.resolve(enrichedLayers);
        }

        function normalizeRegionLayers(layers, regionId) {
            if (regionId !== 'ysk') {
                return layers;
            }

            var administrativeCenterLayers = layers.filter(function (layer) {
                return layer.layer >= 43 && layer.layer <= 46;
            });

            if (administrativeCenterLayers.length <= 1) {
                return layers;
            }

            return layers.filter(function (layer) {
                return layer.layer < 43 || layer.layer > 46;
            }).concat({
                layer: 43,
                layers: '43,44,45,46',
                name: getTranslatedLayerName('İDARİ MERKEZLER'),
                group: administrativeCenterLayers[0].group,
                regionId: regionId,
                defaultVisible: false
            }).sort(function (a, b) {
                return a.layer - b.layer;
            });
        }

        // ============================================
        // XML PARSING (for GetCapabilities)
        // ============================================

        /**
         * Parse WMS GetCapabilities XML response
         * @param {string} xmlString - XML response
         * @param {Object} region - Region configuration
         * @returns {Array} Parsed layer definitions
         */
        function parseCapabilities(xmlString, region) {
            var layers = [];
            var parser = new DOMParser();
            var xmlDoc = parser.parseFromString(xmlString, 'text/xml');

            var rootLayer = xmlDoc.querySelector('Capability > Layer');
            if (!rootLayer) {
                console.warn('WMS Parser: No root layer found');
                return layers;
            }

            var groupLayers = getDirectChildLayers(rootLayer);

            groupLayers.forEach(function (groupLayer) {
                var groupTitle = getDirectChildText(groupLayer, 'Title');
                var groupName = getDirectChildText(groupLayer, 'Name');

                if (groupName) {
                    var layerNumber = parseInt(groupName, 10);
                    if (!isNaN(layerNumber)) {
                        layers.push({
                            layer: layerNumber,
                            name: getTranslatedLayerName(groupTitle),
                            group: null,
                            regionId: region.id,
                            defaultVisible: false
                        });
                    }
                    return;
                }

                extractLayersFromGroup(groupLayer, groupTitle, region, layers);
            });

            layers.sort(function (a, b) {
                return a.layer - b.layer;
            });

            return layers;
        }

        function extractLayersFromGroup(groupEl, mainGroupTitle, region, layers) {
            var childLayers = getDirectChildLayers(groupEl);

            childLayers.forEach(function (childLayer) {
                var layerName = getDirectChildText(childLayer, 'Name');
                var layerTitle = getDirectChildText(childLayer, 'Title');

                if (layerName) {
                    var layerNumber = parseInt(layerName, 10);
                    if (!isNaN(layerNumber)) {
                        layers.push({
                            layer: layerNumber,
                            name: getTranslatedLayerName(layerTitle),
                            group: mainGroupTitle,
                            regionId: region.id,
                            defaultVisible: false
                        });
                    }
                } else {
                    extractLayersFromGroup(childLayer, mainGroupTitle, region, layers);
                }
            });
        }

        function getDirectChildLayers(parentEl) {
            var layers = [];
            for (var i = 0; i < parentEl.children.length; i++) {
                if (parentEl.children[i].tagName === 'Layer') {
                    layers.push(parentEl.children[i]);
                }
            }
            return layers;
        }

        /**
         * Capitalize first letter of each word
         * @param {string} str - Input string
         * @returns {string} String with capitalized first letters
         */
        function capitalizeWords(str) {
            if (!str) return str;

            var hasLowercase = /[a-zğüşıöçi]/.test(str);
            var normalized = str.replace(/_/g, ' ');
            normalized = hasLowercase ? normalized : normalized.toLocaleLowerCase('tr-TR');

            var title = normalized.replace(/(^|[\s/-])([^\s/-])/g, function (match, separator, char) {
                return separator + char.toLocaleUpperCase('tr-TR');
            });

            return title
                .replace(/\bDsi\b/g, 'DSİ')
                .replace(/\bOsb\b/g, 'OSB')
                .replace(/\bKss\b/g, 'KSS')
                .replace(/\bTgb\b/g, 'TGB')
                .replace(/\bMpyy\b/g, 'MPYY')
                .replace(/\bMia\b/g, 'MİA')
                .replace(/\bOha\b/g, 'OHA');
        }

        /**
         * Convert layer name to translation key
         * @param {string} layerName - Layer name from WMS (e.g., "TARIM_FON", "AkarsuCizgi")
         * @returns {string} Translation key (e.g., "wms_tarim_fon", "wms_akarsu_cizgi")
         */
        function layerNameToTranslationKey(layerName) {
            if (!layerName) return '';

            return 'wms_' + layerName
                .toLowerCase()
                .replace(/\s+/g, '_')           // Replace spaces with underscore
                .replace(/i̇/g, 'i')              // Turkish İ lowercase (i + combining dot above) → i
                .replace(/ğ/g, 'g')              // Turkish character normalization
                .replace(/ü/g, 'u')
                .replace(/ş/g, 's')
                .replace(/ı/g, 'i')
                .replace(/ö/g, 'o')
                .replace(/ç/g, 'c')
                .replace(/[()/]/g, '')           // Remove parentheses and slashes
                .replace(/_+/g, '_')             // Replace multiple underscores with single
                .replace(/^_|_$/g, '');          // Trim underscores from start/end
        }

        function groupNameToTranslationKey(groupName) {
            return layerNameToTranslationKey(groupName).replace(/^wms_/, 'wms_group_');
        }

        function trackMissingTranslation(translationKey, fallbackName, type) {
            if (!window.wmsMissingTranslations) {
                window.wmsMissingTranslations = {};
            }

            window.wmsMissingTranslations[translationKey] = capitalizeWords(fallbackName);
            console.warn('[WMS] Missing translation for ' + type + ':', fallbackName, '- key:', translationKey);
        }

        /**
         * Get translated layer name with fallback to capitalized original
         * @param {string} layerName - Original layer name from WMS
         * @returns {string} Translated name or capitalized original
         */
        function getTranslatedLayerName(layerName) {
            if (!layerName) return layerName;

            var translationKey = layerNameToTranslationKey(layerName);
            var translated = $translate.instant(translationKey);

            // If translation not found (returns the key itself), use capitalized original
            if (translated === translationKey) {
                trackMissingTranslation(translationKey, layerName, 'layer');
                return capitalizeWords(layerName);
            }

            return translated;
        }

        function getTranslatedGroupName(groupName, groupTranslations, mainGroupName) {
            if (!groupName) {
                return mainGroupName;
            }

            if (Object.prototype.hasOwnProperty.call(groupTranslations, groupName)) {
                var mappedTranslation = groupTranslations[groupName];
                if (/^wms_/.test(mappedTranslation)) {
                    trackMissingTranslation(mappedTranslation, groupName, 'group');
                    return capitalizeWords(groupName);
                }

                return mappedTranslation;
            }

            var translationKey = groupNameToTranslationKey(groupName);
            var translated = $translate.instant(translationKey);

            if (translated === translationKey) {
                trackMissingTranslation(translationKey, groupName, 'group');
                return capitalizeWords(groupName);
            }

            return translated;
        }

        /**
         * Log missing WMS translations in JSON format for easy copy-paste
         * Call this after layers are loaded: wmsLayerService.logMissingTranslations()
         */
        function logMissingTranslations() {
            if (!window.wmsMissingTranslations || Object.keys(window.wmsMissingTranslations).length === 0) {
                console.log('[WMS] No missing translations found!');
                return;
            }

            console.log('[WMS] Missing translations (copy to locale files):');
            console.log(JSON.stringify(window.wmsMissingTranslations, null, 2));
        }

        function getDirectChildText(parentEl, tagName) {
            for (var i = 0; i < parentEl.children.length; i++) {
                if (parentEl.children[i].tagName === tagName) {
                    return parentEl.children[i].textContent.trim();
                }
            }
            return null;
        }

        // ============================================
        // OVERLAY GENERATION
        // ============================================

        /**
         * Generate WMS overlays for angular-leaflet-directive
         * Uses static layer definitions (CORS prevents GetCapabilities)
         *
         * @param {string} regionId - Region identifier (e.g., 'amd')
         * @returns {Promise<Object>} Overlay configurations for angular-leaflet-directive
         */
        function generateWmsOverlays(regionId) {
            var region = getRegionById(regionId);
            if (!region) {
                console.warn('WMS Layer Service: Region not found:', regionId);
                return $q.resolve({});
            }

            return loadRegionLayers(regionId).then(function (layers) {
                return generateOverlaysFromLayers(region, layers);
            }).catch(function (error) {
                console.error('WMS Layer Service: Failed to generate overlays:', error);
                return {};
            });
        }

        /**
         * Generate overlay configurations from layer definitions
         * Groups layers by their WMS group (PL_ALAN, PL_CİZGİ, PL_NOKTA)
         * @param {Object} region - Region configuration
         * @param {Array} layers - Layer definitions with group info
         * @returns {Object} Overlay configurations sorted by group
         */
        function generateOverlaysFromLayers(region, layers) {
            var mainGroupName = $translate.instant('wms_group_regional_planning');

            // Translation mapping for WMS group names
            var groupTranslations = {
                // AMD Region groups
                'PL_ALAN': $translate.instant('wms_group_pl_alan'),
                'PL_CİZGİ': $translate.instant('wms_group_pl_cizgi'),
                'PL_CIZGI': $translate.instant('wms_group_pl_cizgi'),
                'PL_NOKTA': $translate.instant('wms_group_pl_nokta'),
                // ABI Region groups - Antalya
                'ANTALYA': $translate.instant('wms_group_antalya'),
                'ANTALYA_ULASIM': $translate.instant('wms_group_antalya_ulasim'),
                'ANTALYA_KORUMA': $translate.instant('wms_group_antalya_koruma'),
                'ANTALYA_PLANLAMA': $translate.instant('wms_group_antalya_planlama'),
                'ANTALYA_IDARI': $translate.instant('wms_group_antalya_idari'),
                // ABI Region groups - Burdur-Isparta (static definitions use underscores)
                'BURDUR_ISPARTA_ALANSAL': $translate.instant('wms_group_burdur_isparta_alansal'),
                'BURDUR_ISPARTA_SINIRLAR': $translate.instant('wms_group_burdur_isparta_sinirlar'),
                'BURDUR_ISPARTA_CIZGISEL': $translate.instant('wms_group_burdur_isparta_cizgisel'),
                'BURDUR_ISPARTA_NOKTASAL': $translate.instant('wms_group_burdur_isparta_noktasal'),
                // ABI Region groups - from GetCapabilities XML (uses hyphens)
                'BURDUR-ISPARTA': $translate.instant('BURDUR-ISPARTA'),
                // CB Region groups - Balıkesir-Çanakkale
                'CB_ALANSAL': $translate.instant('wms_group_cb_alansal'),
                'CB_CIZGISEL': $translate.instant('wms_group_cb_cizgisel'),
                'CB_SINIRLAR': $translate.instant('wms_group_cb_sinirlar'),
                'CB_NOKTASAL': $translate.instant('wms_group_cb_noktasal'),
                // MA Region groups - Mersin-Adana
                'MA_ADANA_ALANSAL': $translate.instant('wms_group_ma_adana_alansal'),
                'MA_ADANA_SINIRLAR': $translate.instant('wms_group_ma_adana_sinirlar'),
                'MA_ADANA_CIZGISEL': $translate.instant('wms_group_ma_adana_cizgisel'),
                'MA_ADANA_NOKTASAL': $translate.instant('wms_group_ma_adana_noktasal'),
                'MA_MERSIN_ALANSAL': $translate.instant('wms_group_ma_mersin_alansal'),
                'MA_MERSIN_SINIRLAR': $translate.instant('wms_group_ma_mersin_sinirlar'),
                'MA_MERSIN_CIZGISEL': $translate.instant('wms_group_ma_mersin_cizgisel'),
                'MA_MERSIN_NOKTASAL': $translate.instant('wms_group_ma_mersin_noktasal'),
                // ASD Region groups - Adıyaman-Şanlıurfa-Diyarbakır
                'ASD_ALANSAL': $translate.instant('wms_group_asd_alansal'),
                'ASD_CIZGISEL': $translate.instant('wms_group_asd_cizgisel'),
                'ASD_NOKTASAL': $translate.instant('wms_group_asd_noktasal'),
                'ASD_IDARI': $translate.instant('wms_group_asd_idari'),
                'Diyarbakır_2OSB': $translate.instant('wms_group_diyarbakir_2osb'),
                // AKIA Region groups - Ağrı-Kars-Iğdır-Ardahan
                'AKIA_ALANSAL': $translate.instant('wms_group_akia_alansal'),
                'AKIA_CIZGISEL': $translate.instant('wms_group_akia_cizgisel'),
                'AKIA_NOKTASAL': $translate.instant('wms_group_akia_noktasal'),
                'AKIA_IDARI': $translate.instant('wms_group_akia_idari'),
                // KNNA Region groups - Aksaray-Kırşehir-Nevşehir-Niğde
                'KNNA_ALANSAL': $translate.instant('wms_group_knna_alansal'),
                'KNNA_KORUMA': $translate.instant('wms_group_knna_koruma'),
                'KNNA_CIZGISEL': $translate.instant('wms_group_knna_cizgisel'),
                'KNNA_NOKTASAL': $translate.instant('wms_group_knna_noktasal'),
                'KNNA_IDARI': $translate.instant('wms_group_knna_idari'),
                // AMASYA Region groups - Amasya
                'AMASYA_ALANSAL': $translate.instant('wms_group_amasya_alansal'),
                'AMASYA_KORUMA': $translate.instant('wms_group_amasya_koruma'),
                'AMASYA_CIZGISEL': $translate.instant('wms_group_amasya_cizgisel'),
                'AMASYA_NOKTASAL': $translate.instant('wms_group_amasya_noktasal'),
                // OTRGGA Region groups - Artvin-Giresun-Gümüşhane-Ordu-Rize-Trabzon
                'OTRGGA_ALANSAL': $translate.instant('wms_group_otrgga_alansal'),
                'OTRGGA_CIZGISEL': $translate.instant('wms_group_otrgga_cizgisel'),
                'OTRGGA_NOKTASAL': $translate.instant('wms_group_otrgga_noktasal'),
                // ZBK Region groups - Karabük-Zonguldak
                'ZBK_ALANSAL': $translate.instant('wms_group_zbk_alansal'),
                'ZBK_CIZGISEL': $translate.instant('wms_group_zbk_cizgisel'),
                'ZBK_NOKTASAL': $translate.instant('wms_group_zbk_noktasal'),
                // MBSSH Region groups - Batman-Hakkari-Mardin-Siirt-Şırnak
                'MBSSH_ALANSAL': $translate.instant('wms_group_mbssh_alansal'),
                'MBSSH_CIZGISEL': $translate.instant('wms_group_mbssh_cizgisel'),
                'MBSSH_NOKTASAL': $translate.instant('wms_group_mbssh_noktasal'),
                'MBSSH_MPYY': $translate.instant('wms_group_mbssh_mpyy'),
                'MBSSH_DEGISIKLIK': $translate.instant('wms_group_mbssh_degisiklik'),
                // MBSSH Plan change groups with dates
                'Siirt_Degisiklik_09092020': $translate.instant('wms_group_siirt_degisiklik_09092020'),
                'Sirnak_Degisiklik_04092020': $translate.instant('wms_group_sirnak_degisiklik_04092020'),
                'Mardin_Degisiklik_28022019': $translate.instant('wms_group_mardin_degisiklik_28022019'),
                // EEB Region groups - Bayburt-Erzurum-Erzincan
                'EEB_ALANSAL': $translate.instant('wms_group_eeb_alansal'),
                'EEB_CIZGISEL': $translate.instant('wms_group_eeb_cizgisel'),
                'EEB_NOKTASAL': $translate.instant('wms_group_eeb_noktasal'),
                'EEB_IDARI': $translate.instant('wms_group_eeb_idari'),
                // BILECIK Region groups
                'BILECIK_ALANSAL': $translate.instant('wms_group_bilecik_alansal'),
                'BILECIK_CIZGISEL': $translate.instant('wms_group_bilecik_cizgisel'),
                'BILECIK_NOKTASAL': $translate.instant('wms_group_bilecik_noktasal'),
                // MBV Region groups - Bitlis-Muş-Van
                'MBV_ALANSAL': $translate.instant('wms_group_mbv_alansal'),
                'MBV_CIZGISEL': $translate.instant('wms_group_mbv_cizgisel'),
                'MBV_NOKTASAL': $translate.instant('wms_group_mbv_noktasal'),
                // BOLU Region groups
                'BOLU_RASTER': $translate.instant('wms_group_bolu_raster'),
                // SCT Region groups
                'SCT_ALANSAL': $translate.instant('wms_group_sct_alansal'),
                'SCT_CIZGISEL': $translate.instant('wms_group_sct_cizgisel'),
                'SCT_NOKTASAL': $translate.instant('wms_group_sct_noktasal'),
                // IM Region groups (İzmir-Manisa)
                'IM_ALANSAL': $translate.instant('wms_group_im_alansal'),
                'IM_CIZGISEL': $translate.instant('wms_group_im_cizgisel'),
                'IM_SINIRLAR': $translate.instant('wms_group_im_sinirlar'),
                'IM_NOKTASAL': $translate.instant('wms_group_im_noktasal'),
                // KK Region groups (Karaman-Konya)
                'KK_ALANSAL': $translate.instant('wms_group_kk_alansal'),
                'KK_CIZGISEL': $translate.instant('wms_group_kk_cizgisel'),
                'KK_SINIRLAR': $translate.instant('wms_group_kk_sinirlar'),
                'KK_NOKTASAL': $translate.instant('wms_group_kk_noktasal'),
                // YSK Region groups (Kayseri-Sivas-Yozgat)
                'YSK_ALANSAL': $translate.instant('wms_group_ysk_alansal'),
                'YSK_CIZGISEL': $translate.instant('wms_group_ysk_cizgisel'),
                'YSK_SINIRLAR': $translate.instant('wms_group_ysk_sinirlar'),
                'YSK_NOKTASAL': $translate.instant('wms_group_ysk_noktasal'),
                // KILIS Region groups
                'KILIS_ALANSAL': $translate.instant('wms_group_kilis_alansal'),
                'KILIS_CIZGISEL': $translate.instant('wms_group_kilis_cizgisel'),
                'KILIS_SINIRLAR': $translate.instant('wms_group_kilis_sinirlar'),
                'KILIS_NOKTASAL': $translate.instant('wms_group_kilis_noktasal'),
                // KIRIKKALE Region groups
                'KIRIKKALE_ALANSAL': $translate.instant('wms_group_kirikkale_alansal'),
                'KIRIKKALE_CIZGISEL': $translate.instant('wms_group_kirikkale_cizgisel'),
                'KIRIKKALE_SINIRLAR': $translate.instant('wms_group_kirikkale_sinirlar'),
                'KIRIKKALE_NOKTASAL': $translate.instant('wms_group_kirikkale_noktasal'),
                // OSMANIYE Region groups
                'OSMANIYE_ALANSAL': $translate.instant('wms_group_osmaniye_alansal'),
                'OSMANIYE_CIZGISEL': $translate.instant('wms_group_osmaniye_cizgisel'),
                'OSMANIYE_SINIRLAR': $translate.instant('wms_group_osmaniye_sinirlar'),
                'OSMANIYE_NOKTASAL': $translate.instant('wms_group_osmaniye_noktasal'),
                // SINOP Region groups
                'SINOP_ALANSAL': $translate.instant('wms_group_sinop_alansal'),
                'SINOP_CIZGISEL': $translate.instant('wms_group_sinop_cizgisel'),
                'SINOP_SINIRLAR': $translate.instant('wms_group_sinop_sinirlar'),
                'SINOP_NOKTASAL': $translate.instant('wms_group_sinop_noktasal'),
                // USAK Region groups
                'USAK_ALANSAL': $translate.instant('wms_group_usak_alansal'),
                'USAK_CIZGISEL': $translate.instant('wms_group_usak_cizgisel'),
                'USAK_SINIRLAR': $translate.instant('wms_group_usak_sinirlar'),
                'USAK_NOKTASAL': $translate.instant('wms_group_usak_noktasal'),
                // YALOVA Region groups
                'YALOVA_ALANSAL': $translate.instant('wms_group_yalova_alansal'),
                'YALOVA_CIZGISEL': $translate.instant('wms_group_yalova_cizgisel'),
                'YALOVA_SINIRLAR': $translate.instant('wms_group_yalova_sinirlar'),
                'YALOVA_NOKTASAL': $translate.instant('wms_group_yalova_noktasal'),
                // SKC Region groups - Sinop-Kastamonu-Çankırı
                'SKC_ALANSAL': $translate.instant('wms_group_skc_alansal'),
                'SKC_CIZGISEL': $translate.instant('wms_group_skc_cizgisel'),
                'SKC_NOKTASAL': $translate.instant('wms_group_skc_noktasal'),
                // ERGENE Region groups - Ergene Havzası
                'ERGENE': $translate.instant('wms_group_ergene'),
                // Generic WMS groups
                'PLAN': $translate.instant('wms_group_plan'),
                'ENERJI_URETIM_ALANI': $translate.instant('wms_enerji_uretim_alani'),
                'ENERJİ ÜRETİM ALANI': $translate.instant('wms_enerji_uretim_alani'),
                'milletbahcesi': $translate.instant('wms_milletbahcesi'),
                'milletbahcesin': $translate.instant('wms_milletbahcesin'),
                // Dynamic WMS groups
                'Plan_nokta': $translate.instant('wms_group_plan_nokta'),
                'New Group Layer': $translate.instant('wms_group_sct_main')
            };

            // Group layers by their WMS group for proper ordering
            var groupedLayers = {};
            var groupOrder = [];

            layers.forEach(function (layerDef) {
                var groupKey = layerDef.group || 'default';
                if (!groupedLayers[groupKey]) {
                    groupedLayers[groupKey] = [];
                    groupOrder.push(groupKey);
                }
                groupedLayers[groupKey].push(layerDef);
            });

            // Build overlays in group order (maintains adjacency for same groups)
            var overlays = {};

            // Index determines layer order in layer control (higher index = appears first due to descending sort)
            // Order from top to bottom: Ungrouped (900+) → Ticari (700s) → Konut (500s) → WMS (200-399) → Diğer (100s)
            // WMS layers should appear between Konut and Diğer groups
            var baseIndex = 200;
            var currentIndex = baseIndex;

            groupOrder.forEach(function (groupKey) {
                var groupLayers = groupedLayers[groupKey];

                // Sort layers within group by layer number
                groupLayers.sort(function (a, b) {
                    return a.layer - b.layer;
                });

                groupLayers.forEach(function (layerDef) {
                    // Use padded layer number for proper alphabetical sorting
                    var overlayKey = 'wms_' + region.id + '_' + String(layerDef.layer).padStart(3, '0');

                    // Use translated group name directly (section title handles main category)
                    // Group names like "Alan", "Çizgi", "Nokta" etc.
                    var groupName = getTranslatedGroupName(layerDef.group, groupTranslations, mainGroupName);

                    overlays[overlayKey] = {
                        name: layerDef.name,
                        url: region.wmsUrl,
                        type: 'wms',
                        visible: layerDef.defaultVisible,
                        // Index ensures WMS layers are sorted after all other layers
                        // and maintains group adjacency for proper grouping in layer control
                        index: currentIndex++,
                        layerOptions: {
                            service: 'WMS',
                            request: 'GetMap',
                            layers: (layerDef.layers || layerDef.layer).toString(),
                            format: 'image/png',
                            transparent: true,
                            tiled: true,
                            bounds: [region.bounds.southWest, region.bounds.northEast],
                            continuousWorld: true,
                            attribution: '&copy; ' + $translate.instant('wms_attribution_csb'),
                            maxZoom: 22,
                            minZoom: 7,
                            opacity: 0.8,
                            updateWhenIdle: true,
                            updateWhenZooming: false,
                            updateInterval: 500,
                            keepBuffer: 0
                        },
                        group: groupName
                    };
                });
            });

            return overlays;
        }

        // ============================================
        // CACHE MANAGEMENT (Service Worker)
        // ============================================

        /**
         * Clear WMS tile cache via Service Worker
         * Use this to force refresh of regional planning data
         * @returns {Promise} Resolves when cache is cleared
         */
        function clearWmsCache() {
            if (!navigator.serviceWorker || !navigator.serviceWorker.controller) {
                console.warn('WMS Layer Service: Service Worker not available');
                return $q.reject('Service Worker not available');
            }

            var deferred = $q.defer();
            var messageChannel = new MessageChannel();
            var timeoutId;

            messageChannel.port1.onmessage = function (event) {
                clearTimeout(timeoutId);
                if (event.data && event.data.type === 'WMS_CACHE_CLEARED') {
                    deferred.resolve();
                } else {
                    deferred.reject('Unexpected response');
                }
            };

            navigator.serviceWorker.controller.postMessage(
                { type: 'CLEAR_WMS_CACHE' },
                [messageChannel.port2]
            );

            // Timeout after 5 seconds
            timeoutId = setTimeout(function () {
                deferred.reject('Timeout waiting for cache clear');
            }, 5000);

            return deferred.promise;
        }

        /**
         * Get WMS cache statistics from Service Worker
         * @returns {Promise<Object>} Cache stats { tileCount, maxEntries, usagePercentage, estimatedSizeMB, urls }
         */
        function getWmsCacheStats() {
            if (!navigator.serviceWorker || !navigator.serviceWorker.controller) {
                console.warn('WMS Layer Service: Service Worker not available');
                return $q.resolve({
                    tileCount: 0,
                    maxEntries: 0,
                    usagePercentage: 0,
                    estimatedSizeMB: 0,
                    urls: []
                });
            }

            var deferred = $q.defer();
            var messageChannel = new MessageChannel();

            messageChannel.port1.onmessage = function (event) {
                if (event.data && event.data.type === 'WMS_CACHE_STATS') {
                    var stats = {
                        tileCount: event.data.tileCount,
                        maxEntries: event.data.maxEntries,
                        usagePercentage: event.data.usagePercentage,
                        estimatedSizeMB: event.data.estimatedSizeMB,
                        urls: event.data.urls
                    };

                    // Log stats for easy debugging
                    console.log('[WMS Cache] Stats:', stats.tileCount + '/' + stats.maxEntries + ' tiles (' +
                        stats.usagePercentage + '%), ~' + stats.estimatedSizeMB + ' MB');

                    deferred.resolve(stats);
                } else {
                    deferred.resolve({
                        tileCount: 0,
                        maxEntries: 0,
                        usagePercentage: 0,
                        estimatedSizeMB: 0,
                        urls: []
                    });
                }
            };

            navigator.serviceWorker.controller.postMessage(
                { type: 'GET_WMS_CACHE_STATS' },
                [messageChannel.port2]
            );

            // Timeout after 3 seconds
            setTimeout(function () {
                deferred.resolve({
                    tileCount: 0,
                    maxEntries: 0,
                    usagePercentage: 0,
                    estimatedSizeMB: 0,
                    urls: []
                });
            }, 3000);

            return deferred.promise;
        }
    }
})();
